const en = {
  _name: 'English',
  _flag: '🇬🇧',

  // ── Navigation sections ──
  'nav.businessMonitor': 'Business Monitor',
  'nav.dashboard': 'Dashboard',
  'nav.clients': 'Clients',
  'nav.communication': 'Communication',
  'nav.staff': 'Staff',
  'nav.inventory': 'Inventory',
  'nav.salary': 'Payroll',
  'nav.finances': 'Finances',
  'nav.system': 'System',
  'nav.integrations': 'Integrations',
  'nav.sales': 'Sales',

  // ── Navigation items ──
  'nav.pos': 'Shop',
  'nav.salesProducts': 'Warehouse Dispatch',
  'nav.salesServices': 'Book Services',
  'nav.clientsBase': 'Client Base',
  'nav.categories': 'Client Categories',
  'nav.messages': 'Messages',
  'nav.employees': 'Employees',
  'nav.schedule': 'Work Schedule',
  'nav.scheduleTemplates': 'Schedule Templates',
  'nav.services': 'Services',
  'nav.tariffPlans': 'Tariff Plans',
  'nav.products': 'Products',
  'nav.stock': 'Stock',
  'nav.purchases': 'Purchases',
  'nav.movements': 'Stock Movements',
  'nav.orders': 'Orders',
  'nav.salaryCalc': 'Calculation',
  'nav.salarySchemes': 'Motivation Schemes',
  'nav.financialOps': 'Financial Operations',
  'nav.cashRegister': 'Cash Register',
  'nav.reports': 'Reports',
  'nav.financialResult': 'Financial Result',
  'nav.users': 'Users',
  'nav.roles': 'Roles',
  'nav.checkbox': 'Checkbox POS',
  'nav.telegram': 'Telegram Reminders',
  'nav.sms': 'SMS Mailing',
  'nav.email': 'Email Mailing',
  'nav.novaPoshta': 'Nova Poshta',
  'nav.meestExpress': 'Meest Express',
  'nav.olx': 'OLX',
  'olx.tagline': 'Listing chat messages + catalog sync',
  'olx.connected': 'Connected',
  'olx.notConnected': 'Not connected',
  'olx.connectIntro': 'Connect your OLX account via OAuth to receive listing messages in CRM and publish products as listings.',
  'olx.connectBtn': 'Connect OLX',
  'olx.tabOpened': 'OLX opened in a new tab. Authorize and return here.',
  'olx.connectFailed': 'Connection failed:',
  'olx.connectedToast': 'OLX connected',
  'olx.confirmDisconnect': 'Disconnect OLX integration?',
  'olx.disconnected': 'OLX disconnected',
  'olx.disconnectBtn': 'Disconnect',
  'olx.testBtn': 'Test connection',
  'olx.testOk': 'Connected as: {name} (ID {id})',
  'olx.testFailed': 'Test failed',
  'olx.accountId': 'OLX ID',
  'olx.scope': 'Scopes',
  'olx.connectedAt': 'Connected at',
  'olx.reconnectRequired': 'Re-authorization required',
  'olx.reconnectExplain': 'OLX revoked our tokens (typically after 30 days of inactivity or a password change). Click "Connect OLX" to resume receiving messages.',
  'olx.refreshBtn': 'Check for new messages',
  'olx.refreshFound': 'Fetched {n} new messages — see Communications',
  'olx.refreshNoNew': 'No new messages',
  'olx.refreshFailed': 'Refresh failed',
  'comm.olxThreadMissing': 'Could not determine OLX thread',
  'olx.howItWorks': 'How it works',
  'olx.step1': 'Click "Connect OLX" — OLX authorization opens in a new tab.',
  'olx.step2': 'Log into your OLX account and grant the app access.',
  'olx.step3': 'Return here — status will refresh automatically; verify with "Test connection".',
  'olx.capabilities': 'What the integration unlocks',
  'olx.capInboxTitle': 'Listing chats — inside the CRM',
  'olx.capInboxText': 'Every buyer message on your OLX listings shows up in Sidebar → Communication. Polled every 10 min; use "Check for new messages" above to fetch immediately.',
  'olx.capOutboundTitle': 'Reply from CRM straight into the OLX chat',
  'olx.capOutboundText': 'Open a thread in Communication, pick the OLX channel — your text lands in the buyer\'s OLX chat as if you wrote it on olx.ua itself.',
  'olx.capPublishTitle': 'Publish products as OLX listings',
  'olx.capPublishText': 'Sidebar → Inventory → open a product → "Publish on OLX". Title, description, price and photo are pre-filled from the product card — pick category, city and contact, and the listing is sent to OLX moderation.',
  'olx.limitations': 'Limitations',
  'olx.limitationsText': 'OLX Delivery orders aren\'t exposed through the partner API yet. Handle those in the olx.ua interface for now.',

  // ─── Instagram
  // Англійська тут не косметика: Meta вимагає English UI у скринкасті для
  // App Review, і саме ця сторінка на ньому в кадрі. Без перекладу вона
  // відкочувалась на українську через фолбек у I18nContext, і рецензент
  // бачив текст, якого не читає.
  'nav.instagram': 'Instagram',
  'instagram.tagline': 'Instagram Direct messages from your Business account — inside the CRM',
  'instagram.connected': 'Connected',
  'instagram.notConnected': 'Not connected',
  'instagram.connectIntro': 'Connect an Instagram Business account via OAuth to receive Direct messages from your customers straight in the CRM.',
  'instagram.connectBtn': 'Connect Instagram',
  'instagram.tabOpened': 'Instagram opened in a new tab. Sign in there and come back here.',
  'instagram.connectFailed': 'Connection failed:',
  'instagram.confirmDisconnect': 'Disconnect the Instagram integration?',
  'instagram.disconnected': 'Instagram disconnected',
  'instagram.disconnectBtn': 'Disconnect',
  'instagram.testBtn': 'Test connection',
  'instagram.testOk': 'Connection works:',
  'instagram.testFailed': 'Test failed',
  'instagram.account': 'Account',
  'instagram.userId': 'IG User ID',
  'instagram.scope': 'Permissions',
  'instagram.connectedAt': 'Connected',
  'instagram.expiresAt': 'Valid until',
  'instagram.reconnectRequired': 'Re-authorisation required',
  'instagram.reconnectExplain': 'The long-lived token could not be refreshed (usually after 60+ days of inactivity or an Instagram password change). Click "Connect Instagram" to keep receiving messages.',
  'instagram.howItWorks': 'How it works',
  'instagram.step1': 'Click "Connect Instagram" — the Instagram authorisation opens in a new tab.',
  'instagram.step2': 'Sign in to your Instagram Business account (a Professional account linked to a Facebook Page) and grant the app access to Direct.',
  'instagram.step3': 'Come back to this tab — the status updates automatically; confirm with "Test connection".',
  'instagram.capabilities': 'What you get',
  'instagram.capInboxTitle': 'Direct messages in the CRM',
  'instagram.capInboxText': 'Every Instagram Direct message arrives in Sidebar -> Communication, in real time via Meta webhooks, next to Telegram, SMS and email.',
  'instagram.capOutboundTitle': 'Reply from the CRM straight to Instagram',
  'instagram.capOutboundText': 'Open the conversation in Communication and pick the "Instagram" channel - your reply is delivered to the customer Direct inbox.',
  'instagram.limitations': 'Limitations',
  'instagram.limitationsText': 'Works only with an Instagram Professional account (Business or Creator) linked to a Facebook Page. Meta does not support personal Instagram accounts in the Messaging API.',
  'nav.locations': 'Locations',
  'nav.myPlan': 'My Plan',
  'nav.onlineBooking': 'Online Booking',
  'nav.help': 'Help',
  'booking.title': 'Online Booking',
  'booking.subtitle': 'Configure the public booking page for your customers',
  'booking.enable': 'Enable online booking',
  'booking.yourLink': 'Your link',
  'booking.copy': 'Copy',
  'booking.urlCopied': 'Link copied',
  'booking.linkHint': 'Share this link with your customers — on Instagram, Telegram, your website',
  'booking.businessInfo': 'Business info',
  'booking.businessName': 'Business name',
  'booking.businessNameHint': 'How customers will see you',
  'booking.slug': 'URL identifier',
  'booking.slugHint': 'Latin letters, numbers, hyphens. E.g.: my-salon',
  'booking.description': 'Description',
  'booking.descriptionHint': 'Brief description of your business',
  'booking.themeColor': 'Theme color',
  'booking.locale': 'Page language',
  'booking.rules': 'Booking rules',
  'booking.minHours': 'Minimum notice',
  'booking.hours': 'hours',
  'booking.minHoursHint': 'How many hours before an appointment can be booked',
  'booking.maxDays': 'Max depth',
  'booking.days': 'days',
  'booking.maxDaysHint': 'How many days ahead booking is available',
  'booking.allowedServices': 'Services for online booking',
  'booking.allowedServicesHint': 'Select services available for online booking. If none selected — all are available.',
  'booking.allowedStaff': 'Staff for online booking',
  'booking.allowedStaffHint': 'Select staff available for online booking. If none selected — all are available.',
  'booking.selectAll': 'Select all',
  'booking.deselectAll': 'Deselect all',
  'booking.tabGeneral': 'General',
  'booking.tabServices': 'Services',
  'booking.tabProducts': 'Products',
  'booking.tabAfter': 'After booking',
  'booking.serviceCategories': 'Service categories',
  'booking.serviceCategoriesHint': 'Select categories for online booking. If none selected — all are available.',
  'booking.productCategories': 'Product categories',
  'booking.productCategoriesHint': 'Select categories for online sales. If none selected — all are available.',
  'booking.noCategoriesYet': 'No categories yet. Create them in the corresponding section.',
  'booking.mode': 'Operating mode',
  'booking.modeServices': 'Services',
  'booking.modeShop': 'Shop',
  'booking.modeBoth': 'Both',
  'booking.modeHint': 'Services — appointment booking. Shop — online product ordering. Both — services and products.',
  'booking.shopSettings': 'Shop settings',
  'booking.shopMinOrder': 'Min order amount',
  'booking.shopShowOutOfStock': 'Out of stock items',
  'booking.shopShowOutOfStockLabel': 'Show products with zero stock',
  'booking.shopDelivery': 'Delivery methods',
  'booking.deliveryPickup': 'Pickup',
  'booking.deliveryNP': 'Nova Poshta',
  'booking.deliveryMeest': 'Meest Express',
  'booking.deliveryCourier': 'Courier',
  'booking.gallery': 'Gallery',
  'booking.galleryHint': 'Photos of work, interior, products — up to 10 images',
  'booking.galleryCount': 'photos',
  'booking.promo': 'Promo banner',
  'booking.promoEnable': 'Show promo banner',
  'booking.promoText': 'Promo text',
  'booking.promoPlaceholder': 'e.g. 20% off your first visit',
  'booking.chat': 'Website chat',
  'booking.tariffServices': 'Tariff plan',
  'booking.tariffProducts': 'Tariff plan',
  'booking.tariffHint': 'Applied to shop prices. Customers see discounted prices; orders/bookings in CRM are tagged with the selected plan.',
  'booking.tariffNone': '— no discount —',
  'booking.chatEnable': 'Show chat widget on the shop site',
  'booking.chatHint': 'Floating bubble in the corner of the shop where customers can message you. Messages arrive in the Communications module.',
  'booking.promoColor': 'Color',
  'booking.colorScheme': 'Color scheme',
  'booking.bgColor': 'Background color',
  'booking.presetLight': 'Light',
  'booking.presetDark': 'Dark',
  'booking.presetWarm': 'Warm',
  'booking.presetFresh': 'Fresh',
  'booking.presetRose': 'Rose',
  'booking.presetPurple': 'Purple',
  'booking.cardColor': 'Card color',
  'booking.fontPreset': 'Font',
  'booking.branding': 'Branding',
  'booking.logo': 'Logo',
  'booking.uploadLogo': 'Upload logo',
  'booking.changeLogo': 'Change logo',
  'booking.headerImage': 'Header background',
  'booking.uploadImage': 'Upload photo',
  'booking.changeImage': 'Change photo',
  'booking.logoTooLarge': 'Logo is too large. Maximum 1 MB.',
  'booking.imageTooLarge': 'Image is too large. Maximum 5 MB.',
  'booking.headerImageHint': 'Photo of your business — salon, studio, shop',
  'booking.contacts': 'Contacts',
  'booking.contactsHint': 'Address and working hours are taken from location settings',
  'booking.address': 'Address',
  'booking.addressHint': 'Street, building, city',
  'booking.businessPhone': 'Phone',
  'booking.website': 'Website',
  'booking.workingHours': 'Working hours',
  'booking.workingHoursHint': 'Mon-Fri 9:00-18:00',
  'booking.afterBooking': 'After booking',
  'booking.successMsg': 'Confirmation message',
  'booking.successMsgHint': 'E.g.: We look forward to seeing you! Don\'t forget your ID.',
  'booking.cancelPolicy': 'Cancellation policy',
  'booking.cancelPolicyHint': 'E.g.: You can cancel up to 24 hours before the visit',
  'booking.disableTitle': 'Disable online booking?',
  'booking.disableText': 'Customers will no longer be able to book online. You can re-enable it at any time.',
  'booking.disableConfirm': 'Disable',

  // ── Calendar months & days ──
  'months.0': 'January', 'months.1': 'February', 'months.2': 'March',
  'months.3': 'April', 'months.4': 'May', 'months.5': 'June',
  'months.6': 'July', 'months.7': 'August', 'months.8': 'September',
  'months.9': 'October', 'months.10': 'November', 'months.11': 'December',
  'dow.0': 'Mo', 'dow.1': 'Tu', 'dow.2': 'We',
  'dow.3': 'Th', 'dow.4': 'Fr', 'dow.5': 'Sa', 'dow.6': 'Su',

  // ── Common UI ──
  'common.save': 'Save',
  'common.saving': 'Saving...',
  'common.saved': 'Saved',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.search': 'Search',
  'onboarding.title': 'Set up your business',
  'onboarding.subtitle': '{done} of {total} steps completed',
  'onboarding.allDone': 'All set up!',
  'onboarding.allDoneHint': 'You are ready to go 💪',
  'onboarding.stepBusiness': 'Business type selected',
  'onboarding.stepStaff': 'Add your first staff member',
  'onboarding.stepService': 'Add your first service',
  'onboarding.stepAppointment': 'Create your first appointment',
  'onboarding.stepClient': 'Add your first client',
  'onboarding.noStaffYet': 'No staff members',
  'onboarding.noStaffHint': 'Add your first staff member to start accepting appointments',
  'onboarding.goAddStaff': '+ Add staff member',
  'gsearch.placeholder': 'Search clients, appointments, staff...',
  'gsearch.quickActions': 'Quick actions',
  'gsearch.customers': 'Clients',
  'gsearch.staff': 'Staff',
  'gsearch.appointments': 'Appointments',
  'gsearch.noResults': 'Nothing found',
  'gsearch.goCalendar': 'Schedule — today',
  'gsearch.goClients': 'Client base',
  'gsearch.goFinances': 'Finances',
  'gsearch.goDashboard': 'Dashboard',
  'gsearch.newClient': 'New client',
  'common.close': 'Close',
  'common.loading': 'Loading...',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.and': 'and',
  'common.confirm': 'Confirm',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.create': 'Create',
  'common.actions': 'Actions',
  'common.name': 'Name',
  'common.phone': 'Phone',
  'common.email': 'Email',
  'common.date': 'Date',
  'common.time': 'Time',
  'common.status': 'Status',
  'common.total': 'Total',
  'common.price': 'Price',
  'common.quantity': 'Quantity',
  'common.note': 'Note',
  'common.all': 'All',
  'common.filter': 'Filter',
  'common.export': 'Export',
  'common.shown': 'Shown',
  'common.of': 'of',
  'common.logout': 'Logout',
  'common.profile': 'Profile',
  'common.settings': 'Settings',
  'common.language': 'Language',

  // ── Clients page ──
  'clients.title': 'Client Base',
  'clients.subtitle': 'Client card management',
  'clients.addClient': 'Add Client',
  'clients.import': 'Import',

  // ── Import customers ──
  'import.title': 'Import Clients',
  'import.uploadHint': 'Upload a file with your client database. Excel and CSV are supported.',
  'import.maxRows': 'maximum {max} rows',
  'import.tooManyRowsTitle': 'File is too large',
  'import.tooManyRowsBody': 'The file has {count} rows — the maximum per import is {max}. Split the file into smaller parts or contact support.',
  'import.selectFile': 'Select file',
  'import.downloadTemplate': 'Download template',
  'import.or': 'or',
  'import.rows': 'rows',
  'import.fieldName': 'Name / Full name',
  'import.fieldLastName': 'Last name',
  'import.fieldFirstName': 'First name',
  'import.fieldPhone': 'Phone',
  'import.fieldAdditionalPhone': 'Additional phone',
  'import.fieldEmail': 'Email',
  'import.fieldGender': 'Gender',
  'import.fieldBirthday': 'Birthday',
  'import.fieldCategory': 'Category',
  'import.fieldCardNumber': 'Card number',
  'import.fieldNote': 'Note',

  'importProducts.btn': 'Import',
  'importProducts.btnTitle': 'Bulk-import products from Excel/CSV',
  'importProducts.title': 'Product import',
  'importProducts.uploadHint': 'Upload an Excel or CSV file with your products. Required fields: name and sell price.',
  'importProducts.maxRows': 'maximum {max} rows',
  'importProducts.tooManyRowsTitle': 'File too large',
  'importProducts.tooManyRowsBody': 'The file has {count} rows — max per import is {max}. Split it into smaller files.',
  'importProducts.selectFile': 'Select file',
  'importProducts.downloadTemplate': 'Download template',
  'importProducts.or': 'or',
  'importProducts.rows': 'rows',
  'importProducts.fieldName': 'Name',
  'importProducts.fieldSku': 'SKU',
  'importProducts.fieldCategory': 'Category',
  'importProducts.fieldUnit': 'Unit',
  'importProducts.fieldMinStock': 'Min stock',
  'importProducts.fieldSellPrice': 'Sell price',
  'importProducts.statusCol': 'Status',
  'importProducts.mapHint': 'Match the file columns to the product fields. Required fields are marked with an asterisk.',
  'importProducts.notMapped': 'not selected',
  'importProducts.back': 'Back',
  'importProducts.next': 'Next',
  'importProducts.startOver': 'Different file',
  'importProducts.willImport': 'will be imported',
  'importProducts.willSkip': 'will be skipped',
  'importProducts.newCategories': 'new categories',
  'importProducts.newCategoriesWarning': 'The file references categories that don\'t exist yet — they will be created automatically on import.',
  'importProducts.errMissingName': 'Empty name',
  'importProducts.errInvalidPrice': 'Invalid price',
  'importProducts.errInvalidMinStock': 'Invalid min stock',
  'importProducts.errSkuExisting': 'SKU already exists',
  'importProducts.previewTruncated': 'Showing first 100 of {count}',
  'importProducts.importing': 'Importing...',
  'importProducts.importBtn': 'Import {count}',
  'importProducts.doneTitle': 'Imported {count} products',
  'importProducts.doneNewCategories': 'Created {count} new categories',
  'importProducts.doneSkipped': 'Skipped {count} rows',
  'importProducts.close': 'Close',
  'importProducts.toastSuccess': 'Products imported',

  'importServices.btn': 'Import',
  'importServices.btnTitle': 'Bulk-import services from Excel/CSV',
  'importServices.title': 'Service import',
  'importServices.uploadHint': 'Upload an Excel or CSV file with your services. Required: name and price. Duration defaults to 30 min when missing.',
  'importServices.maxRows': 'maximum {max} rows',
  'importServices.tooManyRowsTitle': 'File too large',
  'importServices.tooManyRowsBody': 'The file has {count} rows — max per import is {max}.',
  'importServices.selectFile': 'Select file',
  'importServices.downloadTemplate': 'Download template',
  'importServices.or': 'or',
  'importServices.rows': 'rows',
  'importServices.fieldName': 'Name',
  'importServices.fieldGroup': 'Group',
  'importServices.fieldPrice': 'Price',
  'importServices.fieldDuration': 'Duration (min)',
  'importServices.statusCol': 'Status',
  'importServices.mapHint': 'Match the file columns to the service fields. Required fields are marked with an asterisk.',
  'importServices.notMapped': 'not selected',
  'importServices.back': 'Back',
  'importServices.next': 'Next',
  'importServices.startOver': 'Different file',
  'importServices.willImport': 'will be imported',
  'importServices.willSkip': 'will be skipped',
  'importServices.newGroups': 'new groups',
  'importServices.newGroupsWarning': 'The file references groups that don\'t exist yet — they will be created automatically.',
  'importServices.errMissingName': 'Empty name',
  'importServices.errInvalidPrice': 'Invalid price',
  'importServices.errInvalidDuration': 'Invalid duration (1-1440 min)',
  'importServices.errNameExisting': 'Service already exists',
  'importServices.previewTruncated': 'Showing first 100 of {count}',
  'importServices.importing': 'Importing...',
  'importServices.importBtn': 'Import {count}',
  'importServices.doneTitle': 'Imported {count} services',
  'importServices.doneNewGroups': 'Created {count} new groups',
  'importServices.doneSkipped': 'Skipped {count} rows',
  'importServices.close': 'Close',
  'importServices.toastSuccess': 'Services imported',

  'import.skip': 'skip',
  'import.phoneRequired': '"Phone" field is required for mapping',
  'import.preview': 'Preview',
  'import.back': 'Back',
  'import.adjustColumns': 'Adjust columns',
  'import.newClients': 'New clients',
  'import.duplicates': 'Duplicates (skipped)',
  'import.duplicate': 'duplicate',
  'import.new': 'new',
  'import.status': 'Status',
  'import.andMore': '...and {count} more',
  'import.importing': 'Importing...',
  'import.importBtn': 'Import ({count})',
  'import.success': '{count} clients imported!',
  'import.skippedDuplicates': '{count} duplicates skipped',
  'import.error': 'Import error',
  'import.close': 'Close',

  // ── Help page ──
  'helpPage.title': 'Help',
  'helpPage.subtitle': 'Guides and instructions for Systemic CRM',
  'helpPage.locations.title': 'Locations in Systemic CRM',
  'helpPage.locations.content': '<h2>What is a location?</h2><p>A location is your physical point of business: salon, clinic, shop, studio, office. One location — works automatically. Multiple — add in <strong>Settings → Locations</strong> and switch via sidebar.</p>'
  + '<h2>What\'s separate per location?</h2>'
  + '<ul>'
  + '<li><strong>Appointments</strong> — belong to the location where created</li>'
  + '<li><strong>Orders</strong> — linked to current location</li>'
  + '<li><strong>Store (POS)</strong> — sales recorded per location</li>'
  + '<li><strong>Finances</strong> — payments shown per location</li>'
  + '<li><strong>Checkout (Checkbox)</strong> — separate connection per location</li>'
  + '<li><strong>Warehouses</strong> — each warehouse belongs to a specific location</li>'
  + '</ul>'
  + '<h2>What\'s shared?</h2>'
  + '<ul>'
  + '<li><strong>Clients</strong> — single database for all locations</li>'
  + '<li><strong>Services & Products (catalog)</strong> — shared</li>'
  + '<li><strong>Product & Service categories</strong> — shared</li>'
  + '<li><strong>Loyalty programs</strong> — work across all locations</li>'
  + '<li><strong>Integrations</strong> — Nova Poshta, Telegram, SMS — one connection</li>'
  + '</ul>'
  + '<h2>Location settings — 3 tabs</h2>'
  + '<h3>General</h3><p>Name, address, phone, color for visual identification.</p>'
  + '<h3>Online Booking</h3><p>Settings for the public page <strong>shop.systemic-crm.com</strong>:</p>'
  + '<ul><li><strong>Location photo</strong> — interior or facade, shown on booking page</li>'
  + '<li><strong>Working hours</strong> — structured per weekday with on/off toggle and time range</li></ul>'
  + '<h3>Company Details</h3><p>Legal data for documents: official name, tax ID, bank account (IBAN), bank name.</p>'
  + '<h2>Warehouses & Locations</h2>'
  + '<ul>'
  + '<li>Each warehouse belongs to a specific location. New warehouses are automatically assigned to the current location.</li>'
  + '<li>The Stock page shows only warehouses of the current location.</li>'
  + '<li>Transfers work within a location and across locations — all warehouses are available in the transfer modal.</li>'
  + '<li>A warehouse cannot be deleted if it has movements, stock, or linked orders.</li>'
  + '</ul>'
  + '<h2>Deleting a location</h2>'
  + '<ul><li>Cannot delete the last location</li><li>Cannot delete a location with linked staff or warehouses — reassign them first</li></ul>'
  + '<h2>Plan limits</h2>'
  + '<p>Location count is limited by plan: Start — 1, Business — 2, Pro — 7. When the limit is reached, the Add button becomes inactive.</p>'
  + '<h2>Staff</h2><p>Shown at all locations by default. Can be restricted via staff profile. Work schedule — separate per location.</p>'
  + '<h2>Reports</h2><p>Location filter: data per specific location or combined across all.</p>',
  'helpPage.staff-and-salaries.title': 'Staff, Salaries & Access',
  'helpPage.staff-and-salaries.content': '<h2>1. Create Staff Members</h2><p>Go to <strong>Staff → Employees → Add</strong>. Set name, position, contacts and <strong>status</strong>:</p><ul><li><strong>Active (show in calendar)</strong> — service providers. Clients book them.</li><li><strong>Active (hide from calendar)</strong> — admins, managers. Have schedule and salary but hidden from booking.</li><li><strong>Dismissed</strong> — hidden everywhere, history preserved.</li></ul><h2>2. Set Work Schedule</h2><p>Go to <strong>Staff → Work Schedule</strong>. Set work days, start/end times and breaks. Used for:</p><ul><li>Showing available time for client booking</li><li>Salary calculation (daily/hourly rate)</li><li>Work hours tracking in reports</li></ul><p>Multiple locations — schedule can be set <strong>separately per location</strong>.</p><h2>3. Create a Motivation Scheme</h2><p>Go to <strong>Payroll → Motivation Schemes → Create</strong>. Name the scheme and enable rules. Rules are grouped:</p><h3>Base</h3><ul><li><strong>Monthly salary</strong> — fixed monthly amount regardless of schedule (e.g. 20,000 UAH for a full-time manager)</li><li><strong>Rate per work day</strong> — fixed amount per scheduled work day</li><li><strong>Rate per hour</strong> — fixed amount per scheduled hour</li></ul><p><em>These three can be combined. For example: 15,000 UAH monthly salary + 200 UAH/day attendance bonus.</em></p><h3>Products</h3><ul><li><strong>% of own sales</strong> — percentage of products sold by this employee</li><li><strong>% of all location sales</strong> — percentage of total product sales at location</li></ul><h3>Services</h3><ul><li><strong>% of provided services</strong> — percentage of revenue from appointments performed by this staff. For subscription-paid services you can choose: at subscription price, at list price, or do not count.</li><li><strong>Bonus per rendered service</strong> — fixed amount per service delivered within an appointment. If one booking contains 2 services (e.g. manicure + pedicure), the bonus is paid 2× the rate. You can also set <strong>individual rates for specific services</strong> (see below).</li><li><strong>% of used materials</strong> — percentage of materials used when providing services</li><li><strong>% of all location services</strong> — percentage of total service and subscription revenue at location</li></ul><h3>General</h3><ul><li><strong>% of total revenue</strong> — all location revenue: services + products + subscriptions</li></ul><h3>Admin</h3><ul><li><strong>% of booked clients</strong> — percentage of revenue from appointments created by this employee</li><li><strong>Bonus per booked client</strong> — fixed amount per appointment created</li></ul><h2>Tiered brackets</h2><p>Any <strong>percent-based rule</strong> can use tiered brackets — different rates depending on volume. Enable the <strong>Tiered brackets</strong> chip on the rule.</p><h3>Calculation modes</h3><ul><li><strong>Progressive (per slice)</strong> — each portion of revenue is taxed at its own rate, like income tax. Example: brackets 0–100k → 5%, 100k–300k → 7%, 300k+ → 9%. At 350,000: 100k × 5% + 200k × 7% + 50k × 9% = <strong>23,500</strong>.</li><li><strong>Flat (whole base at reached tier)</strong> — the whole base is computed at the rate of the tier the volume fell into. Same brackets, 350,000: 350,000 × 9% = <strong>31,500</strong>.</li></ul><h3>How to fill in</h3><p>The <strong>From</strong> field is auto-chained (first bracket starts at 0, each next starts at the previous bracket\'s To). You only edit <strong>To</strong> and <strong>%</strong>. The last bracket with an empty To means "and above" (∞). The "+ Add bracket" button is enabled only once the last bracket is valid — this eliminates gaps and overlaps by design.</p><h2>Per-service override rates</h2><p>For the <strong>Bonus per rendered service</strong> rule you can set separate rates for specific services. Enable the <strong>Per-service overrides</strong> chip.</p><p>Example: default 100 UAH/service, but SPA-pedicure — 250 UAH. A client comes for manicure + SPA-pedicure: 100 + 250 = 350 UAH.</p><p>One service can have only one override. The dropdown filters out already-added services to prevent duplicates.</p><h2>4. Assign Scheme to Staff</h2><p>In the staff profile (<strong>Staff → Employees</strong>), select the scheme in <strong>Salary Scheme</strong> field. One scheme can be assigned to multiple employees.</p><h2>5. Create User Account</h2><p>Go to <strong>System → Users → Create</strong>. Set email, password and:</p><ul><li><strong>Role</strong> — module access</li><li><strong>Staff link</strong> — for salary and schedule</li><li><strong>Data visibility</strong>:<br/>— <strong>Show all</strong> — sees everything (admin, director)<br/>— <strong>Own only</strong> — sees only own documents (manager)</li></ul><h2>6. Calculate Salary</h2><p>Monthly in <strong>Payroll → Calculation</strong>:</p><ol><li>Select month</li><li>Click Calculate</li><li>Review breakdown per rule</li><li>For rules with brackets or overrides — click the row to expand the detailed breakdown (see how each tier or service contributed)</li><li>Add manual adjustments if needed</li><li>Save result</li></ol><h2>Examples</h2><p><strong>Stylist:</strong> 40% of provided services + 500/day. Visibility — own only.</p><p><strong>Stylist with progressive brackets:</strong> % of own services with brackets (up to 30k — 30%, 30–60k — 35%, 60k+ — 40%, progressive mode) + 400/day. The more delivered, the higher the rate on additional services.</p><p><strong>Stylist with per-service rates:</strong> Bonus per rendered service 100, with overrides: "Coloring" — 300, "SPA treatment" — 250. Plus 500/day base rate.</p><p><strong>Clinic Admin:</strong> 15,000/month salary + 5% of booked clients. Visibility — all.</p><p><strong>Sales Manager:</strong> 8% of own sales with brackets (up to 50k — 5%, 50–150k — 8%, 150k+ — 12%) + 200/day. Visibility — own only.</p><p><strong>Director:</strong> 30,000/month salary + 2% of total revenue. Visibility — all.</p>',
  'helpPage.schedule.title': 'Work Schedule & Templates',
  'helpPage.schedule.content': '<h2>How to Set a Schedule</h2><p>Go to <strong>Staff → Work Schedule</strong>. Select the week using navigation arrows. Click on a day cell — the settings panel opens.</p><h3>Day Type</h3><ul><li><strong>Working</strong> — available for client booking</li><li><strong>Day off</strong> — not working</li><li><strong>Vacation</strong> — not working (tracked separately)</li><li><strong>Sick leave</strong> — not working (tracked separately)</li></ul><h3>Working Hours</h3><p>Set start and end time. Duration is calculated automatically.</p><h3>Breaks</h3><p>Add one or more breaks (lunch, rest). Breaks are subtracted from work hours for salary calculation and not shown as available for booking.</p><h2>Schedule Templates</h2><p>To avoid configuring each week manually — use templates.</p><h3>How to Create a Template</h3><ol><li>Set up a 2-week schedule for the employee</li><li>Click &ldquo;Save as template&rdquo; and enter a name (e.g. &ldquo;Manager 5/2&rdquo; or &ldquo;Stylist 2/2&rdquo;)</li></ol><h3>How to Apply a Template</h3><ol><li>Open the day settings panel</li><li>Select a template from the list</li><li>Choose number of repeats (1 cycle = 2 weeks, or half a year)</li><li>Click &ldquo;Apply&rdquo; — the schedule fills automatically</li></ol><h2>Multiple Locations</h2><p>With multiple locations, the schedule is set <strong>separately per location</strong>. One employee can have different schedules at different locations.</p><h2>What the Schedule Is Used For</h2><ul><li>Showing available time slots for client booking in the calendar</li><li>Salary calculation (daily and hourly rates)</li><li>&ldquo;Work Hours&rdquo; report — tracking hours worked</li></ul>',
  'helpPage.loyalty.title': 'Loyalty Programs',
  'helpPage.loyalty.content': '<h2>Overview</h2><p>The loyalty module in Systemic CRM consists of 4 independent programs, each enabled separately: <strong>Points (cashback)</strong>, <strong>Tiers (spending-based discounts)</strong>, <strong>Promo codes (coupons)</strong> and <strong>Subscriptions</strong>. Go to <strong>Sales → Loyalty</strong> to configure.</p>'
  + '<h2>1. Points Program (Cashback)</h2>'
  + '<h3>How It Works</h3>'
  + '<p>Customers earn points as a percentage of the actual paid amount. 1 point = 1 currency unit. On the next payment, the customer can redeem points to reduce the total.</p>'
  + '<h3>Settings</h3>'
  + '<ul>'
  + '<li><strong>Cashback (%)</strong> — percentage of purchase amount returned as points. E.g., at 10% a customer gets 100 points from a 1,000 purchase.</li>'
  + '<li><strong>Max % payable with points</strong> — maximum share of an order that can be paid with points. At 50%, a 2,000 order can use up to 1,000 in points.</li>'
  + '</ul>'
  + '<h3>Automatic Bonuses</h3>'
  + '<ul>'
  + '<li><strong>Birthday bonus</strong> — specified points are awarded automatically on the customer\'s birthday. Once per year.</li>'
  + '<li><strong>Referral bonus</strong> — points awarded to the referrer when the referred customer makes their first payment. Set the referrer in the customer card.</li>'
  + '<li><strong>Return bonus</strong> — if a customer hasn\'t visited for a specified number of days and returns, they get extra points on payment.</li>'
  + '</ul>'
  + '<h3>Where Points Are Earned</h3>'
  + '<ul>'
  + '<li><strong>Calendar</strong> — on appointment payment (on actual paid amount after discounts and point redemption)</li>'
  + '<li><strong>Orders</strong> — on product order payment</li>'
  + '<li><strong>POS</strong> — on point-of-sale purchases</li>'
  + '</ul>'
  + '<h3>Redeeming Points</h3>'
  + '<p>When paying for an appointment, order or purchase, the admin sees a "Redeem points" field. The system automatically limits the maximum per settings. Redeemed points reduce the payment amount — the terminal and fiscal receipt show the reduced amount.</p>'
  + '<h3>History & Balances</h3>'
  + '<p>The <strong>Balances</strong> tab shows each customer\'s current balance. The <strong>History</strong> tab shows all point operations with detailed notes: which visit/order/sale earned points, when and how many were redeemed.</p>'
  + '<h2>2. Tiers (Spending-Based Discounts)</h2>'
  + '<h3>How It Works</h3>'
  + '<p>Customers automatically receive a tier (Bronze, Silver, Gold, etc.) based on their total spending. Each tier provides a fixed discount on services.</p>'
  + '<h3>What Counts as Spending</h3>'
  + '<ul>'
  + '<li>Service payments (appointments)</li>'
  + '<li>Product purchases (orders and POS)</li>'
  + '<li>Subscription purchases</li>'
  + '<li>Minus refunds</li>'
  + '</ul>'
  + '<h3>Accounting Period</h3>'
  + '<p>By default, spending is calculated for all time. You can set a rolling window: <strong>6, 12 or 24 months</strong>. With a rolling window, the tier is re-evaluated automatically — if a customer stops visiting, their tier decreases.</p>'
  + '<h3>Tier Settings</h3>'
  + '<p>Add and edit tiers: name, minimum spending, discount (%). You can create as many tiers as needed.</p>'
  + '<h2>3. Promo Codes (Coupons)</h2>'
  + '<h3>How It Works</h3>'
  + '<p>Create coupons with a discount (percentage or fixed amount). The customer or admin enters the code at payment — the discount applies automatically.</p>'
  + '<h3>Coupon Parameters</h3>'
  + '<ul>'
  + '<li><strong>Code</strong> — unique promo code (e.g., SPRING20)</li>'
  + '<li><strong>Type</strong> — percentage or fixed</li>'
  + '<li><strong>Value</strong> — discount amount (20% or 200)</li>'
  + '<li><strong>Min order amount</strong> — coupon won\'t work if the order is below this amount</li>'
  + '<li><strong>Max uses</strong> — how many times it can be used (0 = unlimited)</li>'
  + '<li><strong>Valid until</strong> — expiry date (empty = no expiry)</li>'
  + '</ul>'
  + '<h2>4. Subscriptions</h2>'
  + '<h3>How It Works</h3>'
  + '<p>Create subscription plans (e.g., "10 massage visits" or "Unlimited month"). The customer buys a subscription and can use visits without additional payment.</p>'
  + '<h3>Subscription Types</h3>'
  + '<ul>'
  + '<li><strong>By visits</strong> — fixed number of visits (e.g., 10). Each use decreases the remaining count.</li>'
  + '<li><strong>By time</strong> — unlimited visits within a specified period (e.g., 30 days).</li>'
  + '</ul>'
  + '<h3>Using a Subscription</h3>'
  + '<p>When paying for an appointment in the Calendar — if the customer has an active subscription covering the service — a <strong>"Subscription"</strong> button appears among payment methods. Transaction amount = 0 (money was already paid at subscription purchase).</p>'
  + '<h2>General Principles</h2>'
  + '<ul>'
  + '<li>All 4 programs work <strong>independently</strong> — enable one or all</li>'
  + '<li>Points, coupons and subscriptions can be <strong>combined</strong> in a single payment</li>'
  + '<li>All loyalty operations are <strong>atomic</strong> — point deduction, earning and payment only happen after successful terminal and fiscal receipt processing</li>'
  + '<li>Programs apply <strong>across all locations</strong></li>'
  + '<li>All operations are logged with <strong>detailed notes</strong></li>'
  + '</ul>',
  'clients.searchPlaceholder': 'Search by name, phone, email, card number...',
  'clients.allCategories': 'All categories',
  'clients.allOrigins': 'All sources',
  'clients.origin': 'Source',
  'clients.noOrigin': 'No source',
  'custModal.origin': 'Source',
  'custModal.originAuto': '(detected automatically)',
  'custModal.originNone': '— not set —',
  'categories.sourcesTab': 'Sources',
  'categories.sourcesDesc': 'Where clients come from. Chosen in the client card (Details tab); cards from Instagram, the website or integrations get a source automatically.',
  'categories.sourcesDefault': 'The general list is in use now — adjust it to your business.',
  'categories.noSources': 'No sources yet.',
  'categories.sourcePlaceholder': 'For example: TikTok',
  'categories.addSource': 'Add',
  'categories.sourceDuplicate': 'This source already exists',
  'categories.sourcesSaved': 'Saved',
  'categories.sourcesExtra': 'Also in cards',
  'categories.sourcesNone': 'No source',
  'categories.clientsShort': 'clients',
  'categories.moveUp': 'Up',
  'categories.moveDown': 'Down',
  'clients.clientsCount': 'Clients',
  'clients.grid': 'Grid',
  'clients.list': 'List',
  'clients.deleteTitle': 'Delete client?',
  'clients.deleteMessage': 'You are about to delete client card',
  'clients.cannotDeleteTitle': 'Cannot delete',
  'clients.cannotDeleteMessage': 'Client has appointments or financial history and cannot be deleted',
  'clients.duplicatePhone': 'A customer with this phone number already exists',
  'clients.duplicatePhoneWithName': 'A customer with this phone already exists: {name}',
  'clients.importSqlErrors': 'Some cards could not be saved completely: {n}. Tell your administrator.',
  'clients.duplicateInstagram': 'This Instagram handle is already on another card',
  'clients.duplicateInstagramWithName': 'This Instagram handle is already on the card: {name}',
  'clients.openExisting': 'Open customer',
  'clients.understood': 'Understood',
  'clients.deleteWarning': 'This action is irreversible. All client data will be lost.',

  // ── Delete modal ──
  'delete.title': 'Confirm deletion',
  'delete.message': 'You are about to delete a record',
  'delete.confirm': 'Yes, delete',
  'delete.warning': 'This action is irreversible. All data will be lost.',

  // ── Confirm Payment Modal ──
  'confirmPay.title': 'Confirm payment',
  'confirmPay.refundTitle': 'Confirm refund',
  'confirmPay.confirm': 'Confirm payment',
  'confirmPay.confirmRefund': 'Confirm refund',
  'confirmPay.withFiscal': 'With fiscal receipt',
  'confirmPay.refundWarning': 'Funds will be returned to the customer',
  'confirmPay.subscriptionVisits': '{count} visit(s) will be deducted from the subscription',
  'confirmPay.terminalWaiting': 'Waiting for terminal...',
  'confirmPay.terminalHint': 'Ask the customer to tap their card on the terminal',
  'confirmPay.terminalProcessing': 'Processing...',

  // ── Payment Success Overlay ──
  'paySuccess.title': 'Payment successful',
  'paySuccess.refundTitle': 'Refund successful',
  'paySuccess.subscriptionVisits': '{count} visit(s) deducted from the subscription',

  // ── Sidebar ──
  'sidebar.crmSystem': 'CRM System',
  'sidebar.version': 'v1.0',

  // ── Login ──
  'login.title': 'Sign In',
  'login.setupTitle': 'System Setup',
  'login.setupSubtitle': 'Create an administrator account',
  'login.subtitle': 'Enter your credentials',
  'login.email': 'Email',
  'login.password': 'Password',
  'login.submit': 'Sign In',
  'login.setupSubmit': 'Create Administrator',
  'login.wait': 'Please wait\u2026',
  'login.forgotPassword': 'Forgot password?',
  'login.resetTitle': 'Password Reset',
  'login.resetSubtitle': 'Enter your email — we will send reset instructions',
  'login.resetSend': 'Send',
  'login.resetSentHint': 'Check your inbox — we sent you instructions',
  'login.backToLogin': 'Back to login',
  'login.nameLabel': 'Name',
  'login.namePlaceholder': 'Your name',
  'login.businessLabel': 'Business name',
  'login.businessPlaceholder': 'My salon / shop / studio',
  'login.errorEnterBusiness': 'Enter business name',
  'login.businessTypeLabel': 'Business type',
  'login.businessTypePlaceholder': 'Select business type...',
  'login.errorSelectBusinessType': 'Select business type',
  'login.showPassword': 'Show password',
  'login.hidePassword': 'Hide password',
  'login.errorInvalidCreds': 'Invalid email or password',
  'login.errorTooMany': 'Too many attempts. Try again later.',
  'login.errorGeneric': 'Login error: ',
  'login.errorEnterName': 'Enter your name',
  'login.errorEnterEmail': 'Enter email',
  'login.errorMinPassword': 'Password must be at least 6 characters',
  'login.errorSetup': 'Error: ',
  'login.tabLogin': 'Login',
  'login.tabRegister': 'Register',
  'login.registerTitle': 'Create account',
  'login.registerSubtitle': '7 days free, all modules included',
  'login.registerSubmit': 'Sign up',
  'login.registerSuccess': 'Account created! Logging in...',
  'login.errorEmailExists': 'This email is already registered',
  'login.errorRegister': 'Registration error: ',
  'login.confirmPassword': 'Confirm password',
  'login.errorPasswordMismatch': 'Passwords do not match',
  'login.agreeTerms': 'By registering, you agree to the',
  'login.agreeCheckbox': 'I agree to the',
  'login.errorAgreeTerms': 'You must agree to the terms of service',
  'login.terms': 'Terms of Service',
  'login.privacy': 'Privacy Policy',

  // ── Blocked ──
  'blocked.title': 'Account blocked',
  'blocked.desc': 'Contact your administrator to restore access',
  'blocked.trialExpired': 'Trial period expired',
  'blocked.trialExpiredDesc': 'Choose a plan to continue using the system',
  'blocked.paymentOverdue': 'Subscription overdue',
  'blocked.paymentOverdueDesc': 'Your subscription has expired. Please renew it to continue working.',
  'blocked.subscriptionExpiredDesc': 'Your subscription has expired. Please renew it to continue working.',
  'blocked.contact': 'Contact support',
  'blocked.logout': 'Log out',

  // ── My Plan ──
  'myPlan.title': 'My Plan',
  'myPlan.subtitle': 'Subscription management',
  'myPlan.loadError': 'Failed to load plan data',
  'myPlan.trial': 'Trial',
  'myPlan.active': 'Active',
  'myPlan.trialExpired': 'Trial expired',
  'myPlan.blocked': 'Blocked',
  'myPlan.daysLeft': 'days left',
  'myPlan.month': 'mo',
  'myPlan.year': 'yr',
  'myPlan.orYearly': 'or',
  'myPlan.chooseBillingPeriod': 'pick billing period',
  'myPlan.periodMonthly': 'Monthly',
  'myPlan.periodYearly': 'Yearly',
  'myPlan.yearlySaving': 'save {n} ₴ vs monthly',
  'myPlan.monthlyTotal': '{n} ₴/year',
  'myPlan.proceedToPayment': 'Proceed to payment',
  'myPlan.cancel': 'Cancel',
  'myPlan.oldRateTitle': 'You\'re on a legacy rate',
  'myPlan.oldRateText': 'You\'re currently paying {old} ₴; the current rate for {plan} is {new} ₴. You can keep the old rate indefinitely or switch to the new one.',
  'myPlan.upgradeRate': 'Switch to new rate',
  'myPlan.users': 'Users',
  'myPlan.locations': 'Locations',
  'myPlan.availablePlans': 'Available plans',
  'myPlan.popular': 'Popular',
  'myPlan.usersIncl': 'users',
  'myPlan.locationsIncl': 'locations',
  'myPlan.allModules': 'All 46 modules',
  'myPlan.trialActive': 'Trial active',
  'myPlan.currentPlan': 'Current plan',
  'myPlan.upgrade': 'Choose plan',
  'myPlan.changePlan': 'Change plan',
  'myPlan.trialHint': 'After the trial period ends, choose a plan to continue. All your data will be preserved.',
  'myPlan.limitUsers': 'User limit reached for your plan. Upgrade to add more users.',
  'myPlan.limitLocations': 'Location limit reached for your plan. Upgrade to add more locations.',
  'myPlan.cancelSubscription': 'Cancel subscription',
  'myPlan.cancelledNotice': 'Subscription cancelled. Your plan remains active until the end of the paid period.',
  'myPlan.cancelTitle': 'Cancel subscription?',
  'myPlan.cancelDescription': 'Your plan will remain active until the end of the paid period. After that, your account will be downgraded to a trial plan.',
  'myPlan.cancelReasonLabel': 'Reason for cancellation (optional)',
  'myPlan.cancelReasonPlaceholder': 'Tell us why you decided to cancel...',
  'myPlan.confirmCancel': 'Yes, cancel',
  'myPlan.keepSubscription': 'Keep subscription',
  'myPlan.cancelError': 'Cancellation error',
  'myPlan.subscriptionExpired': 'expired',

  // ── Checkout (post-registration) ──
  'checkout.title': 'Your account is ready!',
  'checkout.subtitle': 'Choose how to start with Systemic CRM',
  'checkout.recommended': 'Recommended',
  'checkout.payNow': 'Pay and get started',
  'checkout.trialTitle': 'Free trial',
  'checkout.days': 'days',
  'checkout.trialFeature1': 'Full access to all features',
  'checkout.trialFeature2': 'No commitment',
  'checkout.trialFeature3': 'Your data is preserved after payment',
  'checkout.tryFree': 'Try for free',

  // ── Dashboard ──
  'dash.title': 'Dashboard',
  'dash.myOffice': 'My Office',
  'dash.subtitle': 'Main Screen',
  'dash.personalStats': 'Personal Statistics',
  'dash.todayAppointments': 'Appointments Today',
  'dash.completed': 'completed',
  'dash.todayRevenue': 'Today\'s Revenue',
  'dash.clientsCount': 'Clients',
  'dash.newThisMonth': 'this month',
  'dash.unread': 'Unread',
  'dash.todaySchedule': 'Today\'s Schedule',
  'dash.allAppointments': 'All appointments',
  'dash.noAppointmentsToday': 'No appointments today',
  'dash.moreAppointments': 'appointments',
  'dash.weekRevenue': 'Weekly Revenue',
  'dash.needsAttention': 'Needs Attention',
  'dash.unreadMessages': 'unread messages',
  'dash.lowStock': 'low stock',
  'dash.topClients': 'Top Clients (month)',
  'dash.noPaymentsThisMonth': 'No payments this month',
  'dash.birthdays': 'Birthdays',
  'dash.noBirthdaysThisWeek': 'No birthdays this week',
  'dash.today': 'Today!',
  'dash.tomorrow': 'Tomorrow',
  'dash.inDays': 'In {n} days',
  'dash.congratulate': 'Congratulate',
  'dash.atRisk': 'At Risk of Loss',
  'dash.allClientsActive': 'All clients are active',
  'dash.daysWithoutVisit': 'days without visit',
  'dash.write': 'Message',
  'dash.todayOrderSales': 'Product sales',
  'dash.serviceSales': 'Service sales',
  'dash.appointmentsToday': 'appointments today',
  'dash.ordersToday': 'orders today',
  'dash.activeOrders': 'active',
  'dash.recentOrders': 'Recent orders',
  'dash.allOrders': 'All orders',
  'dash.items': 'items',
  'dash.statusWaiting': 'Waiting',
  'dash.statusConfirmed': 'Completed',
  'dash.statusArrived': 'Arrived',
  'dash.statusNoShow': 'No Show',
  'dash.dowSun': 'Su', 'dash.dowMon': 'Mo', 'dash.dowTue': 'Tu',
  'dash.dowWed': 'We', 'dash.dowThu': 'Th', 'dash.dowFri': 'Fr', 'dash.dowSat': 'Sa',

  // ── Profile modal ──
  'profile.title': 'Profile',
  'profile.name': 'Name',
  'profile.namePlaceholder': 'Your name',
  'profile.email': 'Email',
  'profile.changePassword': 'Change Password',
  'profile.passwordHint': 'Leave fields empty if you don\'t want to change the password',
  'profile.currentPassword': 'Current Password',
  'profile.newPassword': 'New Password',
  'profile.newPasswordPlaceholder': 'At least 6 characters',
  'profile.confirmPassword': 'Confirm Password',
  'profile.confirmPasswordPlaceholder': 'Repeat new password',
  'profile.saved': 'Saved!',
  'profile.passwordChanged': 'Password changed',
  'profile.homePage': 'Home page',
  'profile.startingLocation': 'Starting location',
  'profile.startingLocationAuto': 'Automatic (default)',
  'profile.homeBizMonitor': 'Business Monitor',
  'profile.homeDashboard': 'Dashboard',
  'profile.homeCalendar': 'Calendar',
  'profile.homeClients': 'Clients',
  'profile.homePos': 'Store',
  'profile.homeOrders': 'Orders',
  'profile.homeFinances': 'Finances',
  'profile.homeCommunication': 'Messages',
  'profile.homeStaff': 'Staff',
  'profile.homeStock': 'Stock',
  'profile.homePurchases': 'Purchases',
  'profile.homeProduction': 'Production',
  'profile.homeSalary': 'Payroll',
  'profile.homeCashRegister': 'Cash Register',
  'profile.homeReports': 'Reports',
  'profile.homeFinResult': 'Financial Result',
  'profile.profileUpdated': 'Profile updated',
  'profile.errorEnterName': 'Enter your name',
  'profile.errorEnterCurrentPassword': 'Enter current password',
  'profile.errorMinPassword': 'New password must be at least 6 characters',
  'profile.errorPasswordMismatch': 'Passwords do not match',
  'profile.errorWrongPassword': 'Incorrect current password',
  'profile.errorTooMany': 'Too many attempts. Try again later.',
  'profile.errorGeneric': 'Error: ',

  // ── Calendar page ──
  'cal.monthGen.0': 'January', 'cal.monthGen.1': 'February', 'cal.monthGen.2': 'March',
  'cal.monthGen.3': 'April', 'cal.monthGen.4': 'May', 'cal.monthGen.5': 'June',
  'cal.monthGen.6': 'July', 'cal.monthGen.7': 'August', 'cal.monthGen.8': 'September',
  'cal.monthGen.9': 'October', 'cal.monthGen.10': 'November', 'cal.monthGen.11': 'December',
  'cal.weekday.0': 'Sunday', 'cal.weekday.1': 'Monday', 'cal.weekday.2': 'Tuesday',
  'cal.weekday.3': 'Wednesday', 'cal.weekday.4': 'Thursday', 'cal.weekday.5': 'Friday', 'cal.weekday.6': 'Saturday',
  'cal.today': 'Today',
  'cal.daySchedule': 'Day Schedule',
  'cal.appointments': 'appointments',
  'cal.working': 'Working',
  'cal.dayOff': 'Day Off',
  'cal.noStaffWorking': 'No staff working on this day',
  'cal.clickToAdd': 'Click on a time slot to add an appointment',
  'cal.service': 'Service',
  'cal.material': 'Material',
  'cal.batchClashed': 'Not created — the master already has a booking: {list}',
  'cal.paymentNotRecorded': 'The payment went through, but its record was not saved. Do not repeat the payment — tell your administrator.',
  'cal.subscriptionVisitNotReturned': 'The visit was not returned to the subscription — tell your administrator.',
  'cal.paid': 'Paid',
  'cal.unpaid': 'Unpaid',
  'cal.batchBooking': 'Batch Booking',
  'cal.batchCreated': 'Appointments created',
  'cal.fiscalReceiptCreated': 'Fiscal receipt created',
  'cal.fiscalReceiptError': 'Fiscal receipt error',
  'cal.terminalError': 'Terminal payment error',
  'cal.fiscalReturnError': 'Failed to create fiscal return receipt',
  'cal.refundRecorded': 'Refund recorded',
  'cal.cannotDeletePaid': 'Cannot delete a paid appointment. Refund it first.',

  // ── Appointment modal ──
  'apt.newTitle': 'New Appointment',
  'apt.editTitle': 'Edit Appointment',
  'apt.closeEsc': 'Close (Esc)',
  'apt.client': 'Client',
  'apt.nameOrPhone': 'Name or phone',
  'apt.startTyping': 'Start typing...',
  'apt.phone': 'Phone',
  'apt.viewProfile': 'Go to profile',
  'apt.dateAndTime': 'Date and Time',
  'apt.date': 'Date',
  'apt.startTime': 'Start',
  'apt.endTime': 'End',
  'apt.servicesAndPayment': 'Services and Payment',
  'apt.pricelist': 'Price List',
  'apt.addService': 'Add service',
  'apt.standardPrice': 'Standard price',
  'apt.tariffPlan': 'Tariff plan',
  'apt.min': 'min',
  'apt.discount': 'Discount',
  'apt.uah': 'UAH',
  'apt.total': 'Total',
  'apt.toPay': 'To pay',
  'apt.paymentMethod': 'Payment method',
  'apt.cash': 'Cash',
  'apt.terminal': 'Terminal',
  'apt.transfer': 'Transfer',
  'apt.paid': 'Paid',
  'apt.clientGave': 'Client gave',
  'apt.change': 'Change',
  'apt.note': 'Note',
  'apt.author': 'Author',
  'apt.rescheduled': 'Rescheduled',
  'apt.notePlaceholder': 'Comment on the appointment...',
  'apt.notesPlaceholder': 'Comment on the appointment...',
  'apt.book': 'Book',
  'apt.saveChanges': 'Save changes',
  'apt.cancel': 'Cancel',
  'apt.delete': 'Delete',
  'apt.printBill': 'Bill',
  'apt.deleteTitle': 'Delete appointment?',
  'apt.deleteMessage': 'You are about to delete this appointment. This action cannot be undone.',
  'apt.payBtn': 'Pay',
  'apt.confirmPayment': 'Confirm payment?',
  'apt.refund': 'Refund',
  'apt.refundTitle': 'Refund',
  'apt.refundMessage': 'Are you sure you want to refund this appointment?',
  'apt.refundWarning': 'This action cannot be undone.',
  'apt.confirmRefund': 'Confirm refund',
  'apt.refunded': 'Refunded',
  'apt.back': 'Back',
  'apt.batchBooking': 'Batch Booking',
  'apt.createMultiple': 'Create multiple',
  'apt.materials': 'Materials',
  'apt.product': 'Product',
  'apt.qty': 'Qty',
  'apt.pcs': 'pcs',
  'apt.add': 'Add',
  'apt.noProductsAdded': 'No products added',
  'apt.noProductsInStock': 'No products in stock',
  'apt.notEnough': 'Not enough',
  'apt.notEnoughInStock': 'Not enough in stock',
  'apt.notEnoughStock': 'Insufficient stock',
  'apt.appointmentNote': 'Appointment note',
  'apt.clientDocs': 'Client documents',
  'apt.addDocument': 'Add document',
  'apt.docName': 'Document name',
  'apt.docNamePlaceholder': 'Enter name...',
  'apt.docText': 'Document text',
  'apt.noDocsYet': 'No documents yet',
  'apt.attachFile': 'Attach file',
  'apt.maxFileSize': 'Max file size: 2 MB',
  'apt.errClientName': 'Enter client name',
  'apt.errClientPhone': 'Enter client phone',
  'apt.errDate': 'Select a date',
  'apt.errDiscount': 'Discount cannot exceed the total',
  'apt.errDayOff': 'Specialist is off on this day',
  'apt.errOutsideWorkingHours': 'Time is outside working hours ({start} – {end})',
  'apt.errOverlap': 'Time overlaps with appointment {start}–{end} ({client})',
  'apt.workingHoursHint': 'Working hours: {start} – {end}',
  'apt.statusWaiting': 'Waiting',
  'apt.statusConfirmed': 'Completed',
  'apt.statusArrived': 'Arrived',
  'apt.statusNoShow': 'No Show',

  // ── Batch appointment modal ──
  'batchApt.title': 'Batch Booking',
  'batchApt.subtitle': 'Create multiple appointments at once',
  'batchApt.closeEsc': 'Close (Esc)',
  'batchApt.client': 'Client',
  'batchApt.nameOrPhone': 'Name or phone',
  'batchApt.phone': 'Phone',
  'batchApt.staffMember': 'Staff member',
  'batchApt.service': 'Service',
  'batchApt.discount': 'Discount',
  'batchApt.uah': 'UAH',
  'batchApt.addDate': 'Add date',
  'batchApt.delete': 'Delete',
  'batchApt.entries': 'entries',
  'batchApt.entrySingle': 'entry',
  'batchApt.entryPlural': 'entries',
  'batchApt.create': 'Create',
  'batchApt.cancel': 'Cancel',
  'batchApt.errClientName': 'Enter client name',
  'batchApt.errClientPhone': 'Enter client phone',
  'batchApt.errDiscount': 'Discount cannot exceed the total',
  'batchApt.errNoRows': 'Add at least one entry',

  // ── Customer card ──
  'custCard.edit': 'Edit',
  'custCard.delete': 'Delete',
  'custCard.book': 'Book',
  'custCard.order': 'Order',
  'custCard.sell': 'Sell',
  'custCard.sellProduct': 'Product',
  'custCard.sellService': 'Service',
  'custCard.sellSubscription': 'Subscription',
  'custCard.openFinances': 'Finances',
  'custCard.paid': 'Paid',
  'custCard.sold': 'Sold',
  'custCard.balance': 'Balance',
  'custCard.importance': 'Importance',
  'custCard.forbidOnlineBooking': 'Online booking forbidden',

  // ── Customer grid ──
  'custGrid.noCustomersFound': 'No customers found',
  'custGrid.tryChangeSearch': 'Try changing your search query or category filter',

  // ── Customer modal ──
  'custModal.newCustomer': 'New Customer',
  'custModal.editCustomer': 'Edit Customer',
  'custModal.closeEsc': 'Close (Esc)',
  'custModal.tabMain': 'General',
  'custModal.tabDetails': 'Details',
  'custModal.tabVisits': 'Visits',
  'custModal.tabFinancial': 'Finances',
  'custModal.tabAnalytics': 'Analytics',
  'custModal.tabNotes': 'Notes',
  'custModal.tabDocuments': 'Documents',
  'custModal.personalData': 'Personal Data',
  'custModal.fullName': 'Full name',
  'custModal.fullNamePlaceholder': 'Enter full name',
  'custModal.mobilePhone': 'Mobile phone',
  'custModal.additionalPhone': 'Additional phone',
  'custModal.birthDate': 'Date of birth',
  'custModal.day': 'Day',
  'custModal.month': 'Month',
  'custModal.year': 'Year',
  'custModal.gender': 'Gender',
  'custModal.genderMale': 'Male',
  'custModal.genderFemale': 'Female',
  'custModal.genderOther': 'Other',
  'custModal.cardNumber': 'Card number',
  'custModal.profilePhoto': 'Profile photo',
  'custModal.uploadPhoto': 'Upload photo',
  'custModal.changePhoto': 'Change photo',
  'custModal.deletePhoto': 'Delete photo',
  'custModal.avatar': 'Avatar',
  'custModal.categoryAndClassification': 'Category and Classification',
  'custModal.category': 'Category',
  'custModal.importanceLabel': 'Importance',
  'custModal.discountLabel': 'Discount',
  'custModal.discountRange': '0\u2013100%',
  'custModal.referral': 'Referral program',
  'custModal.referredBy': 'Referred by',
  'custModal.referredByHint': 'Select the client who brought this person. Referrer gets a bonus on first payment.',
  'custModal.restrictions': 'Restrictions',
  'custModal.forbidOnlineBooking': 'Forbid online booking',
  'custModal.forbidOnlineBookingDesc': 'Client will not be able to book independently',
  'custModal.telegramReminders': 'Telegram Reminders',
  'custModal.telegramConnected': 'Telegram connected',
  'custModal.setupTelegramBot': 'Set up Telegram bot',
  'custModal.sendLinkToCustomer': 'Send link to customer',
  'custModal.send': 'Send',
  'custModal.sending': 'Sending...',
  'custModal.specifyPhoneFirst': 'Specify phone first',
  'custModal.save': 'Save',
  'custModal.cancel': 'Cancel',
  'custModal.close': 'Close',
  'custModal.editBtn': 'Edit',
  'custModal.viewCustomer': 'Customer card',
  'custModal.back': 'Back',
  'custModal.next': 'Next',
  'custModal.nameRequired': 'Name is required',
  'custModal.phoneRequired': 'Phone is required',
  'custModal.instagram': 'Instagram (handle)',
  'custModal.instagramInvalid': 'Instagram handle: Latin letters, digits, dot, underscore',
  'custModal.fromThreadHint': 'Card from a conversation: once saved, the thread and its history move to this card.',
  'custModal.nameDuplicate': 'A client with this name already exists',
  'custModal.phoneDuplicate': 'A client with this phone number already exists',
  'custModal.note': 'Note',
  'custModal.notePlaceholder': 'Add a note...',
  'custModal.comments': 'Comments',
  'custModal.contactLater': 'Contact later',
  'custComments.placeholder': 'New comment…',
  'custComments.add': 'Add',
  'apiKeys.title': 'API keys',
  'apiKeys.subtitle': 'Access for external systems to the business’s customers',
  'apiKeys.create': 'Create key',
  'apiKeys.empty': 'No keys yet.',
  'apiKeys.revoked': 'Revoked',
  'apiKeys.revoke': 'Revoke',
  'apiKeys.noScopes': 'No permissions',
  'apiKeys.createdBy': 'Created by',
  'apiKeys.lastUsed': 'Last used',
  'apiKeys.name': 'Name',
  'apiKeys.namePlaceholder': 'For example: Telegram bot, Website, Binotel',
  'apiKeys.createBtn': 'Create',
  'apiKeys.newTitle': 'Key created',
  'apiKeys.onceWarning': 'Copy the key now — it cannot be shown again.',
  'apiKeys.copy': 'Copy',
  'apiKeys.done': 'I have saved the key',
  'apiKeys.copied': 'Copied',
  'apiKeys.copyFailed': 'Could not copy',
  'apiKeys.docs': 'Developer documentation',
  'apiKeys.copyDocs': 'Copy documentation link',
  'apiKeys.handover': 'Send the developer the key and the documentation link:',
  'nav.calls': 'Calls',
  'nav.documentTemplates': 'Document templates',
  'custModal.docFromTemplate': 'Document from template',
  'custModal.previewDoc': 'Preview and print',
  'apt.docFromTemplate': 'Document from template',
  'apt.previewDoc': 'Preview / print',
  'nav.telephony': 'Telephony',
  'custModal.tabCalls': 'Calls',
  'custModal.fromCallHint': 'Card from a call: all calls from this number will appear in its “Calls” tab.',
  'tel.title': 'Telephony',
  'tel.subtitle': 'Calls in Systemic: who is calling, history, missed calls',
  'tel.step1': 'Binotel keys',
  'tel.step1Hint': 'Binotel support issues the REST API key and secret: email support@binotel.ua from your account email and ask for REST API keys.',
  'tel.apiKey': 'Key',
  'tel.apiSecret': 'Secret',
  'tel.save': 'Save',
  'tel.saved': 'Saved',
  'tel.test': 'Check keys',
  'tel.testOk': 'Binotel accepted the keys',
  'tel.testFail': 'Binotel rejected the keys',
  'tel.linesNote': 'No need to assign internal lines: each employee picks their phone the first time they press “Call”.',
  'tel.step2': 'Address for Binotel',
  'tel.step2Hint': 'Send this email to Binotel support (support@binotel.ua) from your account email. The address is secret — share it with no one but Binotel.',
  'tel.copyEmail': 'Copy email',
  'tel.rotate': 'New address',
  'tel.rotateConfirm': 'Create a new address? The old one will stop working and the new one must be sent to Binotel support again.',
  'tel.binotelLines': 'Lines in Binotel',
  'tel.disconnect': 'Disconnect',
  'tel.disconnectConfirm': 'Disconnect telephony? Call history will be kept.',
  'tel.step4': 'Reasons for “no deal”',
  'tel.step4Hint': 'After a call, an employee can mark “Agreed” or “No deal” and pick a reason from this list. Marking is optional.',
  'tel.step4Default': 'The general list is in use now — adjust it to your business.',
  'tel.removeReason': 'Remove',
  'tel.reasonPlaceholder': 'For example: No free time slots',
  'tel.addReason': 'Add',
  'tel.saveReasons': 'Save reasons',
  'custComments.empty': 'No comments yet.',
  'custComments.afterCreate': 'Comments can be added once the card is created.',
  'custComments.edit': 'Edit',
  'custComments.delete': 'Delete',
  'custComments.save': 'Save',
  'custComments.edited': 'edited',
  'custComments.unknown': 'Unknown',
  'custComments.legacy': 'Earlier comments',
  'custComments.older': 'Show earlier',
  'custComments.confirmDelete': 'Delete this comment?',
  'custComments.addFailed': 'Could not add the comment',
  'custComments.saveFailed': 'Could not save',
  'custComments.deleteFailed': 'Could not delete',
  'custModal.commentsPlaceholder': 'Write a comment...',
  'custModal.writeMessagePlaceholder': 'Write a message...',
  // Customer modal — visits tab
  'custModal.visitHistory': 'Visit History',
  'custModal.totalVisits': 'Total visits',
  'custModal.lastVisit': 'Last visit',
  'custModal.visitFrequency': 'Visit frequency',
  'custModal.days': 'days',
  'custModal.visitsByMonth': 'Visits by month',
  'custModal.noVisitsYet': 'No visits yet',
  'custModal.tabOrders': 'Purchases',
  'custModal.orderHistory': 'Purchase history',
  'custModal.ordersTotal': 'Orders',
  'custModal.ordersDelivered': 'Delivered',
  'custModal.ordersPaid': 'Paid',
  'custModal.noOrdersYet': 'No purchases yet',
  'custModal.posSalesCount': 'Sales',
  'custModal.orderStatusNew': 'New',
  'custModal.orderStatusConfirmed': 'Confirmed',
  'custModal.orderStatusPacked': 'Packed',
  'custModal.orderStatusShipped': 'Shipped',
  'custModal.orderStatusDelivered': 'Delivered',
  'custModal.orderStatusCancelled': 'Cancelled',
  'custModal.posCompleted': 'Completed',
  'custModal.posSourceLabel': 'POS',
  'custModal.orderSourceLabel': 'Order',
  'custModal.subscriptionsLabel': 'Subscriptions',
  'custModal.completed': 'Completed',
  'custModal.noShow': 'No Show',
  'custModal.statusWaiting': 'Waiting',
  'custModal.statusConfirmed': 'Completed',
  'custModal.statusArrived': 'Arrived',
  'custModal.statusNoShow': 'No Show',
  // Customer modal — financial tab
  'custModal.financialIndicators': 'Financial Indicators',
  'custModal.finPaid': 'Paid',
  'custModal.finBalance': 'Balance',
  'custModal.avgCheck': 'Avg check',
  'custModal.ltv': 'LTV',
  'custModal.charges': 'Charges',
  'custModal.noChargesYet': 'No charges yet',
  'custModal.subscriptionPurchase': 'Subscription purchase',
  'custModal.subscriptionRefund': 'Subscription refund',
  'custModal.noPaymentsYet': 'No payments yet',
  'custModal.date': 'Date',
  'custModal.dateTime': 'Date/time',
  'custModal.service': 'Service',
  'custModal.serviceLabel': 'Service',
  'custModal.price': 'Price',
  'custModal.discount': 'Discount',
  'custModal.total': 'Total',
  'custModal.paidLabel': 'Payment',
  'custModal.payment': 'Payment',
  'custModal.paymentMethod': 'Payment method',
  'custModal.amount': 'Amount',
  'custModal.totalAmount': 'Total amount',
  'custModal.methodCash': 'Cash',
  'custModal.methodCard': 'Card',
  'custModal.methodTransfer': 'Transfer',
  'custModal.methodOnline': 'Online',
  'custModal.methodSubscription': 'Subscription',
  'custModal.cash': 'Cash',
  'custModal.terminal': 'Terminal',
  'custModal.transfer': 'Transfer',
  'custModal.online': 'Online',
  'custModal.refund': 'Refund',
  'custModal.sold': 'Sold',
  'custModal.finCharged': 'Charged',
  'custModal.serviceCharges': 'Service charges',
  'custModal.servicesLabel': 'Services',
  'custModal.productCharges': 'Product charges',
  'custModal.productLabel': 'Product',
  'custModal.noProductChargesYet': 'No product sales yet',
  'custModal.time': 'Time',
  'custModal.unknown': 'Unknown',
  // Customer modal — analytics tab
  'custModal.favoriteMaster': 'Favorite specialist',
  'custModal.favoriteService': 'Favorite service',
  'custModal.favoriteProduct': 'Favorite product',
  'custModal.lastActivity': 'Last activity',
  'custModal.spendingBreakdown': 'Spending breakdown',
  'custModal.purchasesByMonth': 'Purchases by month',
  'custModal.churn_low': 'Customer is active',
  'custModal.churn_medium': 'Churn risk — hasn\'t visited in a while',
  'custModal.churn_high': 'High churn risk — contact needed',
  // Customer modal — documents tab
  'custModal.customerDocuments': 'Customer Documents',
  'custModal.addDocument': 'Add document',
  'custModal.addDoc': 'Add',
  'custModal.addBtn': 'Add',
  'custModal.noDocumentsYet': 'No documents yet',
  'custModal.docName': 'Document name',
  'custModal.docNamePlaceholder': 'Enter name...',
  'custModal.docNameRequired': 'Enter document name',
  'custModal.docText': 'Document text',
  'custModal.docTextPlaceholder': 'Enter text...',
  'custModal.attachFile': 'Attach file',
  'custModal.fileUpTo2MB': 'File up to 2 MB',
  'custModal.fileTooLarge': 'File is too large (max 2 MB)',
  'custModal.emptyDocument': 'Empty document',
  'custModal.deleteDoc': 'Delete document',
  'custModal.deleteThisDoc': 'Delete this document?',
  'custModal.deleteBtn': 'Delete',
  'custModal.download': 'Download',
  'custModal.copy': 'Copy',
  'custModal.specifyPhoneForDocs': 'Specify phone for documents',
  'custModal.loading': 'Loading...',
  'custModal.error': 'Error',
  // Customer modal — month abbreviations
  'custModal.monthJan': 'January', 'custModal.monthFeb': 'February', 'custModal.monthMar': 'March',
  'custModal.monthApr': 'April', 'custModal.monthMay': 'May', 'custModal.monthJun': 'June',
  'custModal.monthJul': 'July', 'custModal.monthAug': 'August', 'custModal.monthSep': 'September',
  'custModal.monthOct': 'October', 'custModal.monthNov': 'November', 'custModal.monthDec': 'December',
  'custModal.monthAbbrJan': 'Jan', 'custModal.monthAbbrFeb': 'Feb', 'custModal.monthAbbrMar': 'Mar',
  'custModal.monthAbbrApr': 'Apr', 'custModal.monthAbbrMay': 'May', 'custModal.monthAbbrJun': 'Jun',
  'custModal.monthAbbrJul': 'Jul', 'custModal.monthAbbrAug': 'Aug', 'custModal.monthAbbrSep': 'Sep',
  'custModal.monthAbbrOct': 'Oct', 'custModal.monthAbbrNov': 'Nov', 'custModal.monthAbbrDec': 'Dec',
  'custModal.monthShortJan': 'Jan', 'custModal.monthShortFeb': 'Feb', 'custModal.monthShortMar': 'Mar',
  'custModal.monthShortApr': 'Apr', 'custModal.monthShortMay': 'May', 'custModal.monthShortJun': 'Jun',
  'custModal.monthShortJul': 'Jul', 'custModal.monthShortAug': 'Aug', 'custModal.monthShortSep': 'Sep',
  'custModal.monthShortOct': 'Oct', 'custModal.monthShortNov': 'Nov', 'custModal.monthShortDec': 'Dec',

  // ── Categories page ──
  'categories.title': 'Client Categories',
  'categories.subtitle': 'Manage categories and importance levels',
  'categories.categoriesTab': 'Categories',
  'categories.importanceTab': 'Importance',
  'categories.categoriesDesc': 'Group clients by type',
  'categories.importanceDesc': 'Define client importance levels',
  'categories.addCategory': 'Add category',
  'categories.newCategory': 'New Category',
  'categories.editCategory': 'Edit Category',
  'categories.noCategories': 'No categories yet',
  'categories.categoryName': 'Category name',
  'categories.name': 'Name',
  'categories.namePlaceholder': 'Enter name...',
  'categories.nameDuplicate': 'A category with this name already exists',
  'categories.importanceDuplicate': 'An importance level with this name already exists',
  'categories.icon': 'Icon',
  'categories.changeIcon': 'Change icon',
  'categories.chooseIcon': 'Choose icon',
  'categories.color': 'Color',
  'categories.bgColor': 'Background color',
  'categories.textColor': 'Text color',
  'categories.borderColor': 'Border color',
  'categories.indicatorColor': 'Indicator color',
  'categories.preview': 'Preview',
  'categories.save': 'Save',
  'categories.cancel': 'Cancel',
  'categories.delete': 'Delete',
  'categories.edit': 'Edit',
  'categories.add': 'Add',
  'categories.confirmDelete': 'Are you sure you want to delete?',
  'categories.hasCustomersBlocked': 'This category has clients and cannot be deleted',
  'categories.yes': 'Yes',
  'categories.no': 'No',
  'categories.addLevel': 'Add level',
  'categories.newImportanceLevel': 'New Importance Level',
  'categories.editLevel': 'Edit Level',
  'categories.noImportanceLevels': 'No importance levels yet',
  'categories.levelName': 'Level name',
  'categories.levelPlaceholder': 'Enter level name...',
  'categories.iconBusiness': 'Business',
  'categories.iconClients': 'Clients',
  'categories.iconNature': 'Nature',
  'categories.iconOther': 'Other',
  'categories.iconStatus': 'Status',
  'categories.iconSymbols': 'Symbols',

  // ── Staff page ──
  'staff.title': 'Employees',
  'staff.subtitle': 'Staff management',
  'staff.addStaff': 'Add employee',
  'staff.searchPlaceholder': 'Search by name, position, phone...',
  'staff.activeStaff': 'Active',
  'staff.activeStaffDesc': 'employees',
  'staff.statusActive': 'Active (show in calendar)',
  'staff.statusActiveHidden': 'Active (hide from calendar)',
  'staff.statusDismissed': 'Dismissed',
  'staff.shown': 'Shown',
  'staff.of': 'of',
  'staff.total': 'total',
  'staff.notFound': 'No employees found',
  'staff.notFoundHint': 'Try changing your search query',
  'staff.newStaff': 'New Employee',
  'staff.editStaff': 'Edit Employee',
  'staff.closeEsc': 'Close (Esc)',
  'staff.tabMain': 'General',
  'staff.tabDetails': 'Details',
  'staff.tabServices': 'Services',
  'staff.tabSchedule': 'Schedule',
  'staff.personalData': 'Personal Data',
  'staff.fullName': 'Full name',
  'staff.fullNamePlaceholder': 'Enter full name',
  'staff.nameRequired': 'Name is required',
  'staff.nameDuplicate': 'An employee with this name already exists',
  'staff.phoneDuplicate': 'An employee with this phone number already exists',
  'staff.phone': 'Phone',
  'staff.position': 'Position',
  'staff.positionPlaceholder': 'Enter position...',
  'staff.status': 'Status',
  'staff.active': 'Active',
  'staff.profilePhoto': 'Profile photo',
  'staff.uploadPhoto': 'Upload photo',
  'staff.changePhoto': 'Change photo',
  'staff.avatar': 'Avatar',
  'staff.avatarColor': 'Avatar color',
  'staff.birthDate': 'Date of birth',
  'staff.day': 'Day',
  'staff.month': 'Month',
  'staff.year': 'Year',
  'staff.address': 'Address',
  'staff.addressPlaceholder': 'Enter address...',
  'staff.note': 'Note',
  'staff.notePlaceholder': 'Add a note...',
  'staff.salaryScheme': 'Salary scheme',
  'staff.notSelected': 'Not selected',
  'staff.locations': 'Locations',
  'staff.servicesEmpty': 'No services assigned',
  'staff.servicesHint': 'Select services this employee provides',
  'staff.priceUah': 'Price (UAH)',
  'staff.uah': 'UAH',
  'staff.min': 'min',
  'staff.mins': 'min',
  'staff.workSchedule': 'Work Schedule',
  'staff.dayOff': 'Day Off',
  'staff.save': 'Save',
  'staff.saveChanges': 'Save changes',
  'staff.cancel': 'Cancel',
  'staff.back': 'Back',
  'staff.next': 'Next',
  'staff.add': 'Add',
  'staff.edit': 'Edit',
  'staff.delete': 'Delete',
  'staff.deleteConfirmTitle': 'Delete employee?',
  'staff.deleteForever': 'Delete permanently',
  'staff.hasAppointments': 'Employee has appointments and cannot be deleted',
  'staff.deleteError': 'Could not delete the employee',
  'staff.understood': 'Understood',
  'staff.scheduleConflict': 'Schedule conflict',
  'staff.dayMon': 'Mo', 'staff.dayTue': 'Tu', 'staff.dayWed': 'We',
  'staff.dayThu': 'Th', 'staff.dayFri': 'Fr', 'staff.daySat': 'Sa', 'staff.daySun': 'Su',
  'staff.monthJan': 'January', 'staff.monthFeb': 'February', 'staff.monthMar': 'March',
  'staff.monthApr': 'April', 'staff.monthMay': 'May', 'staff.monthJun': 'June',
  'staff.monthJul': 'July', 'staff.monthAug': 'August', 'staff.monthSep': 'September',
  'staff.monthOct': 'October', 'staff.monthNov': 'November', 'staff.monthDec': 'December',

  // ── Schedule page ──
  'schedule.title': 'Work Schedule',
  'schedule.subtitle': 'Manage employee work schedules',
  'schedule.active': 'Active',
  'schedule.inactive': 'Inactive',
  'schedule.staffMember': 'Employee',
  'schedule.hrsPerWeek': 'Hrs/week',
  'schedule.prevWeek': '\u2190 Previous week',
  'schedule.nextWeek': 'Next week \u2192',
  'schedule.current': 'Current',
  'schedule.working': 'Working',
  'schedule.dayOff': 'Day Off',
  'schedule.noActiveStaff': 'No active employees',
  'schedule.noActiveStaffHint': 'Add employees in the "Staff" section',
  'schedule.scheduleSettings': 'Schedule Settings',
  'schedule.dayType': 'Day type',
  'schedule.workDay': 'Work day',
  'schedule.workHours': 'Work hours',
  'schedule.breaks': 'Breaks',
  'schedule.noBreaks': 'No breaks',
  'schedule.oneBreak': '1 break',
  'schedule.nBreaks': 'breaks',
  'schedule.addBreak': 'Add break',
  'schedule.deleteBreak': 'Delete break',
  'schedule.save': 'Save',
  'schedule.cancel': 'Cancel',
  'schedule.apply': 'Apply',
  'schedule.vacation': 'Vacation',
  'schedule.sickLeave': 'Sick leave',
  'schedule.repeat1': '2 weeks (1 cycle)',
  'schedule.repeatN': '{n} weeks',
  'schedule.repeatWeekly': 'Weekly (year)',
  'schedule.templateAppliedWeeks': 'Template applied for {n} weeks',
  'schedule.scheduleTemplate': 'Schedule Template',
  'schedule.noTemplate': 'No template',
  'schedule.saveTwoWeeksTemplate': 'Save as template (2 weeks)',
  'schedule.templateDuplicate': 'A template with this name already exists',
  'schedule.templateNamePlaceholder': 'Template name...',
  'schedule.scheduleConflict': 'Schedule conflict',
  'schedule.appointmentConflict': 'Cannot change schedule: appointment at {time} ({count} total) falls outside new working hours',
  'schedule.h': 'hrs',
  'schedule.hrs': 'hrs',
  'schedule.min': 'min',
  'schedule.dayMonFull': 'Monday', 'schedule.dayTueFull': 'Tuesday', 'schedule.dayWedFull': 'Wednesday',
  'schedule.dayThuFull': 'Thursday', 'schedule.dayFriFull': 'Friday', 'schedule.daySatFull': 'Saturday', 'schedule.daySunFull': 'Sunday',
  'schedule.dayMon': 'Mo', 'schedule.dayTue': 'Tu', 'schedule.dayWed': 'We',
  'schedule.dayThu': 'Th', 'schedule.dayFri': 'Fr', 'schedule.daySat': 'Sa', 'schedule.daySun': 'Su',

  // ── Schedule templates page ──
  'schedTpl.title': 'Schedule Templates',
  'schedTpl.subtitle': 'Create and manage work schedule templates',
  'schedTpl.templates': 'Templates',
  'schedTpl.newTemplate': 'New Template',
  'schedTpl.noTemplates': 'No templates yet',
  'schedTpl.noTemplatesHint': 'Create a schedule template for quick application',
  'schedTpl.templateSettings': 'Template Settings',
  'schedTpl.templateNamePlaceholder': 'Template name...',
  'schedTpl.dayType': 'Day type',
  'schedTpl.workDay': 'Work day',
  'schedTpl.dayOff': 'Day Off',
  'schedTpl.vacation': 'Vacation',
  'schedTpl.sickLeave': 'Sick Leave',
  'schedTpl.workHours': 'Work hours',
  'schedTpl.breaks': 'Breaks',
  'schedTpl.noBreaks': 'No breaks',
  'schedTpl.addBreak': 'Add break',
  'schedTpl.save': 'Save',
  'schedTpl.cancel': 'Cancel',
  'schedTpl.create': 'Create',
  'schedTpl.delete': 'Delete',
  'schedTpl.rename': 'Rename',
  'schedTpl.deleteTitle': 'Delete template?',
  'schedTpl.deleteMessage': 'You are about to delete this template. This action cannot be undone.',
  'schedTpl.hPerWeek': 'hrs/week',
  'schedTpl.hrs': 'hrs',
  'schedTpl.min': 'min',
  'schedTpl.workShort': 'Work',
  'schedTpl.offShort': 'Off',
  'schedTpl.week1': 'Week 1',
  'schedTpl.week2': 'Week 2',
  'schedTpl.dayMonFull': 'Monday', 'schedTpl.dayTueFull': 'Tuesday', 'schedTpl.dayWedFull': 'Wednesday',
  'schedTpl.dayThuFull': 'Thursday', 'schedTpl.dayFriFull': 'Friday', 'schedTpl.daySatFull': 'Saturday', 'schedTpl.daySunFull': 'Sunday',
  'schedTpl.dayMon': 'Mo', 'schedTpl.dayTue': 'Tu', 'schedTpl.dayWed': 'We',
  'schedTpl.dayThu': 'Th', 'schedTpl.dayFri': 'Fr', 'schedTpl.daySat': 'Sa', 'schedTpl.daySun': 'Su',

  // ── Services page ──
  'services.title': 'Services',
  'services.subtitle': 'Service catalog',
  'services.servicesCount': 'Services',
  'services.groups': 'Groups',
  'services.addService': 'Add service',
  'services.newGroup': 'New group',
  'services.emptyCatalog': 'Service catalog is empty',
  'services.emptyCatalogHint': 'Add a group and services',
  'services.noServicesInGroup': 'No services in this group',
  'services.serviceName': 'Service name',
  'services.durationMin': 'Duration (min)',
  'services.durationMinError': 'Duration must be greater than 0',
  'services.priceUah': 'Price (UAH)',
  'services.priceNegativeError': 'Price cannot be negative',
  'services.nameDuplicate': 'A service with this name already exists',
  'services.groupDuplicate': 'A group with this name already exists',
  'services.min': 'min',
  'services.uah': 'UAH',
  'services.save': 'Save',
  'services.cancel': 'Cancel',
  'services.edit': 'Edit',
  'services.delete': 'Delete',
  'services.renameGroup': 'Rename group',
  'services.deleteGroup': 'Delete group',
  'services.deleteGroupTitle': 'Delete group?',
  'services.deleteGroupMessage': 'All services in this group will also be deleted.',
  'services.deleteServiceTitle': 'Delete service?',
  'services.deleteServiceMessage': 'This action cannot be undone.',
  'services.cannotDelete': 'Cannot delete',
  'services.serviceHasAppointments': 'This service has appointments and cannot be deleted',
  'services.groupHasAppointments': 'This group has services with appointments and cannot be deleted',
  'services.cannotDeleteGroupHasServices': 'Move or delete the services in this group first',
  'services.deleteError': 'Delete failed',
  'services.understood': 'Understood',

  // ── Tariff plans page ──
  'tariffs.title': 'Tariff Plans',
  'tariffs.subtitle': 'Manage tariff plans',
  'tariffs.tariffsCount': 'Tariffs',
  'tariffs.addTariff': 'Add tariff',
  'tariffs.noTariffs': 'No tariff plans',
  'tariffs.newTariffPlan': 'New Tariff Plan',
  'tariffs.editTariff': 'Edit Tariff',
  'tariffs.tariffName': 'Tariff name',
  'tariffs.tariffNamePlaceholder': 'Enter tariff name...',
  'tariffs.nameDuplicate': 'A tariff with this name already exists',
  'tariffs.tariffType': 'Tariff type',
  'tariffs.discount': 'Discount',
  'tariffs.surcharge': 'Surcharge',
  'tariffs.noChange': 'No change',
  'tariffs.priceModifierPercent': 'Price modifier (%)',
  'tariffs.percentModifier': '% modifier',
  'tariffs.modifier': 'Modifier',
  'tariffs.modifierHint': 'Negative value \u2014 discount, positive \u2014 surcharge',
  'tariffs.modifierPlaceholder': 'e.g.: -10 or +15',
  'tariffs.activeCheckbox': 'Active',
  'tariffs.active': 'Active',
  'tariffs.inactive': 'Inactive',
  'tariffs.tabServices': 'Services',
  'tariffs.tabProducts': 'Products',
  'tariffs.servicePrices': 'Service prices',
  'tariffs.customPriceServices': 'Custom service prices',
  'tariffs.customPriceProducts': 'Custom product prices: {n}',
  'tariffs.productPrices': 'Product prices',
  'tariffs.productPricesHint': 'Search and add products to set promotional prices',
  'tariffs.searchProduct': 'Search product by name or SKU...',
  'tariffs.noCategory': 'No category',
  'tariffs.priceList': 'Price list',
  'tariffs.leaveEmptyDefault': 'Leave empty for standard price',
  'tariffs.uah': 'UAH',
  'tariffs.save': 'Save',
  'tariffs.create': 'Create',
  'tariffs.cancel': 'Cancel',
  'tariffs.edit': 'Edit',
  'tariffs.delete': 'Delete',
  'tariffs.deleteConfirm': 'Are you sure you want to delete this tariff?',
  'tariffs.cannotDelete': 'Cannot delete tariff',
  'tariffs.appointmentsCount': 'appointments',
  'tariffs.ordersCount': 'orders',
  'tariffs.yes': 'Yes',
  'tariffs.no': 'No',

  // ── Finances page ──
  'fin.title': 'Financial Operations',
  'fin.subtitle': 'Payment and refund journal',
  'fin.searchPlaceholder': 'Search by client, phone, service...',
  'fin.period': 'Period',
  'fin.today': 'Today',
  'fin.week': 'Week',
  'fin.month': 'Month',
  'fin.from': 'from',
  'fin.to': 'to',
  'fin.allTime': 'All time',
  'fin.typeLabel': 'Type',
  'fin.all': 'All',
  'fin.payments': 'Payments',
  'fin.refunds': 'Refunds',
  'fin.type_all': 'All',
  'fin.type_payment': 'Payment',
  'fin.type_refund': 'Refund',
  'fin.type_product_sale': 'Product sale',
  'fin.methodLabel': 'Payment method',
  'fin.cash': 'Cash',
  'fin.terminal': 'Terminal',
  'fin.transfer': 'Transfer',
  'fin.online': 'Online',
  'fin.subscription': 'Subscription',
  'fin.total': 'Total',
  'fin.uah': 'UAH',
  'fin.exportExcel': 'Export Excel',
  'fin.exportFileName': 'Financial_operations',
  'fin.noOperations': 'No operations',
  'fin.noOperationsHint': 'Try changing the filters or period',
  'fin.colDate': 'Date',
  'fin.colClient': 'Client',
  'fin.colPhone': 'Phone',
  'fin.colService': 'Service',
  'fin.colMaster': 'Specialist',
  'fin.colType': 'Type',
  'fin.colPayMethod': 'Payment method',
  'fin.colMethod': 'Method',
  'fin.colAmount': 'Amount',
  'fin.colSum': 'Sum',
  'fin.colAuthor': 'Author',
  'fin.colReceipt': 'Receipt',
  'fin.service': 'Service',
  'fin.receipt': 'Receipt',
  'fin.receiptNum': 'Receipt #',
  'fin.receiptSubtitle': 'Fiscal receipt',
  'fin.receiptDate': 'Date',
  'fin.receiptClient': 'Client',
  'fin.receiptPhone': 'Phone',
  'fin.receiptMaster': 'Specialist',
  'fin.receiptMethod': 'Payment method',
  'fin.receiptTotal': 'Amount',
  'fin.receiptThanks': 'Thank you for your visit!',
  'fin.printReceipt': 'Print receipt',
  'fin.fiscalCode': 'Fiscal code',
  'fin.noFiscal': 'No fiscal receipt',
  'fin.retryFiscal': 'Retry fiscal receipt',
  'fin.fiscalRetrySuccess': 'Fiscal receipt retried successfully',
  'fin.fiscalRetryError': 'Fiscal receipt retry error',
  'fin.fiscalMarkNotSaved': 'The receipt was issued ({code}), but the mark was not saved. Click again — no new receipt will be issued.',

  // ── Cash register page ──
  'cashReg.title': 'Cash Register',
  'cashReg.subtitle': 'Manage cash register shifts',
  'cashReg.currentShift': 'Current Shift',
  'cashReg.openNewShift': 'Open New Shift',
  'cashReg.openNewShiftHint': 'Shift is not open. Open a shift to accept payments.',
  'cashReg.openingBalance': 'Opening balance',
  'cashReg.openingBalanceLabel': 'Opening cash balance',
  'cashReg.openShift': 'Open Shift',
  'cashReg.closeShift': 'Close Shift',
  'cashReg.prro': 'POS',
  'cashReg.processing': 'Processing...',
  'cashReg.opened': 'Open',
  'cashReg.closed': 'Closed',
  'cashReg.openedAt': 'Opened at',
  'cashReg.openBal': 'Opening bal.',
  'cashReg.closeBal': 'Closing bal.',
  'cashReg.revenue': 'Revenue',
  'cashReg.totalRevenue': 'Total revenue',
  'cashReg.operations': 'Operations',
  'cashReg.inRegister': 'In register',
  'cashReg.cash': 'Cash',
  'cashReg.terminal': 'Terminal',
  'cashReg.transfer': 'Transfer',
  'cashReg.uah': 'UAH',
  'cashReg.shift': 'Shift',
  'cashReg.shiftLog': 'Shift Log',
  'cashReg.historyEmpty': 'Shift history is empty',
  'cashReg.historyEmptyHint': 'Closed shifts will appear here',
  'cashReg.shiftOpened': 'Shift opened',
  'cashReg.shiftClosed': 'Shift closed',
  'cashReg.checkboxNotConfigured': 'To use the cash register, configure Checkbox ПРРО connection in Settings → Checkbox ПРРО',

  // ── Reports page ──
  'reports.reportType_cash_day': 'Revenue by period',
  'reports.reportType_work_hours': 'Work hours',
  'reports.reportType_services_sales': 'Service sales',
  'reports.reportType_mutual': 'Client mutual settlements',
  'reports.reportType_inventory_flow': 'Inventory flow',
  'reports.reportType_client_analytics': 'Client analytics',
  'reports.reportType_staff_revenue': 'Staff revenue',
  'reports.reportType_service_profitability': 'Service profitability',
  'reports.reportType_abc_analysis': 'ABC product analysis',
  'reports.reportType_revenue_dynamics': 'Revenue dynamics',
  'reports.reportType_discount_analytics': 'Discount analytics',
  'reports.reportType_purchases_by_supplier': 'Purchases by supplier',
  'reports.reportType_purchase_dynamics': 'Purchase dynamics',
  'reports.reportType_top_purchased_products': 'Top purchased products',
  'reports.reportType_supplier_price_compare': 'Supplier price comparison',
  'reports.reportType_product_turnover': 'Product turnover',
  'reports.reportType_subscriptions': 'Subscriptions',
  'reports.subsEmpty': 'No subscriptions in the selected period',
  'reports.subsAll': 'All',
  'reports.subsActive': 'Active',
  'reports.subsNearExpiry': 'Near expiry',
  'reports.subsNearExpiryHint': 'expiring in <14 days',
  'reports.subsExpired': 'Expired',
  'reports.subsUsedUp': 'Used up',
  'reports.subsRefunded': 'Refunded',
  'reports.subsRevenue': 'Revenue',
  'reports.subsSold': 'sold',
  'reports.subsUnusedVisits': 'Unused visits',
  'reports.subsUnusedHint': 'in active + expired',
  'reports.subsPurchaseDate': 'Purchase date',
  'reports.subsPlan': 'Plan',
  'reports.subsBoughtVisits': 'Bought',
  'reports.subsUsage': 'Usage',
  'reports.subsPaid': 'Paid',
  'reports.subsValidUntil': 'Valid until',
  'reports.subsStatus': 'Status',
  'reports.reportType_no_shows': 'No-show analytics',
  'reports.nsEmpty': 'No appointments in the selected period',
  'reports.nsTotal': 'Total appointments',
  'reports.nsNoShow': 'No-show',
  'reports.nsCancelled': 'Cancelled',
  'reports.nsLostRevenue': 'Lost revenue',
  'reports.nsRepeatOffenders': 'Repeat offenders (≥2 no-show)',
  'reports.nsByStaff': 'By staff',
  'reports.nsByService': 'By service (top-15 problematic)',
  'reports.nsNoShowPct': 'No-show %',
  'reports.nsCancelPct': 'Cancel %',
  'reports.nsRepeatOffendersTitle': 'Repeat offenders',
  'reports.nsRepeatOffendersHint': '≥2 no-shows in the period',
  'reports.nsLastNoShow': 'Last no-show',
  'reports.reportType_service_profitability': 'Service profitability',
  'reports.reportType_payment_methods': 'Payment methods',
  'reports.reportType_sales_by_channel': 'Sales by channel',
  'reports.reportType_customer_ltv': 'LTV / VIP customers',
  'reports.profitEmpty': 'No services for the selected period',
  'reports.profitRevenue': 'Revenue',
  'reports.profitCost': 'Cost',
  'reports.profitGross': 'Profit',
  'reports.profitMargin': 'Margin',
  'reports.profitVisits': 'Visits',
  'reports.group': 'Group',
  'reports.visits': 'Visits',
  'reports.pmEmpty': 'No transactions for the selected period',
  'reports.tryChangeDate': 'Try changing the period',
  'reports.pmMethod': 'Method',
  'reports.pmCount': 'Transactions',
  'reports.pmAmount': 'Amount',
  'reports.pmShare': 'Share',
  'reports.pmTotalTx': 'Transactions',
  'reports.pmMethodsCount': 'Methods used',
  'reports.pmCash': 'Cash',
  'reports.pmTerminal': 'Terminal',
  'reports.pmOnline': 'Online',
  'reports.pmTransfer': 'Transfer',
  'reports.pmSubscription': 'Subscription',
  'reports.pmGiftCard': 'Gift card',
  'reports.pmPoints': 'Loyalty points',
  'reports.pmUnknown': 'Unspecified',
  'reports.ltvEmpty': 'No customers for the selected period',
  'reports.ltvCustomers': 'Customers',
  'reports.ltvTotalRevenue': 'Total revenue',
  'reports.ltvAvgTicket': 'Average ticket',
  'reports.ltvVip': 'VIP customers (top 20%)',
  'reports.ltvSleepingVip': 'Sleeping VIPs',
  'reports.ltvSleepingHint': '>60 days no visit',
  'reports.ltvTotal': 'Total',
  'reports.ltvLastVisit': 'Last visit',
  'reports.ltvSleepingBadge': '😴 Sleeping VIP',
  'reports.ltvVipBadge': '👑 VIP',
  'reports.reportType_salary_archive': 'Salary archive',
  'reports.reportType_salary_efficiency': 'Staff efficiency (ROI)',
  'reports.reportType_salary_ratio': 'Salary-to-revenue ratio',
  'reports.salaryArchiveEmpty': 'No saved salary records yet',
  'reports.salaryArchiveEmptyHint': 'Calculate salary in the "Salary calc" page — it will appear here.',
  'reports.salaryArchiveMonth': 'Month',
  'reports.salaryArchiveSavedAt': 'Saved',
  'reports.salaryFund': 'Total fund',
  'reports.salaryStaffCount': 'Staff',
  'reports.salaryAvg': 'Average',
  'reports.salaryRevenue': 'Month revenue',
  'reports.salaryScheme': 'Scheme',
  'reports.salaryByRules': 'By rules',
  'reports.salaryAdjustments': 'Adjustments',
  'reports.salaryEffEmpty': 'No salaries computed for the selected period',
  'reports.salaryEffEmptyHint': 'Try a period when salaries are already calculated.',
  'reports.salaryEffRevenue': 'Revenue',
  'reports.salaryEffSalary': 'Salary',
  'reports.salaryEffProfit': 'Margin',
  'reports.salaryEffAvgRoi': 'Avg ROI',
  'reports.salaryEffRoiHint': '>3 healthy, <1.5 problem',
  'reports.salaryRatioEmpty': 'No salary history yet',
  'reports.salaryRatioCurrent': 'Current ratio',
  'reports.salaryRatioAvg': 'Period average',
  'reports.salaryRatioTrend': 'Change vs previous month',
  'reports.salaryRatioHealthy': 'Healthy range',
  'reports.salaryRatioHealthyHint': 'for beauty business',
  'reports.salaryRatioPct': 'Ratio',
  'reports.loading': 'Loading…',
  'reports.reportType_sales_managers': 'Sales managers',
  'reports.smEmpty': 'No orders for the selected period',
  'reports.smUnknown': '— Unspecified',
  'reports.smManagersCount': 'Managers',
  'reports.smOrdersCreated': 'Orders created',
  'reports.smDelivered': 'Delivered',
  'reports.smNetRevenue': 'Net revenue',
  'reports.smAvgCheck': 'Avg ticket',
  'reports.smManager': 'Manager',
  'reports.smCreated': 'Created',
  'reports.smCancelled': 'Cancelled',
  'reports.smReturned': 'Returns',
  'reports.smCancelRate': 'Cancel %',
  'reports.smReturnRate': 'Return %',
  'reports.smAvgTime': 'Days to delivery',
  'reports.reportType_admin_activity': 'Admin activity',
  'reports.aaEmpty': 'No createdBy activity for the selected period',
  'reports.aaAdmins': 'Active admins',
  'reports.aaTotalApts': 'Apts created',
  'reports.aaTotalProcessed': 'Money processed',
  'reports.aaSubsRevenue': 'Subscription revenue',
  'reports.aaAdmin': 'Admin',
  'reports.aaApts': 'Apts',
  'reports.aaConfirmed': 'Confirmed',
  'reports.aaNoShowPct': 'No-show %',
  'reports.aaTx': 'Tx',
  'reports.aaProcessed': 'Amount',
  'reports.aaSubsSold': 'Subs',
  'reports.aaSubsRev': 'Subs ₴',
  'reports.aaDiscounts': 'Discounts ₴',
  'reports.groupSales': 'Revenue & Sales',
  'reports.groupCustomers': 'Customers',
  'reports.groupStaff': 'Staff & Salaries',
  'reports.groupLoyalty': 'Loyalty & Promos',
  'reports.groupInventory': 'Inventory',
  'reports.groupProcurement': 'Procurement',
  'reports.reportType_loyalty_points': 'Loyalty points',
  'reports.reportType_coupons': 'Coupons',
  'reports.lpEmpty': 'No loyalty activity for the selected period',
  'reports.lpEarned': 'Earned',
  'reports.lpRedeemed': 'Redeemed',
  'reports.lpReversed': 'Reversed',
  'reports.lpReversedHint': 'refunds / cancellations',
  'reports.lpNet': 'Net for period',
  'reports.lpSourcesTitle': 'Where points came from (earn)',
  'reports.lpSource': 'Source',
  'reports.lpPoints': 'Points',
  'reports.lpShare': 'Share',
  'reports.lpRefService': 'Services',
  'reports.lpRefProduct': 'Products',
  'reports.lpRefOrder': 'Orders',
  'reports.lpRefReferral': 'Referrals',
  'reports.lpRefBirthday': 'Birthday',
  'reports.lpRefManual': 'Manual',
  'reports.lpRefSubscription': 'Subscription',
  'reports.lpRefOther': 'Other',
  'reports.cpEmpty': 'You have no coupons yet',
  'reports.cpEmptyHint': 'Add coupons in Loyalty to see stats here.',
  'reports.cpTotal': 'Total coupons',
  'reports.cpUsedInPeriod': 'Used in period',
  'reports.cpDiscount': 'Discount given',
  'reports.cpOrderAmount': 'Revenue with coupons',
  'reports.cpCode': 'Code',
  'reports.cpType': 'Type',
  'reports.cpValue': 'Value',
  'reports.cpUsage': 'Used',
  'reports.cpInPeriod': 'In period',
  'reports.cpOrderSum': 'Revenue ₴',
  'reports.cpStatus': 'Status',
  'reports.cpStatusActive': 'Active',
  'reports.cpStatusExpired': 'Expired',
  'reports.cpStatusExhausted': 'Exhausted',
  'reports.cpStatusDisabled': 'Disabled',
  'reports.reportType_production_runs': 'Production runs',
  'reports.reportType_cash_shifts_report': 'Cash shifts',
  'reports.reportType_heatmap_dow_hour': 'Heatmap day × hour',
  'reports.prEmpty': 'No production runs in the selected period',
  'reports.prRuns': 'Runs',
  'reports.prCancelled': 'cancelled',
  'reports.prOutputQty': 'Output quantity',
  'reports.prInputCost': 'Input cost',
  'reports.prAvgUnitCost': 'Avg unit cost',
  'reports.prRecipe': 'Recipe',
  'reports.csEmpty': 'No cash shifts in the selected period',
  'reports.csEmptyHint': 'Cash shifts sync with Checkbox.',
  'reports.csShifts': 'Shifts',
  'reports.csCash': 'Cash',
  'reports.csCard': 'Card',
  'reports.csAvgDuration': 'Avg duration',
  'reports.csDiscrep': 'With discrepancy',
  'reports.csOpened': 'Opened',
  'reports.csClosed': 'Closed',
  'reports.csLocation': 'Location',
  'reports.csOpenBal': 'Open ₴',
  'reports.csCloseBal': 'Close ₴',
  'reports.csDiff': 'Δ',
  'reports.csOpen': 'Open',
  'reports.hmEmpty': 'No appointments in the selected period',
  'reports.hmTotal': 'Total appointments',
  'reports.hmPeak': 'Peak hour',
  'reports.hmTopDay': 'Top day',
  'reports.hmRecords': 'records',
  'reports.hmLow': 'Low',
  'reports.hmMedium': 'Medium',
  'reports.hmHigh': 'High',
  'reports.hmPeakLegend': 'Peak',
  'reports.dowMon': 'Mon',
  'reports.dowTue': 'Tue',
  'reports.dowWed': 'Wed',
  'reports.dowThu': 'Thu',
  'reports.dowFri': 'Fri',
  'reports.dowSat': 'Sat',
  'reports.dowSun': 'Sun',
  'reports.period_day': 'Day',
  'reports.period_week': 'Week',
  'reports.period_month': 'Month',
  'reports.period_year': 'Year',
  'reports.period_custom': 'Custom',
  'period.today': 'Today',
  'period.yesterday': 'Yesterday',
  'period.thisWeek': 'This week',
  'period.lastWeek': 'Last week',
  'period.thisMonth': 'This month',
  'period.lastMonth': 'Last month',
  'period.thisQuarter': 'This quarter',
  'period.thisYear': 'This year',
  'period.last30': 'Last 30 days',
  'period.last90': 'Last 90 days',
  'period.custom': 'Custom',
  'reports.title': 'Reports',
  'reports.subtitle': 'Analytics and reporting',
  'reports.allStaff': 'All employees',
  'reports.allClients': 'All clients',
  'reports.allCategories': 'All categories',
  'reports.allProducts': 'All products',
  'reports.allLocations': 'All locations',
  'reports.appointments': 'Appointments',
  'reports.clients': 'Clients',
  'reports.masters': 'Specialists',
  'reports.revenue': 'Revenue',
  'reports.service': 'Service',
  'reports.serviceOrProduct': 'Product/Service',
  'reports.client': 'Client',
  'reports.master': 'Specialist',
  'reports.date': 'Date',
  'reports.dateTime': 'Date/time',
  'reports.time': 'Time',
  'reports.duration': 'Duration',
  'reports.price': 'Price',
  'reports.discount': 'Discount',
  'reports.paid': 'Paid',
  'reports.payment': 'Payment',
  'reports.method': 'Method',
  'reports.cash': 'Cash',
  'reports.online': 'Online',
  'reports.total': 'Total',
  'reports.grandTotal': 'Grand total',
  'reports.sum': 'Sum',
  'reports.position': 'Position',
  'reports.positions': 'positions',
  'reports.product': 'Product',
  'reports.category': 'Category',
  'reports.qty': 'Qty',
  'reports.pcs': 'pcs',
  'reports.cost': 'Cost',
  'reports.balance': 'Balance',
  'reports.debt': 'Debt',
  'reports.charges': 'Charges',
  'reports.productCharges': 'Product charges',
  'reports.serviceRefunds': 'Service refunds',
  'reports.subscriptionVisit': 'Subscription visit',
  'reports.charged': 'Charged',
  'reports.visits': 'Visits',
  'reports.days': 'days',
  'reports.hrs': 'hrs',
  'reports.min': 'min',
  'reports.avgCheck': 'Avg check',
  'reports.avgDuration': 'Avg duration',
  'reports.totalClients': 'Total clients',
  'reports.totalHours': 'Total hours',
  'reports.servicesSold': 'Services provided',
  'reports.withDiscount': 'With discount',
  'reports.utilization': 'Utilization',
  'reports.worked': 'Worked',
  'reports.workingHours': 'Working hours',
  'reports.noVisitDays': 'Days without visit',
  'reports.forOrder': 'For order',
  'reports.mainRegister': 'Main register',
  'reports.settlementAccount': 'Settlement account',
  'reports.other': 'Other',
  'reports.incoming': 'Incoming',
  'reports.incomingQty': 'Incoming qty',
  'reports.incomingSum': 'Incoming sum',
  'reports.incomings': 'Incomings',
  'reports.writeoff': 'Write-off',
  'reports.writeoffsExpenses': 'Write-offs/expenses',
  'reports.writtenOff': 'Written off',
  'reports.writtenOffQty': 'Write-off qty',
  'reports.writtenOffSum': 'Write-off sum',
  'reports.remainQty': 'Remaining qty',
  'reports.remainSum': 'Remaining sum',
  'reports.transferMove': 'Transfer',
  'reports.together': 'Total',
  'reports.subscriptionPurchase': 'Subscription purchase',
  'reports.exportExcel': 'Export to Excel',
  'reports.exportPdf': 'Print / PDF',
  'reports.print': 'Print',
  'reports.noService': 'No service',
  'reports.noDataForPeriod': 'No data for the selected period',
  'reports.noCompletedForPeriod': 'No completed appointments for the selected period',
  'reports.noRecordsForPeriod': 'No records for the selected period',
  'reports.noInventoryForPeriod': 'No inventory data for the selected period',
  'reports.segment_all': 'All',
  'reports.segment_no30': 'No visit 30+ days',
  'reports.segment_new': 'New',
  'reports.segment_vip': 'VIP',
  'reports.segment_once': 'One-time',
  'reports.segment_services_only': 'Services only',
  'reports.segment_products_only': 'Products only',
  'reports.ordersCol': 'Orders',
  'reports.productContactsCol': 'Prod. orders',
  'reports.serviceContactsCol': 'Serv. orders',
  'reports.servicesIncome': 'Services ₴',
  'reports.productsIncome': 'Products ₴',
  'reports.lastContact': 'Last contact',
  'reports.operations': 'Operations',
  'reports.noClientsInSegment': 'No clients in this segment',
  'reports.tryChangeDateOrStaff': 'Try changing the date or employee',
  'reports.tryChangeDateOrFilters': 'Try changing the date or filters',
  'reports.tryChangeDateOrClient': 'Try changing the date or client',
  'reports.servicesRevenue': 'Services revenue',
  'reports.productSales': 'Product sales',
  'reports.totalRevenue': 'Total revenue',
  'reports.share': 'Share',
  'reports.materialCosts': 'Material costs',
  'reports.margin': 'Margin',
  'reports.abcClass': 'Class',
  'reports.abcLeaders': 'leaders',
  'reports.abcMiddle': 'middle',
  'reports.abcSlow': 'slow movers',
  'reports.avgPerDay': 'Avg per day',
  'reports.discountCount': 'Discount count',
  'reports.discountSum': 'Discount amount',
  'reports.discountShare': 'Discount share',
  'reports.noDiscountsForPeriod': 'No discounts for the selected period',
  'reports.grossPrice': 'Gross price',
  'reports.avgDiscount': 'Avg discount',
  'reports.supplier': 'Supplier',
  'reports.allSuppliers': 'All suppliers',
  'reports.suppliersCount': 'Suppliers',
  'reports.invoices': 'Invoices',
  'reports.avgPrice': 'Avg price',
  'reports.noPurchasesForPeriod': 'No purchases for the selected period',
  'reports.productUnits': 'Product units',
  'reports.invoiceCount': 'Invoice count',
  'reports.netto': 'Net',
  'reports.peakDay': 'Peak',
  'reports.purchases': 'Purchases',
  'reports.categories': 'Categories',
  'reports.remainder': 'Remainder',
  'reports.ordered': 'Ordered',
  'reports.returned': 'Returned',
  'reports.received': 'Received',
  'reports.productsCompared': 'Products compared',
  'reports.noPriceComparison': 'No comparison data available',
  'reports.needMultipleSuppliers': 'Need purchases of one product from different suppliers',
  'reports.turnoverRatio': 'Turnover',
  'reports.turnoverStatus': 'Status',
  'reports.highTurnover': 'High',
  'reports.medTurnover': 'Medium',
  'reports.lowTurnover': 'Low',

  // ── Financial result page ──
  'finResult.month_jan': 'January', 'finResult.month_feb': 'February', 'finResult.month_mar': 'March',
  'finResult.month_apr': 'April', 'finResult.month_may': 'May', 'finResult.month_jun': 'June',
  'finResult.month_jul': 'July', 'finResult.month_aug': 'August', 'finResult.month_sep': 'September',
  'finResult.month_oct': 'October', 'finResult.month_nov': 'November', 'finResult.month_dec': 'December',
  'finResult.sourceDeleted': 'This document has been removed from the system',
  'finResult.title': 'Financial Result',
  'finResult.subtitle': 'Income and expense analysis',
  'finResult.allLocations': 'All locations',
  'finResult.income': 'Income',
  'finResult.incomes': 'Income',
  'finResult.expenses': 'Expenses',
  'finResult.financialResult': 'Financial Result',
  'finResult.profitability': 'Profitability',
  'finResult.sales': 'Sales',
  'finResult.servicesCompleted': 'Services provided',
  'finResult.productSales': 'Product sales',
  'finResult.orderProductSales': 'Product sales (shipments)',
  'finResult.posProductSales': 'Product sales (POS / retail)',
  'finResult.aptProductSales': 'Product sales in services',
  'finResult.subscriptions': 'Subscriptions',
  'finResult.refunds': 'refunds',
  'finResult.cogsOrders': 'COGS — shipments',
  'finResult.cogsAppointments': 'COGS — services',
  'finResult.cogsPos': 'COGS — retail',
  'finResult.cogsWriteoffs': 'COGS (other write-offs)',
  'finResult.orders': 'Orders',
  'finResult.visits': 'Visits',
  'finResult.salaries': 'Salaries',
  'finResult.addExpense': 'Add expense',
  'finResult.otherIncome': 'Other income',
  'finResult.addOtherIncome': 'Add other income',
  'finResult.incomeName': 'Income name',
  'finResult.deleteIncomeConfirm': 'Delete this income entry?',
  'finResult.exportExcel': 'Export to Excel',
  'finResult.add': 'Add',
  'finResult.cancel': 'Cancel',
  'finResult.delete': 'Delete',
  'finResult.expenseName': 'Expense name',
  'finResult.expenseSum': 'Amount',
  'finResult.monthly': 'Monthly',
  'finResult.monthlyOption': 'Monthly',
  'finResult.oneTime': 'One-time',
  'finResult.oneTimeOption': 'One-time',
  'finResult.deleteExpenseTitle': 'Delete expense?',
  'finResult.deleteExpenseConfirm': 'Are you sure you want to delete this expense?',
  'finResult.notCalculated': 'Not calculated',
  'finResult.print': 'Print',
  'finResult.printPdf': 'Print PDF',
  'finResult.dynamics6months': 'Dynamics over 6 months',
  'finResult.expenseStructure': 'Expense structure',
  'finResult.incomeStructure': 'Income structure',
  'finResult.donutServices': 'Services',
  'finResult.donutProducts': 'Goods',
  'finResult.noIncomeYet': 'No income yet this month',
  'finResult.salaryFundTitle': 'Salary fund structure',
  'finResult.salaryNotCalculated': 'Salaries for this month are not calculated yet',
  'finResult.salaryNoData': 'No data to display',
  'finResult.fundSalary': 'Fixed salary',
  'finResult.fundPercent': 'Percentage',
  'finResult.fundHybrid': 'Per-action fixed',
  'finResult.vsPrev': 'vs prev',
  'finResult.cashFlowTitle': 'Cash flow (daily)',
  'finResult.cashFlowEmpty': 'No transactions yet this month',
  'finResult.cashFlowReceipts': 'Receipts',
  'finResult.cashFlowRefunds': 'Refunds',
  'finResult.cashFlowNet': 'Net flow',
  'finResult.groupCogsProducts': 'Cost of goods',
  'finResult.groupSalaries': 'Salaries',
  'finResult.groupFixed': 'Fixed costs',
  'finResult.groupOther': 'Write-offs & other',
  'finResult.noExpensesYet': 'No expenses this month yet',
  'finResult.effectiveFrom': 'Effective from',
  'finResult.edit': 'Edit',
  'finResult.save': 'Save',
  'finResult.applyForwardOnly': 'Apply only from the chosen month forward (keep old amount for past months)',
  'finResult.total': 'Total',
  'finResult.hintAddNew': 'Expense will apply from {month} forward (until you change it).',
  'finResult.hintMutateSingle': 'Amount will be updated for: {month}',
  'finResult.hintMutateRange': 'Amount will be updated for: {from} — {to}',
  'finResult.hintMutateForward': 'Amount will be updated for: {month} and all following months',
  'finResult.hintSplit': 'A new version will be created from {newMonth}. Previous months ({oldFrom} — {oldTo}) will keep {oldAmount} ₴.',

  // ── Inventory products page ──
  'invProd.title': 'Products',
  'invProd.subtitle': 'Manage products, categories, and warehouses',
  'invProd.tabProducts': 'Products',
  'invProd.tabCategories': 'Categories',
  'invProd.tabWarehouses': 'Warehouses',
  'invProd.statProducts': 'Products',
  'invProd.statCategories': 'Categories',
  'invProd.statWarehouses': 'Warehouses',
  'invProd.productsCount': 'Products',
  'invProd.positionsCount': 'Positions',
  'invProd.searchPlaceholder': 'Search by name, SKU...',
  'invProd.allCategories': 'All categories',
  'invProd.addProduct': 'Add product',
  'invProd.newProduct': 'New Product',
  'invProd.editProduct': 'Edit Product',
  'invProd.emptyProducts': 'No products yet',
  'invProd.emptyProductsHint': 'Add your first product',
  'invProd.emptyCategories': 'Create your first product category',
  'invProd.emptyCategoriesHint': 'Categories help organize products and find what you need quickly',
  'invProd.emptyWarehouses': 'Add your first warehouse',
  'invProd.emptyWarehousesHint': 'Warehouses are needed to track stock and process purchases',
  'invProd.colName': 'Name',
  'invProd.colSku': 'SKU',
  'invProd.colCategory': 'Category',
  'invProd.colUnit': 'Unit',
  'invProd.colStock': 'Stock',
  'invProd.colMin': 'Min',
  'invProd.colSellPrice': 'Sale price',
  'invProd.labelName': 'Name',
  'invProd.labelSku': 'SKU',
  'invProd.labelCategory': 'Category',
  'invProd.labelUnit': 'Unit of measure',
  'invProd.labelMinStock': 'Min stock',
  'invProd.labelSellPrice': 'Sale price',
  'invProd.labelImageUrl': 'Image URL',
  'invProd.labelImage': 'Product photo',
  'invProd.uploadImage': 'Upload photo',
  'invProd.maxSize': 'up to 200 KB',
  'invProd.pasteUrl': 'Or paste URL',
  'invProd.noCategory': 'No category',
  'invProd.unitPcs': 'pcs',
  'invProd.unitG': 'g',
  'invProd.unitKg': 'kg',
  'invProd.unitMl': 'ml',
  'invProd.unitL': 'l',
  'invProd.unitPack': 'pack',
  'invProd.save': 'Save',
  'invProd.cancel': 'Cancel',
  'invProd.publishOnOlx': 'Publish on OLX',
  'invProd.olxPublished': 'OLX: listing created',
  'olxPublish.title': 'Publish on OLX',
  'olxPublish.alreadyPublished': 'This product already has an OLX listing. Publishing again creates a second listing.',
  'olxPublish.openAdvert': 'Open listing',
  'olxPublish.fieldTitle': 'Listing title',
  'olxPublish.fieldDescription': 'Description',
  'olxPublish.descriptionHint': 'OLX usually requires ~80+ characters. Describe what the item is, condition, details.',
  'olxPublish.fieldCategory': 'Category',
  'olxPublish.suggesting': 'Picking a category from the title…',
  'olxPublish.noCategorySuggestions': 'Could not suggest a category automatically. Refine the title or enter an ID below.',
  'olxPublish.orManualCategoryId': 'or enter OLX category ID',
  'olxPublish.fieldCity': 'City',
  'olxPublish.cityPlaceholder': 'Start typing, e.g. "Kyiv"',
  'olxPublish.searching': 'Searching…',
  'olxPublish.fieldPrice': 'Price',
  'olxPublish.fieldPhotoUrl': 'Photo URL',
  'olxPublish.fieldContactName': 'Contact name',
  'olxPublish.contactNamePlaceholder': 'How to sign the listing',
  'olxPublish.fieldContactPhone': 'Phone',
  'olxPublish.errorTitle': 'OLX returned an error:',
  'olxPublish.showRawError': 'Show full OLX response',
  'olxPublish.categoryAttrsTitle': 'OLX requires extra fields for this category:',
  'olxPublish.loadingAttrs': 'Loading category fields…',
  'olxPublish.choose': 'choose',
  'olxPublish.fieldDistrict': 'District',
  'olxPublish.loadingDistricts': 'Loading districts of the city…',
  'olxPublish.success': 'Listing created, sent to OLX moderation',
  'olxPublish.cancel': 'Cancel',
  'olxPublish.publish': 'Publish',
  'invProd.add': 'Add',
  'invProd.addCategory': 'Add category',
  'invProd.addWarehouse': 'Add warehouse',
  'invProd.categoryName': 'Category name',
  'invProd.warehouseName': 'Warehouse name',
  'invProd.warehouseDesc': 'Description',
  'invProd.warehouseDescPlaceholder': 'Address, notes...',
  'invProd.delete': 'Delete',
  'invProd.deleteProduct': 'Delete product',
  'invProd.deleteCategory': 'Delete category',
  'invProd.deleteWarehouse': 'Delete warehouse',
  'invProd.deleteConfirmMsg': 'Are you sure you want to delete?',
  'invProd.cannotDelete': 'Cannot delete',
  'invProd.errName': 'Enter a name',
  'invProd.nameDuplicate': 'A product with this name already exists',
  'invProd.catDuplicate': 'A category with this name already exists',
  'invProd.whDuplicate': 'A warehouse with this name already exists',
  'invProd.understood': 'Understood',
  'invProd.newCategoryPlaceholder': 'New category name',
  'invProd.newWarehousePlaceholder': 'New warehouse name',
  'invProd.blockProduct': 'Products',
  'invProd.blockCategory': 'Categories',
  'invProd.blockWarehouse': 'Warehouses',

  // ── Inventory stock page ──
  'invStock.title': 'Stock',
  'invStock.subtitle': 'Stock level control',
  'invStock.statProducts': 'Products',
  'invStock.statLow': 'Low stock',
  'invStock.searchPlaceholder': 'Search by name...',
  'invStock.allCategories': 'All categories',
  'invStock.allWarehouses': 'All warehouses',
  'invStock.lowStockOnly': 'Low stock only',
  'invStock.emptyTitle': 'No data',
  'invStock.emptyHint': 'Add products in the "Products" section',
  'invStock.colProduct': 'Product',
  'invStock.colCategory': 'Category',
  'invStock.colUnit': 'Unit',
  'invStock.colTotal': 'Stock',
  'invStock.colMin': 'Min',
  'invStock.colStatus': 'Status',
  'invStock.statusLow': 'Low',
  'invStock.statusEmpty': 'Empty',
  'invStock.available': 'Available',
  'invStock.transfer': 'Transfer',
  'invStock.transferTitle': 'Product Transfer',
  'invStock.transferBtn': 'Transfer',
  'invStock.labelProduct': 'Product',
  'invStock.labelFromWarehouse': 'From warehouse',
  'invStock.labelToWarehouse': 'To warehouse',
  'invStock.labelQuantity': 'Quantity',
  'invStock.cancel': 'Cancel',

  // ── Inventory purchases page ──
  'invPurch.title': 'Purchases',
  'invPurch.subtitle': 'Product purchase tracking',
  'invPurch.statPurchases': 'Purchases',
  'invPurch.searchPlaceholder': 'Search by supplier...',
  'invPurch.newPurchase': 'New purchase',
  'invPurch.emptyTitle': 'No purchases yet',
  'invPurch.emptyHint': 'Create your first purchase',
  'invPurch.colDate': 'Date',
  'invPurch.colSupplier': 'Supplier',
  'invPurch.colWarehouse': 'Warehouse',
  'invPurch.colItems': 'Items',
  'invPurch.colTotal': 'Total',
  'invPurch.modalTitle': 'New Purchase',
  'invPurch.labelSupplier': 'Supplier',
  'invPurch.supplierPlaceholder': 'Enter supplier name...',
  'invPurch.labelDestWarehouse': 'Destination warehouse',
  'invPurch.sectionProducts': 'Products',
  'invPurch.selectProduct': 'Select product',
  'invPurch.searchProduct': 'Search product...',
  'invPurch.noProducts': 'No products found',
  'invPurch.addItem': 'Add product',
  'invPurch.qty': 'Qty',
  'invPurch.pricePerUnit': 'Price per unit',
  'invPurch.totalSum': 'Total sum',
  'invPurch.pos': 'positions',
  'invPurch.units': 'units',
  'invPurch.receive': 'Receive',
  'invPurch.cancel': 'Cancel',
  'invPurch.errWarehouse': 'Select a warehouse',
  'invPurch.errItems': 'Add at least one product',
  'invPurch.errNegPrice': 'Price cannot be negative',
  'invPurch.errZeroPrice': 'Enter purchase price for each product',
  'invPurch.periodWeek': 'Week',
  'invPurch.periodMonth': 'Month',
  'invPurch.periodYear': 'Year',
  'invPurch.periodAll': 'All time',
  'invPurch.periodCustom': 'Custom',
  'invPurch.returnToSupplier': 'Return to supplier',
  'invPurch.returnTitle': 'Return to supplier',
  'invPurch.returnHint': 'Specify quantities to return',
  'invPurch.returnAmount': 'Return amount',
  'invPurch.confirmReturn': 'Return',
  'invPurch.returnSuccess': 'Return completed',
  'invPurch.returnLookupError': 'Could not check earlier returns',
  'invPurch.returnSaveError': 'Could not save the return',
  'invPurch.allReturned': 'All items already returned or out of stock',
  'invPurch.deletePurchase': 'Delete purchase',
  'invPurch.deleteTitle': 'Delete purchase',
  'invPurch.deleteWarning': 'Are you sure? The following items will be reversed from stock:',
  'invPurch.deleteStockNote': 'Stock quantities will be reduced accordingly.',
  'invPurch.deleteConfirm': 'Delete',
  'invPurch.deleteBlockedTitle': 'Deletion not possible',
  'invPurch.deleteBlockedText': 'This purchase cannot be deleted because there are later movements for these products:',
  'invPurch.deleteBlockedHint': 'First delete or cancel the later operations, then try again.',
  'invPurch.understood': 'Understood',

  // ── Tabs ──
  'invPurch.tabPurchases': 'Product receipts',
  'invPurch.tabSuppliers': 'Suppliers',
  'invPurch.selectSupplier': 'Select supplier',

  // ── Suppliers ──
  'invPurch.searchSupplier': 'Search supplier...',
  'invPurch.newSupplier': 'New supplier',
  'invPurch.editSupplier': 'Edit supplier',
  'invPurch.statSuppliers': 'suppliers',
  'invPurch.emptySuppliersTitle': 'No suppliers yet',
  'invPurch.emptySuppliersHint': 'Add suppliers for convenient purchase tracking',
  'invPurch.colSupplierName': 'Name',
  'invPurch.colContact': 'Contact person',
  'invPurch.colPhone': 'Phone',
  'invPurch.colEdrpou': 'Tax ID',
  'invPurch.supplierDuplicate': 'A supplier with this name already exists',
  'invPurch.supplierName': 'Name',
  'invPurch.supplierNamePh': 'LLC "Supplier"',
  'invPurch.contactPerson': 'Contact person',
  'invPurch.contactPersonPh': 'Last name First name',
  'invPurch.phone': 'Phone',
  'invPurch.email': 'Email',
  'invPurch.bankDetails': 'Bank details',
  'invPurch.edrpou': 'Tax ID',
  'invPurch.mfo': 'Bank code',
  'invPurch.iban': 'IBAN / Account number',
  'invPurch.supplierNotes': 'Notes',
  'invPurch.supplierNotesPh': 'Additional info about supplier...',
  'invPurch.create': 'Create',
  'invPurch.deleteSupplierTitle': 'Delete supplier?',
  'invPurch.deleteSupplierWarning': 'Are you sure you want to delete supplier',

  // ── Inventory movements page ──
  'invMov.title': 'Stock Movements',
  'invMov.subtitle': 'Stock movement history',
  'invMov.statOperations': 'Operations',
  'invMov.filterType': 'Type',
  'invMov.filterAll': 'All',
  'invMov.filterPurchase': 'Purchase',
  'invMov.filterWriteoff': 'Write-off',
  'invMov.filterTransfer': 'Transfer',
  'invMov.filterAppointment': 'Appointment',
  'invMov.filterOrder': 'Order',
  'invMov.filterReturn': 'Return',
  'invMov.filterAllProducts': 'All products',
  'invMov.emptyTitle': 'No operations',
  'invMov.emptyHint': 'All product operations will be displayed here',
  'invMov.colDate': 'Date',
  'invMov.colType': 'Type',
  'invMov.colProduct': 'Product',
  'invMov.colQty': 'Qty',
  'invMov.colCost': 'Cost',
  'invMov.colWarehouse': 'Warehouse',
  'invMov.colAuthor': 'Author',
  'invMov.colDetails': 'Details',
  'invMov.typePurchase': 'Purchase',
  'invMov.typeWriteoff': 'Write-off',
  'invMov.typeTransfer': 'Transfer',
  'invMov.typeAppointment': 'Appointment',
  'invMov.typeSale': 'Sale',
  'invMov.typeOrder': 'Order',
  'invMov.typeOrderCancel': 'Order cancellation',
  'invMov.typeSaleCancel': 'Sale cancellation',
  'invMov.typeAppointmentCancel': 'Appointment cancellation',
  'invMov.typeReturn': 'Return',
  'invMov.typePurchaseReturn': 'Return to supplier',
  'invMov.supplier': 'Supplier',
  'invMov.writeoffTitle': 'Product Write-off',
  'invMov.writeoffBtn': 'Write off',
  'invMov.writeoffConfirm': 'Confirm write-off',
  'invMov.labelProduct': 'Product',
  'invMov.labelQuantity': 'Quantity',
  'invMov.labelWarehouse': 'Warehouse',
  'invMov.labelReason': 'Reason',
  'invMov.labelNote': 'Note',
  'invMov.available': 'Available',
  'invMov.cancel': 'Cancel',
  'invMov.reasonExpired': 'Expired',
  'invMov.reasonDamaged': 'Damaged',
  'invMov.reasonLost': 'Lost',
  'invMov.reasonUsed': 'Used',
  'invMov.reasonOther': 'Other',

  // ── Salary calculation page ──
  'salCalc.month_jan': 'January', 'salCalc.month_feb': 'February', 'salCalc.month_mar': 'March',
  'salCalc.month_apr': 'April', 'salCalc.month_may': 'May', 'salCalc.month_jun': 'June',
  'salCalc.month_jul': 'July', 'salCalc.month_aug': 'August', 'salCalc.month_sep': 'September',
  'salCalc.month_oct': 'October', 'salCalc.month_nov': 'November', 'salCalc.month_dec': 'December',
  'salCalc.title': 'Salary Calculation',
  'salCalc.subtitle': 'Payroll calculation',
  'salCalc.selectMonthHint': 'Select a month for calculation',
  'salCalc.calculate': 'Calculate',
  'salCalc.save': 'Save',
  'salCalc.loadSaved': 'Load saved',
  'salCalc.exportExcel': 'Export Excel',
  'salCalc.staffCount': 'Employees',
  'salCalc.staffWithSchemes': 'With schemes',
  'salCalc.allStaff': 'All',
  'salCalc.noDataTitle': 'No data',
  'salCalc.noDataDesc': 'Select a month and click "Calculate"',
  'salCalc.noStaffTitle': 'No employees',
  'salCalc.noStaffDesc': 'Add employees in the "Staff" section',
  'salCalc.totalByRules': 'By rules',
  'salCalc.manualAdjustments': 'Adjustments',
  'salCalc.totalLabel': 'Total',
  'salCalc.grandTotal': 'Grand total',
  'salCalc.adjustments': 'Adjustments',
  'salCalc.addAdjustment': 'Add adjustment',
  'salCalc.adjDescPlaceholder': 'Description...',
  'salCalc.adjAmountPlaceholder': 'Amount',
  'salCalc.edit': 'Edit',
  'salCalc.back': 'Back',
  'salCalc.cancel': 'Cancel',
  'salCalc.saved': 'Saved',
  'salCalc.savedNotice': 'Calculation saved',
  'salCalc.overwriteTitle': 'Overwrite?',
  'salCalc.overwriteDesc': 'A saved calculation already exists for this month. Overwrite?',
  'salCalc.overwrite': 'Overwrite',
  'salCalc.hourlyRate': 'Rate per hour',
  'salCalc.monthlySalary': 'Monthly salary',
  'salCalc.monthlyFixed': 'fixed per month',
  'salCalc.tiered': 'tiered',
  'salCalc.dailyRate': 'Rate per work day',
  'salCalc.fixedPerAppointment': 'Bonus per completed appointment',
  'salCalc.percentOwnServices': '% of provided services',
  'salCalc.percentTotalRevenue': '% of total revenue',
  'salCalc.percentOwnProductSales': '% of own sales',
  'salCalc.percentAllProductSales': '% of all location sales',
  'salCalc.percentCreatedAppointments': '% of booked clients',
  'salCalc.fixedPerCreatedAppointment': 'Bonus per booked client',
  'salCalc.percentOwnMaterials': '% of used materials',
  'salCalc.percentAllServices': '% of all location services',
  'salCalc.hours': 'hrs',
  'salCalc.days': 'days',
  'salCalc.appts': 'appts',
  'salCalc.services': 'svc',
  'salCalc.individual': 'individual',
  'salCalc.otherService': 'other',
  'salCalc.exFileName': 'Salaries',
  'salCalc.exStaff': 'Employee',
  'salCalc.exScheme': 'Scheme',
  'salCalc.exByRules': 'By rules',
  'salCalc.exAdjustments': 'Adjustments',
  'salCalc.exTotal': 'Total',
  'salCalc.exRule': 'Rule',
  'salCalc.exDetails': 'Details',
  'salCalc.exAmount': 'Amount',
  'salCalc.exGrandTotal': 'Grand Total',
  'salCalc.adjustment': 'Adjustment',

  // ── Salary schemes page ──
  'salSchemes.title': 'Motivation Schemes',
  'salSchemes.subtitle': 'Payroll calculation rules',
  'salSchemes.schemesCount': 'Schemes',
  'salSchemes.newScheme': 'New scheme',
  'salSchemes.emptyTitle': 'No schemes yet',
  'salSchemes.emptyDesc': 'Create your first payroll scheme',
  'salSchemes.newSchemeTitle': 'New Scheme',
  'salSchemes.editScheme': 'Edit Scheme',
  'salSchemes.schemeName': 'Scheme name',
  'salSchemes.nameDuplicate': 'A scheme with this name already exists',
  'salSchemes.schemeNamePlaceholder': 'Enter name...',
  'salSchemes.rulesSection': 'Calculation Rules',
  'salSchemes.groupBase': 'Base',
  'salSchemes.groupServices': 'Services',
  'salSchemes.groupProducts': 'Products',
  'salSchemes.groupGeneral': 'General',
  'salSchemes.groupAdmin': 'Admin',
  'salSchemes.noRules': 'No rules yet',
  'salSchemes.hourlyRate': 'Rate per hour',
  'salSchemes.dailyRate': 'Rate per work day',
  'salSchemes.fixedPerAppointment': 'Bonus per rendered service',
  'salSchemes.percentOwnServices': '% of provided services',
  'salSchemes.percentTotalRevenue': '% of total revenue',
  'salSchemes.hintHourlyRate': 'UAH/hr',
  'salSchemes.hintDailyRate': 'UAH/day',
  'salSchemes.hintFixedPer': 'UAH/appt',
  'salSchemes.hintPercentOwn': '% of own',
  'salSchemes.hintPercentTotal': '% of total',
  'salSchemes.percentOwnProductSales': '% of own sales',
  'salSchemes.hintPercentOwnProducts': '% of products sold by this employee',
  'salSchemes.percentAllProductSales': '% of all location sales',
  'salSchemes.hintPercentAllProducts': '% of total product sales at location',
  'salSchemes.percentCreatedAppointments': '% of booked clients',
  'salSchemes.hintPercentCreated': '% of revenue from appointments created by this employee',
  'salSchemes.fixedPerCreatedAppointment': 'Bonus per booked client',
  'salSchemes.hintFixedCreated': 'Fixed amount per appointment created',
  'salSchemes.percentOwnMaterials': '% of used materials',
  'salSchemes.hintPercentMaterials': '% of materials used when providing services by this staff',
  'salSchemes.percentAllServices': '% of all location services',
  'salSchemes.hintPercentAllServices': 'Percentage of total service and subscription revenue at location',
  'salSchemes.subscriptionLabel': 'Subscription services',
  'salSchemes.subModeVisitPrice': 'At subscription price',
  'salSchemes.subModeFullPrice': 'At list price',
  'salSchemes.subModeSkip': 'Do not count',
  'salSchemes.unitHour': 'UAH/hr',
  'salSchemes.unitDay': 'UAH/day',
  'salSchemes.unitRecord': 'UAH/appt',
  'salSchemes.unitService': 'UAH/svc',
  'salSchemes.useOverrides': 'Per-service overrides',
  'salSchemes.overrideService': 'Service',
  'salSchemes.overrideRate': 'Rate',
  'salSchemes.overrideAdd': 'Add override',
  'salSchemes.overrideRemove': 'Remove override',
  'salSchemes.overridesShort': 'overrides',
  'salSchemes.staffShort': 'empl.',
  'salSchemes.save': 'Save',
  'salSchemes.create': 'Create',
  'salSchemes.cancel': 'Cancel',
  'salSchemes.editBtn': 'Edit',
  'salSchemes.deleteBtn': 'Delete',
  'salSchemes.delete': 'Delete',
  'salSchemes.deleteTitle': 'Delete scheme?',
  'salSchemes.deleteConfirmText': 'Are you sure you want to delete this scheme?',
  'salSchemes.deleteAssigned': 'This scheme is assigned to employees and cannot be deleted',
  'salSchemes.understood': 'Understood',
  'salSchemes.monthlySalary': 'Monthly salary',
  'salSchemes.hintMonthlySalary': 'Fixed amount per month regardless of schedule',
  'salSchemes.unitMonth': '₴/mo',
  'salSchemes.useBrackets': 'Tiered brackets',
  'salSchemes.bracketModeProgressive': 'Progressive (per slice)',
  'salSchemes.bracketModeFlat': 'Flat (whole base at reached tier)',
  'salSchemes.bracketFrom': 'From',
  'salSchemes.bracketTo': 'To',
  'salSchemes.bracketAdd': 'Add bracket',
  'salSchemes.bracketRemove': 'Remove bracket',

  // ── Checkbox settings page ──
  'checkbox.title': 'Checkbox POS',
  'checkbox.subtitle': 'Checkbox connection settings',
  'checkbox.licenseKey': 'License key',
  'checkbox.licenseKeyHint': 'Key from your Checkbox dashboard',
  'checkbox.licenseKeyPlaceholder': 'Enter license key...',
  'checkbox.pinCode': 'Cashier PIN code',
  'checkbox.pinCodeHint': 'Cashier PIN code from Checkbox',
  'checkbox.pinPlaceholder': 'Enter PIN code...',
  'checkbox.save': 'Save',
  'checkbox.saving': 'Saving...',
  'checkbox.settingsSaved': 'Settings saved',
  'checkbox.testConnection': 'Test connection',
  'checkbox.testing': 'Testing...',
  'checkbox.connectionSuccess': 'Connection successful',
  'checkbox.connectionSuccessToast': 'Checkbox connected successfully',
  'checkbox.shiftOpen': 'Shift open',
  'checkbox.shiftClosed': 'Shift closed',
  'checkbox.guideTitle': 'How the integration works',
  'checkbox.guideStep1': 'Register at checkbox.ua and create a cash register. Copy the license key from your cabinet.',
  'checkbox.guideStep2': 'Create a cashier and note the PIN code. Paste the key and PIN above, click "Test Connection".',
  'checkbox.guideStep3': 'Done! Now when processing payments for orders or appointments, the system will automatically create fiscal receipts.',
  'checkbox.guideCapabilities': 'Features:',
  'checkbox.guideCap1': 'Automatic fiscalization on order and appointment payments',
  'checkbox.guideCap2': 'Opening and closing cash register shifts',
  'checkbox.guideCap3': 'Support for cash and non-cash payments',
  'checkbox.guideCap4': 'X-report and Z-report for cash control',
  'checkbox.taxGroup': 'Tax group',
  'checkbox.taxGroupHint': 'Select tax rates to include in every receipt. Click "Test connection" to load available rates.',
  'checkbox.noTax': 'No tax',
  'checkbox.paylinkTitle': 'POS Terminal Connection',
  'checkbox.paylinkDesc': 'Connect a bank terminal to automatically send the payment amount when "Card" is selected.',
  'checkbox.paylinkStep1': 'Download and install {link}Checkbox Desktop PayLink{/link}',
  'checkbox.paylinkStep2': 'Connect the terminal to PayLink (USB, Wi-Fi or Ethernet) and link it to your cash register. See {link}official instructions{/link}',
  'checkbox.paylinkStep3': 'Done! Card payments will now automatically be sent to the terminal',
  'checkbox.paylinkHost': 'PayLink address',
  'checkbox.paylinkPort': 'Port',
  'checkbox.paylinkDetect': 'Detect terminals',
  'checkbox.paylinkDetecting': 'Detecting...',
  'checkbox.paylinkNoDevices': 'No terminals found. Make sure a terminal is added in PayLink.',
  'checkbox.paylinkFound': 'Terminals found',
  'checkbox.paylinkSelectTerminal': 'Select terminal',
  'checkbox.paylinkChoose': '— select —',
  'checkbox.paylinkPing': 'Test terminal',
  'checkbox.paylinkPinging': 'Testing...',
  'checkbox.paylinkPingOk': 'Terminal connected and ready',
  'checkbox.paylinkSave': 'Save terminal',
  'checkbox.paylinkSaved': 'Terminal saved',
  'checkbox.paylinkSupported': 'Supported terminals:',
  'checkbox.paylinkDocs': 'Detailed instructions on Checkbox website',

  // ── Nova Poshta settings page ──
  'np.title': 'Nova Poshta',
  'np.subtitle': 'Nova Poshta delivery integration settings',
  'np.apiKey': 'API Key',
  'np.apiKeyPlaceholder': 'Enter Nova Poshta API key...',
  'np.apiKeyHint': 'Key from my.novaposhta.ua → Settings → Security',
  'np.save': 'Save',
  'np.saving': 'Saving...',
  'np.settingsSaved': 'Nova Poshta settings saved',
  'np.error': 'Error: ',
  'np.testConnection': 'Test connection',
  'np.testing': 'Testing...',
  'np.connectionSuccess': 'Connected! Senders found: {count}',
  'np.connectionSuccessToast': 'Nova Poshta connected successfully',
  'np.connectionFailed': 'Connection failed. Check your API key.',
  'np.senderSection': 'Sender details',
  'np.sender': 'Sender (counterparty)',
  'np.contactPerson': 'Contact person',
  'np.senderPhone': 'Sender phone',
  'np.senderAddress': 'Shipping address',
  'np.senderAddressHint': 'Nova Poshta branch from which you ship parcels',
  'np.loadingSenders': 'Loading sender data...',
  'np.senderWarehouse': 'Sender warehouse',
  'np.senderWarehouseHint': 'Your NP account has no registered addresses. Select the branch you ship from.',
  'np.senderCity': 'Sender city',
  'np.senderCityPlaceholder': 'Enter city name...',
  'np.senderWarehouseSelect': 'Branch',
  'np.noWarehouses': 'No branches found',
  'np.clearSelection': 'Clear',
  'np.guideTitle': 'How the integration works',
  'np.guideStep1': 'Log in to my.novaposhta.ua → Settings → Security → copy the API key.',
  'np.guideStep2': 'Paste the key above, click "Test Connection". Select sender, contact person and shipping address.',
  'np.guideStep3': 'Done! Now select "Nova Poshta" as shipping method when creating orders.',
  'np.guideCapabilities': 'Features:',
  'np.guideCap1': 'Create TTN with one click from the order page (status "Packed")',
  'np.guideCap2': 'Automatic delivery status sync every 10 minutes',
  'np.guideCap3': 'Real-time parcel tracking',
  'np.guideCap4': 'Print shipping labels',
  'np.guideCap5': 'Automatic delivery cost calculation when selecting a branch',

  // ── Meest Express settings page ──
  'meest.title': 'Meest Express',
  'meest.subtitle': 'Integration settings',
  'meest.apiToken': 'API Token',
  'meest.apiTokenPlaceholder': 'Paste API token from Meest cabinet',
  'meest.apiTokenHint': 'Find at 24.meest.com → Settings → API Integration',
  'meest.contractId': 'Contract ID',
  'meest.contractIdPlaceholder': 'e.g. b0004cad-27a3-...',
  'meest.contractIdHint': 'Find in Meest cabinet next to API token',
  'meest.save': 'Save',
  'meest.saving': 'Saving...',
  'meest.settingsSaved': 'Meest Express settings saved',
  'meest.error': 'Error: ',
  'meest.testConnection': 'Test Connection',
  'meest.testing': 'Testing...',
  'meest.testingConnection': 'Testing connection to Meest Express...',
  'meest.connectionSuccess': 'Meest Express connected successfully',
  'meest.connectionSuccessToast': 'Meest Express connected',
  'meest.connectionFailed': 'Connection failed. Check token and Contract ID.',
  'meest.senderSection': 'Sender details',
  'meest.senderName': 'Sender full name',
  'meest.senderNamePlaceholder': 'Last name First name',
  'meest.senderPhone': 'Sender phone',
  'meest.senderCity': 'Sender city',
  'meest.senderCityPlaceholder': 'Start typing city name',
  'meest.senderBranch': 'Sender branch',
  'meest.branchPlaceholder': 'Search branch',
  'meest.noBranches': 'No branches found',
  'meest.clearSelection': 'Clear',
  'meest.guideTitle': 'How the integration works',
  'meest.guideStep1': 'Register at 24.meest.com and sign the contract. In Settings → API Integration copy the token and Contract ID.',
  'meest.guideStep2': 'Paste them above, click "Test Connection". Sender data will be filled automatically — verify and save.',
  'meest.guideStep3': 'Done! Now select "Meest Express" as shipping method when creating orders.',
  'meest.guideCapabilities': 'Features:',
  'meest.guideCap1': 'Create shipment with one click from the order page (status "Packed")',
  'meest.guideCap2': 'Automatic delivery status sync every 10 minutes',
  'meest.guideCap3': 'Real-time parcel tracking',
  'meest.guideCap4': 'Print shipping label for the parcel',

  // ── Telegram settings page ──
  'telegram.title': 'Telegram Reminders',
  'telegram.subtitle': 'Set up a bot for client reminders',
  'telegram.botToken': 'Bot Token',
  'telegram.botTokenHint': 'Bot token from @BotFather',
  'telegram.saveAndConnect': 'Save and connect',
  'telegram.connecting': 'Connecting...',
  'telegram.checkingBot': 'Checking bot...',
  'telegram.settingWebhook': 'Setting up webhook...',
  'telegram.botConnected': 'Bot connected',
  'telegram.botReady': 'Bot is ready to work',
  'telegram.invalidToken': 'Invalid token',
  'telegram.webhookError': 'Webhook error',
  'telegram.webhookFailed': 'Failed to set up webhook',
  'telegram.error': 'Error',
  'telegram.howItWorks': 'How it works',
  'telegram.step1': '1. Create a bot via @BotFather in Telegram',
  'telegram.step2': '2. Copy the bot token',
  'telegram.step3': '3. Paste the token above and click "Save and connect"',
  'telegram.step4': '4. Clients will be able to connect via a link',
  'telegram.guideCapabilities': 'Features:',
  'telegram.guideCap1': 'Automatic appointment reminders for clients',
  'telegram.guideCap2': 'Clients can view their upcoming appointments',
  'telegram.guideCap3': 'Confirm or cancel appointments via the bot',
  'telegram.guideCap4': 'Personal link for each client',

  // ── SMS settings page ──
  'sms.title': 'SMS Mailing',
  'sms.subtitle': 'SMS gateway settings',
  'sms.provider': 'Provider',
  'sms.apiKey': 'API key',
  'sms.apiKeyPlaceholder': 'Enter API key...',
  'sms.senderName': 'Sender name',
  'sms.senderNameHint': 'Name the recipient will see (up to 11 characters)',
  'sms.save': 'Save',
  'sms.settingsSaved': 'Settings saved',
  'sms.testConnection': 'Test connection',
  'sms.testing': 'Testing...',
  'sms.checkingConnection': 'Checking connection...',
  'sms.connectionSuccess': 'Connection successful',
  'sms.connectionError': 'Connection error',
  'sms.gatewayWorks': 'SMS gateway is working',
  'sms.error': 'Error',
  'sms.unknown': 'Unknown error',
  'sms.howItWorks': 'How it works',
  'sms.howToConnect': 'How to connect {name}',
  'sms.openSite': 'Open {name} website',
  'sms.apiKeyLocation': 'You\'ll find the API key here: {path}',
  'sms.recommended': 'Recommended',
  'sms.tagline_turbosms': 'Most popular in Ukraine. Solid dashboard, simple API.',
  'sms.tagline_smsclub': 'Flexible pricing, alpha-name supported.',
  'sms.tagline_alphasms': 'Transparent pricing, fast onboarding.',
  'sms.guide_turbosms.step1': 'Sign up at TurboSMS and top up your balance.',
  'sms.guide_turbosms.step2': 'Order an alpha-name (the sender label) in the dashboard. Approval is usually same-day.',
  'sms.guide_turbosms.step3': 'Go to Profile → API and copy the API key.',
  'sms.guide_turbosms.step4': 'Paste the key + alpha-name below and click "Test connection".',
  'sms.guide_smsclub.step1': 'Create an SMSClub account and top up your balance.',
  'sms.guide_smsclub.step2': 'Order an alpha-name in the dashboard (moderation ~1 business day).',
  'sms.guide_smsclub.step3': 'Open Settings / Profile → find the API token.',
  'sms.guide_smsclub.step4': 'Paste the token + alpha-name below and click "Test connection".',
  'sms.guide_alphasms.step1': 'Sign up at AlphaSMS and top up your balance.',
  'sms.guide_alphasms.step2': 'Order an alpha-name (moderation usually takes a few hours).',
  'sms.guide_alphasms.step3': 'Dashboard: Settings → API → copy the API key.',
  'sms.guide_alphasms.step4': 'Paste the key + alpha-name below and click "Test connection".',
  'sms.step1': '1. Register with an SMS provider',
  'sms.step2': '2. Get your API key',
  'sms.step3': '3. Paste the key above and save',
  'sms.step4': '4. Now you can send SMS to clients',

  // ── Email settings page ──
  'emailSet.title': 'Email Mailing',
  'emailSet.subtitle': 'Email sending settings',
  'emailSet.gmailAddress': 'Gmail address',
  'emailSet.gmailHint': 'Gmail address from which emails will be sent',
  'emailSet.appPassword': 'App password',
  'emailSet.appPasswordHint': 'Google app password (not the main password)',
  'emailSet.fromName': 'Sender name',
  'emailSet.fromNameHint': 'Name the recipient will see',
  'emailSet.save': 'Save',
  'emailSet.settingsSaved': 'Settings saved',
  'emailSet.sendTestEmail': 'Send test email',
  'emailSet.sendingTest': 'Sending...',
  'emailSet.testing': 'Testing...',
  'emailSet.testSent': 'Test email sent',
  'emailSet.testSubject': 'Test email',
  'emailSet.testBody': 'This is a test email from Systemic CRM',
  'emailSet.emailWorks': 'Email is working',
  'emailSet.sendError': 'Sending error',
  'emailSet.error': 'Error',
  'emailSet.unknown': 'Unknown error',
  'emailSet.howToGetAppPassword': 'How to get an app password',
  'emailSet.important': 'Important',
  'emailSet.importantText': 'Use an app password, not the main Gmail password',
  'emailSet.step1': '1. Sign in to your Google account',
  'emailSet.step2': '2. Go to Security \u2192 Two-Step Verification',
  'emailSet.step2direct': '2. Enable two-step verification',
  'emailSet.step3': '3. Go to App Passwords',
  'emailSet.step4': '4. Create a new app password',
  'emailSet.step5': '5. Copy the generated password',
  'emailSet.provider': 'Email provider',
  'emailSet.presetGmail': 'Gmail / Google Workspace',
  'emailSet.presetOutlook': 'Outlook / Microsoft 365',
  'emailSet.presetUkrnet': 'Ukr.net',
  'emailSet.presetMeta': 'Meta.ua',
  'emailSet.presetCustom': 'Custom SMTP',
  'emailSet.hintGmail': 'Get an App Password at myaccount.google.com/apppasswords (enable 2FA first)',
  'emailSet.hintOutlook': 'Log in with the full address (you@outlook.com). May need an app-specific password if 2FA is on',
  'emailSet.hintUkrnet': 'In Ukr.net: Settings → Mail → Allow external mail clients',
  'emailSet.hintMeta': 'In Meta.ua: Settings → IMAP/SMTP → Enable',
  'emailSet.hintCustom': 'Enter host, port and credentials of your SMTP server manually',
  'emailSet.host': 'SMTP host',
  'emailSet.port': 'Port',
  'emailSet.secure': 'TLS/SSL',
  'emailSet.smtpUser': 'SMTP username',
  'emailSet.smtpUserHint': 'Usually the full email address',
  'emailSet.password': 'SMTP password',
  'emailSet.passwordHint': 'For Gmail/Outlook — app-specific password, not your login password',
  'emailSet.fromEmail': 'From address',
  'emailSet.fromEmailHint': 'Defaults to SMTP username if empty',
  'emailSet.invalidEmail': 'Not a valid email address (expected user@domain.com)',
  'emailSet.sectionProvider': 'Email service and server',
  'emailSet.sectionCredentials': 'Credentials',
  'emailSet.sectionFrom': 'From',
  'emailSet.howToConnect': 'How to connect {provider}',
  'emailSet.instrGmail': '<ol><li>Enable 2-factor authentication on your Google account: <a href="https://myaccount.google.com/security" target="_blank">myaccount.google.com/security</a> → <strong>2-Step Verification</strong> → <strong>On</strong>.</li><li>Go to <a href="https://myaccount.google.com/apppasswords" target="_blank">myaccount.google.com/apppasswords</a>.</li><li>Create a new App Password: type — <strong>Mail</strong> (or <strong>Other</strong> with name <code>Systemic CRM</code>).</li><li>Copy the 16-character password (looks like <code>abcd efgh ijkl mnop</code>).</li><li>Paste it into the <strong>SMTP password</strong> field above. Click <strong>Send test email</strong>.</li></ol>',
  'emailSet.instrOutlook': '<ol><li>Sign in at <a href="https://account.microsoft.com/security" target="_blank">account.microsoft.com/security</a>.</li><li>Go to <strong>Advanced security options</strong>.</li><li>Under <strong>App passwords</strong>, click <strong>Create a new app password</strong>.</li><li>Copy the generated password and paste it into <strong>SMTP password</strong>.</li><li><em>If "App passwords" is not visible — enable 2-Step Verification first.</em></li></ol>',
  'emailSet.instrUkrnet': '<ol><li>Sign in to Ukr.net mail.</li><li>Go to <strong>Settings → All settings → Mail client access</strong>.</li><li>Enable <strong>IMAP/SMTP access</strong>.</li><li>Use your main Ukr.net password in the <strong>SMTP password</strong> field.</li><li><em>If 2-Step Verification is on — create a dedicated app password in Security settings.</em></li></ol>',
  'emailSet.instrMeta': '<ol><li>Sign in to Meta.ua mail.</li><li>Go to <strong>Settings → IMAP/SMTP</strong>.</li><li>Enable SMTP protocol.</li><li>Use your main mail password in the <strong>SMTP password</strong> field.</li></ol>',
  'emailSet.instrCustom': '<ol><li>Ask your system administrator or hosting provider for the SMTP details of your mail server.</li><li>Typically you\'ll need: <strong>host</strong> (smtp.your-domain.com), <strong>port</strong> (587 or 465), <strong>TLS/SSL</strong> (on for 465).</li><li>Username — the full email address.</li><li>Password — the same as you use to log into mail (or a dedicated SMTP password if your provider issues them).</li></ol>',

  // ── Locations settings page ──
  'locations.title': 'Locations',
  'locations.subtitle': 'Manage your business locations',
  'locations.locationsLabel': 'Locations',
  'locations.staffCount': 'Employees',
  'locations.warehousesCount': 'Warehouses',
  'locations.addLocation': 'Add location',
  'locations.tabMain': 'General',
  'locations.tabBooking': 'Online Booking',
  'locations.tabCompany': 'Company Details',
  'locations.photo': 'Location photo',
  'locations.uploadPhoto': 'Upload photo',
  'locations.changePhoto': 'Change photo',
  'locations.photoHint': 'Interior or facade photo — shown on the online booking page',
  'locations.scheduleLabel': 'Working hours',
  'locations.dayOff': 'Day off',
  'locations.mon': 'Mon', 'locations.tue': 'Tue', 'locations.wed': 'Wed',
  'locations.thu': 'Thu', 'locations.fri': 'Fri', 'locations.sat': 'Sat', 'locations.sun': 'Sun',
  'locations.workingHoursLabel': 'Working hours',
  'locations.workingHoursPlaceholder': 'Mon-Fri 9:00-18:00, Sat 10:00-15:00',
  'locations.hasLinkedData': 'Cannot delete — location has linked staff or warehouses. Reassign them first.',
  'locations.limitReached': 'Location limit reached for your plan. Upgrade to add more.',
  'locations.newLocation': 'New Location',
  'locations.editLocation': 'Edit Location',
  'locations.nameLabel': 'Name',
  'locations.namePlaceholder': 'Enter name...',
  'locations.nameDuplicate': 'A location with this name already exists',
  'locations.addressLabel': 'Address',
  'locations.addressPlaceholder': '1 Main Street',
  'locations.cityLabel': 'City',
  'locations.cityPlaceholder': 'New York',
  'locations.phoneLabel': 'Phone',
  'locations.colorLabel': 'Color',
  'locations.save': 'Save',
  'locations.cancel': 'Cancel',
  'locations.add': 'Add',
  'locations.edit': 'Edit',
  'locations.delete': 'Delete',
  'locations.cannotDelete': 'Cannot delete',
  'locations.ordersCount': 'Orders',
  'locations.needAtLeastOne': 'At least one location is required',
  'locations.added': 'Location added',
  'locations.updated': 'Location updated',
  'locations.deleted': 'Location deleted',
  'locations.deleteTitle': 'Delete location',
  'locations.deleteMessage': 'Are you sure? This cannot be undone.',
  'locations.companyDetailsHint': 'Company details (for invoices and documents)',
  'locations.officialNameLabel': 'Official name',
  'locations.officialNamePlaceholder': 'LLC "Name" / Sole Proprietor',
  'locations.edrpouLabel': 'Tax ID / Registration code',
  'locations.edrpouShort': 'Tax ID',
  'locations.bankAccountLabel': 'Bank account (IBAN)',
  'locations.bankNameLabel': 'Bank name',
  'locations.bankNamePlaceholder': 'Bank name',

  // ── Users page ──
  'users.title': 'Users',
  'users.subtitle': 'System user management',
  'users.usersCount': 'Users',
  'users.addUser': 'Add user',
  'users.limitReached': 'User limit reached for your plan. Upgrade to add more.',
  'users.newUser': 'New User',
  'users.editUser': 'Edit User',
  'users.noUsers': 'No users yet',
  'users.thName': 'Name',
  'users.thEmail': 'Email',
  'users.thRole': 'Role',
  'users.thStaff': 'Employee',
  'users.thActions': 'Actions',
  'users.nameLabel': 'Name',
  'users.namePlaceholder': 'Enter name...',
  'users.emailLabel': 'Email',
  'users.passwordLabel': 'Password',
  'users.passwordPlaceholder': 'At least 6 characters',
  'users.passwordMin': 'Password must be at least 6 characters',
  'users.roleLabel': 'Role',
  'users.selectRole': 'Select role',
  'users.selectRoleOption': '\u2014 Select role \u2014',
  'users.showPassword': 'Show password',
  'users.hidePassword': 'Hide password',
  'users.enterName': 'Enter name',
  'users.enterEmail': 'Enter email',
  'users.emailAlreadyUsed': 'This email is already in use',
  'users.error': 'Error',
  'users.edit': 'Edit',
  'users.delete': 'Delete',
  'users.confirmDelete': 'Are you sure you want to delete this user?',
  'users.yes': 'Yes',
  'users.no': 'No',
  'users.staffBinding': 'Staff binding',
  'users.noStaffBinding': '— None —',
  'users.noPosition': 'no position',
  'users.staffBindingHint': 'Link user to employee for salary calculation and work schedule',
  'users.viewScope': 'Data visibility',
  'users.viewScopeAll': 'Show all records and orders',
  'users.viewScopeOwn': 'Show only own',
  'users.viewScopeHint': '"Own only" — user will see only their appointments, orders and sales',
  'users.createWarning': 'Warning: after creating a user you may be logged out. Just sign in again.',

  // ── Roles ──
  'roles.title': 'Roles',
  'roles.subtitle': 'Manage roles and access permissions',
  'roles.rolesCount': 'Roles',
  'roles.addRole': 'Add role',
  'roles.noRoles': 'No roles yet.',
  'roles.systemBadge': 'System',
  'roles.permsOf': 'permissions',
  'roles.newRole': 'New role',
  'roles.editRole': 'Edit role',
  'roles.roleName': 'Role name',
  'roles.roleNamePlaceholder': 'E.g.: Administrator, Manager, Master',
  'roles.nameDuplicate': 'A role with this name already exists',
  'roles.permissions': 'Permissions',
  'roles.confirmDelete': 'Delete?',
  'roles.cannotDelete': 'Cannot delete role',
  'roles.usersAssigned': 'users assigned to this role',
  'roles.groupClients': 'Clients',
  'roles.groupStaff': 'Staff',
  'roles.groupCalendar': 'Calendar',
  'roles.groupSales': 'Sales',
  'roles.groupInventory': 'Warehouse',
  'roles.groupLoyalty': 'Loyalty',
  'roles.groupSalary': 'Salaries',
  'roles.groupFinances': 'Finances & Analytics',
  'roles.groupCommunication': 'Communications',
  'roles.groupSettings': 'Settings',
  'roles.groupSystem': 'System',
  'roles.permClientsView': 'View clients',
  'roles.permClientsEdit': 'Edit clients',
  'roles.permClientsDelete': 'Delete clients',
  'roles.permClientsCategories': 'Client categories',
  'roles.permClientsDocuments': 'Client documents',
  'roles.permDocumentsTemplates': 'Document templates',
  'roles.permStaffView': 'View staff',
  'roles.permStaffEdit': 'Edit staff',
  'roles.permScheduleView': 'Work schedule',
  'roles.permScheduleEdit': 'Schedule templates',
  'roles.permServicesView': 'View services',
  'roles.permServicesEdit': 'Edit services',
  'roles.permCalendarView': 'View calendar',
  'roles.permCalendarCreate': 'Create appointments',
  'roles.permCalendarEdit': 'Edit appointments',
  'roles.permPosSell': 'POS (Shop)',
  'roles.permOrdersView': 'Orders (view)',
  'roles.permOrdersCreate': 'Orders (create)',
  'roles.permOrdersEdit': 'Orders (edit)',
  'roles.permInvView': 'Products & stock',
  'roles.permInvPurchases': 'Purchases',
  'roles.permInvMovements': 'Stock movements',
  'roles.permProductionView': 'View production',
  'roles.permProductionCreate': 'Create production',
  'roles.permLoyaltyView': 'View loyalty programs',
  'roles.permLoyaltyEdit': 'Edit loyalty programs',
  'roles.permSalaryView': 'Salary calculation',
  'roles.permSalaryEdit': 'Motivation schemes',
  'roles.permFinancesView': 'View finances',
  'roles.permCashRegister': 'Cash register (Checkbox)',
  'roles.permReportsView': 'Reports',
  'roles.permFinancialResult': 'Financial result',
  'roles.permBusinessMonitor': 'Business monitor',
  'roles.permCommunicationView': 'Messages',
  'roles.permCommSettingsEdit': 'Communication settings',
  'roles.permSettingsLocations': 'Locations',
  'roles.permSettingsBooking': 'Online booking',
  'roles.permSettingsIntegrations': 'Integrations',
  'roles.permSettingsTariffs': 'Tariff plans',
  'roles.permManageUsers': 'Users',
  'roles.permManageRoles': 'Roles',
  'roles.permAuditLog': 'Audit log',

  // ── Auto-notifications ──
  'notifAuto.title': 'Communication settings',
  'notifAuto.subtitle': 'Channel priority, automatic notifications and reminders',
  'notifAuto.navItem': 'Communication settings',
  'notifAuto.sectionDefaultPriority': 'Default priority for manual messages',
  'notifAuto.defaultPriorityHint': 'When the admin writes to a client in Communications for the first time, the first available channel in this list is pre-selected; after that, the channel last used with that client is kept. Drag to reorder, toggle off the ones you don\'t use.',
  'notifAuto.sectionBooking': 'Service booking — created notification',
  'notifAuto.sectionOrder': 'Product order — created notification',
  'notifAuto.enable': 'Enable',
  'notifAuto.mode': 'Delivery mode',
  'notifAuto.modePriority': 'Priority (first available channel)',
  'notifAuto.modeAll': 'All channels at once',
  'notifAuto.channelsOrder': 'Channel priority (drag to reorder)',
  'notifAuto.channelsEmpty': 'No channels enabled — turn on at least one below',
  'notifAuto.otherChannels': 'Other channels',
  'notifAuto.dragHint': 'Drag to reorder',
  'notifAuto.channelNotConfigured': 'Channel not configured in its settings page — message will not be sent',
  'notifAuto.channelTelegram': 'Telegram',
  'notifAuto.channelSms': 'SMS',
  'notifAuto.channelEmail': 'Email',
  'notifAuto.channelWeb': 'Web chat',
  'notifAuto.template': 'Message template',
  'notifAuto.templateHint': 'Available tokens: {clientName}, {date}, {time}, {serviceName}, {staffName}, {locationName}, {phone}, {orderNumber}, {total}, {items}',
  'notifAuto.templateHtmlNote': 'Supports HTML for Telegram/Email; auto-converted to plain text for SMS',
  'notifAuto.preview': 'Preview',
  'notifAuto.previewHint': 'Sample with test data',
  'notifAuto.save': 'Save',
  'notifAuto.saved': 'Settings saved',
  'notifAuto.moveUp': 'Up',
  'notifAuto.moveDown': 'Down',
  'notifAuto.defaultBookingTemplate': 'Hi {clientName}! Your booking on {date} at {time} is confirmed. Service: {serviceName}, with {staffName}. See you soon!',
  'notifAuto.defaultOrderTemplate': 'Thanks for order #{orderNumber} for {total}. We will reach out to confirm shipping.',
  'notifAuto.sectionReminders': 'Pre-appointment reminders',
  'notifAuto.remindersHint': 'Add multiple rules with different intervals (e.g. 24h before and 2h before). Minimum is 1 hour.',
  'notifAuto.noReminders': 'No reminders configured yet',
  'notifAuto.addReminder': 'Add reminder',
  'notifAuto.removeReminder': 'Remove reminder',
  'notifAuto.hoursBefore': 'Hours before appointment',
  'notifAuto.hoursBeforeUnit': 'hours',
  'notifAuto.defaultReminderTemplate': 'Reminder: your appointment on {date} at {time}. Service: {serviceName} with {staffName}. See you soon!',
  'notifAuto.timezone': 'Timezone',
  'notifAuto.timezoneHint': 'Determines when reminders are sent',
  'notifAuto.tzKyiv': 'Kyiv (UTC+2/+3)',
  'notifAuto.tzWarsaw': 'Warsaw (UTC+1/+2)',
  'notifAuto.tzBerlin': 'Berlin (UTC+1/+2)',
  'notifAuto.tzParis': 'Paris (UTC+1/+2)',
  'notifAuto.tzLondon': 'London (UTC+0/+1)',
  'notifAuto.tzMadrid': 'Madrid (UTC+1/+2)',
  'notifAuto.tzRome': 'Rome (UTC+1/+2)',
  'notifAuto.tzNewYork': 'New York (UTC-5/-4)',

  'errors.rateLimited': 'Too many requests. Try again in {seconds} s 🙂',
  'errors.serverError': 'Server error. Please try again in a moment',
  'errors.networkError': 'No connection. Check your internet',

  // ── Communication ──
  'comm.title': 'Communication',
  'comm.filterAll': 'All',
  'comm.sendingVia': 'Current channel: {channel}',
  'comm.channelWeb': 'Web chat',
  'comm.anonymousVisitor': 'Anonymous visitor',
  'comm.deletedVisitor': 'Deleted visitor',
  'comm.noChannelsForClient': 'This client has no connected communication channels',
  'comm.addContactToCard': 'Add a phone number or email to the client card, or send them the Telegram bot link',
  'comm.subtitle': 'Messages and client communication',
  'comm.searchPlaceholder': 'Search client...',
  'comm.allClients': 'All clients',
  'comm.nothingFound': 'Nothing found',
  'comm.noConnectedClients': 'No connected clients',
  'comm.you': 'You: ',
  'comm.noMessages': 'No messages',
  'comm.noHistory': 'No history',
  'comm.selectChat': 'Select a chat',
  'comm.selectChatHint': 'Select a client on the left to start communicating',
  'comm.telegramNotConnected': 'Telegram is not connected',
  'comm.smsNotConfigured': 'SMS gateway is not configured',
  'comm.clientNoPhone': 'Client has no phone number',
  'comm.noPhone': 'No phone',
  'comm.emailNotConfigured': 'Email is not configured',
  'comm.clientNoEmail': 'Client has no email address',
  'comm.noEmail': 'No email',
  'comm.defaultSubject': 'Message',
  'comm.emailSent': 'Email sent',
  'comm.smsSent': 'SMS sent',
  'comm.messageSent': 'Message sent',
  'comm.error': 'Error: ',
  'comm.linkCopied': 'Link copied',
  'comm.yesterday': 'Yesterday',
  'comm.clientNoTelegram': 'Client has not connected Telegram yet',
  'comm.sendBotLink': 'Send this link to the client:',
  'comm.copy': 'Copy',
  'comm.sendSmsInstead': 'Send SMS instead',
  'comm.botNotConfigured': 'Telegram bot is not configured',
  'comm.configureTelegram': 'Configure in System → Telegram reminders',
  'comm.configureSms': 'Configure in System → SMS messaging',
  'comm.addPhoneToCard': 'Add a phone number to the client card',
  'comm.configureEmail': 'Configure in System → Email messaging',
  'comm.addEmailToCard': 'Add an email to the client card',
  'comm.noMessagesYet': 'No messages yet. Write first!',
  'comm.openAttachment': 'Open attachment',
  'comm.seen': 'Seen',
  'comm.igWindowHuman': 'More than 24 hours have passed since the customer’s last message. Instagram will accept a reply only as a human-agent reply (up to 7 days), if Meta has approved it. If it fails, reply from the Instagram app — a copy will appear here.',
  'comm.igWindowClosed': 'More than 7 days have passed since the customer’s last message — Instagram will not accept a reply from the CRM. Reply from the Instagram app (a copy will appear here) or use another channel.',
  'comm.igOutsideWindow': 'Instagram rejected the message: more than 24 hours have passed since the customer’s last message. Reply from the Instagram app (a copy will appear here) or use another channel.',
  'comm.sentFromApp': 'from Instagram',
  'comm.sentFromAppHint': 'Sent outside the CRM: from the Instagram app or Meta Business Suite',
  'comm.botLabel': 'Bot',
  'comm.pressed': 'Pressed',
  'comm.saveAsCustomer': 'Save as a customer card',
  'comm.cardCreatedNotLinked': 'Card created, but the thread was not linked',
  'comm.clientReaction': 'Customer reaction',
  'comm.yourReaction': 'Your reaction',
  'comm.reactHeart': 'React with a heart',
  'comm.unreactHeart': 'Remove heart',
  'comm.reactFailed': 'Could not add the reaction',
  'comm.attachHintWeb': 'The conversation moves to the customer card with its history; further messages from this chat will land on the card too.',
  'comm.createCardFromVisitor': 'Create card from visitor details',
  'comm.cardCreated': 'Card created',
  'comm.showOlder': 'Show earlier',
  'comm.emailSubjectPlaceholder': 'Email subject...',
  'comm.emailPlaceholder': 'Email body...',
  'comm.smsPlaceholder': 'Write an SMS...',
  'comm.messagePlaceholder': 'Write a message...',
  'comm.sendEnter': 'Send (Enter)',

  // ── Orders ──
  'orders.title': 'Orders',
  'orders.subtitle': 'Product sales',
  'orders.statTotal': 'Total',
  'orders.statusNew': 'New',
  'orders.statusPaid': 'Paid',
  'orders.searchPlaceholder': 'Search by customer or product...',
  'orders.filterAll': 'All',
  'orders.status_new': 'New',
  'orders.status_confirmed': 'Confirmed',
  'orders.status_packed': 'Packed',
  'orders.status_shipped': 'Shipped',
  'orders.status_delivered': 'Received',
  'orders.status_cancelled': 'Cancelled',
  'orders.periodAll': 'All',
  'orders.periodWeek': 'Week',
  'orders.periodMonth': 'Month',
  'orders.periodYear': 'Year',
  'orders.periodCustom': 'Custom',
  'orders.newOrder': 'New order',
  'orders.editOrder': 'Edit order',
  'orders.emptyTitle': 'No orders yet',
  'orders.emptyHint': 'Create your first product sales order',
  'orders.pos': 'items',
  'orders.discount': 'Discount',
  'orders.total': 'Total',
  'orders.pay_unpaid': 'Unpaid',
  'orders.pay_partial': 'Partial',
  'orders.pay_paid': 'Paid',
  'orders.pay_refunded': 'Refunded',
  'orders.refund': 'Refund',
  'orders.refunded': 'Payment refunded',
  'orders.refundTitle': 'Refund payment',
  'orders.refundMessage': 'Refund {amount} ₴ to the customer?',
  'orders.refundWarning': 'A refund transaction will be created',
  'orders.refundDescription': 'Order refund',
  'orders.confirmRefund': 'Confirm refund',
  'orders.refundAmountLabel': 'Refund amount',
  'orders.paidOf': 'Paid {paid} of {total} ₴',
  'orders.payRemaining': 'Pay remaining',
  'orders.payAmountLabel': 'Payment amount',
  'orders.fullAmount': 'full amount',
  'orders.returnProducts': 'Return products',
  'orders.returnTitle': 'Product return',
  'orders.returnHint': 'Specify quantities to return to stock',
  'orders.confirmReturn': 'Confirm return',
  'orders.returnFrom': 'Return from order',
  'orders.fullyReturned': 'Returned',
  'orders.partiallyReturned': 'Partial return',
  'orders.statusReturned': 'Returned',
  'orders.action_confirmed': 'Confirm',
  'orders.action_packed': 'Pack',
  'orders.action_shipped': 'Ship',
  'orders.action_delivered': 'Received',
  'orders.action_cancelled': 'Cancel',
  'orders.markPaid': 'Mark paid',
  'orders.payBtn': 'Pay',
  'orders.cashGiven': 'Client gave',
  'orders.change': 'Change',
  'orders.notEnough': 'Not enough',
  'orders.confirmPayment': 'Confirm payment',
  'orders.back': 'Back',
  'orders.edit': 'Edit',
  'orders.errCustomerName': 'Enter customer name',
  'orders.errItems': 'Add at least one product',
  'orders.errWarehouse': 'Select warehouse',
  'orders.errStockInsufficient': 'Insufficient stock',
  'orders.errNegPrice': 'Price cannot be negative',
  'orders.errQuantity': 'Specify quantity for selected products',
  'orders.inStock': 'In stock',
  'orders.available': 'available',
  'orders.needed': 'needed',
  'orders.paymentDescription': 'Product sale',
  'orders.fiscalError': 'Failed to create fiscal receipt. Payment cancelled',
  'orders.terminalError': 'Terminal payment error',
  'orders.fiscalReturnError': 'Failed to create fiscal return receipt',
  'orders.sectionCustomer': 'Customer',
  'orders.sectionProducts': 'Products',
  'orders.sectionPayment': 'Payment',
  'orders.labelName': 'Name',
  'orders.namePlaceholder': 'Customer name',
  'orders.labelPhone': 'Phone',
  'orders.labelTariff': 'Tariff plan',
  'orders.standardPrice': 'Standard price',
  'orders.labelEmail': 'Email',
  'orders.labelWarehouse': 'Warehouse',
  'orders.selectWarehouse': 'Select warehouse',
  'orders.labelPaymentMethod': 'Payment method',
  'orders.pm_cash': 'Cash',
  'orders.pm_terminal': 'Terminal',
  'orders.pm_transfer': 'Transfer',
  'orders.pm_online': 'Online',
  'orders.selectProduct': 'Select product',
  'orders.qty': 'Quantity',
  'orders.price': 'Price',
  'orders.addItem': 'Add product',
  'orders.colProduct': 'Product',
  'orders.colWarehouse': 'Warehouse',
  'orders.colQty': 'Qty',
  'orders.colPrice': 'Price',
  'orders.colDiscount': 'Disc.',
  'orders.colSum': 'Sum',
  'orders.labelDiscount': 'Discount (₴)',
  'orders.labelNote': 'Note',
  'orders.notePlaceholder': 'Order comment...',
  'orders.cancel': 'Cancel',
  'orders.save': 'Save',
  'orders.saving': 'Saving…',
  'orders.searchProduct': 'Search product...',
  'orders.noProducts': 'No products found',
  'orders.changeProduct': 'Change product',
  'orders.noWarehouse': 'No warehouse with stock',
  'orders.noCategory': 'Uncategorized',
  'orders.printInvoice': 'Invoice',
  'orders.printBill': 'Bill',
  'orders.sectionShipping': 'Shipping',
  'orders.labelShippingMethod': 'Shipping method',
  'orders.labelShippingAddress': 'Delivery address',
  'orders.shippingNone': 'No shipping (pickup)',
  'orders.shippingNP': 'Nova Poshta',
  'orders.shippingPickup': 'Pickup',
  'orders.shippingCourier': 'Courier',
  'orders.shippingOther': 'Other',
  'orders.shipping_novaposhta': 'Nova Poshta',
  'orders.shipping_pickup': 'Pickup',
  'orders.shipping_courier': 'Courier',
  'orders.shipping_other': 'Other delivery',
  'orders.npCity': 'City',
  'orders.npCityPlaceholder': 'Enter city name...',
  'orders.npWarehouse': 'Branch / Post office',
  'orders.npWarehousePlaceholder': 'Search branch...',
  'orders.npTTN': 'Tracking number',
  'orders.npTTNPlaceholder': 'Waybill number',
  'orders.npTrack': 'Track',
  'orders.npStatus': 'Status',
  'orders.npFrom': 'From',
  'orders.npTo': 'To',
  'orders.npDeliveryTo': 'Delivery',
  'orders.npDeliveryDate': 'Delivery date',
  'orders.npTTNOnlyPacked': 'TTN can only be created from "Packed" status',
  'orders.npSyncTracking': 'Sync tracking',
  'orders.npSyncing': 'Syncing...',
  'orders.npAutoSyncActive': 'Status will update automatically via Nova Poshta',
  'orders.meestAutoSyncActive': 'Status will update automatically via Meest Express',
  'orders.meestAll': 'All',
  'orders.meestOffice': 'Offices',
  'orders.meestParcelLocker': 'Parcel lockers',
  'orders.npCodConfirmTitle': 'Create Nova Poshta waybill',
  'orders.meestCodConfirmTitle': 'Create Meest shipment',
  'orders.codChoiceMessage': 'The order is not paid. You can create the shipment with Cash on Delivery.',
  'orders.codWithCod': 'Yes, with COD',
  'orders.codWithoutCod': 'No, without COD',
  'orders.codCancel': 'Cancel shipment creation',
  'orders.addressPlaceholder': 'Delivery address...',
  'orders.courierAddressPlaceholder': 'Courier delivery address...',
  'orders.npSettingsRequired': 'First configure Nova Poshta in System → Nova Poshta',
  'orders.npResaveSettings': 'Please re-save Nova Poshta settings (System → Nova Poshta → Save) to update sender data.',
  'orders.npMissingFields': 'Missing data for waybill creation. Go to System → Nova Poshta and re-save. Missing fields',
  'orders.npAddressRequired': 'Specify city and NP branch in the order',
  'orders.npRecipientRequired': 'Enter recipient name and phone number',
  'orders.npCreateTTN': 'Create waybill',
  'orders.npTTNCreated': 'Waybill created',
  'orders.npTTNError': 'Waybill creation error',
  'orders.npPrintSticker': 'Print sticker',
  'orders.npDeliveryPriceLabel': 'Estimated delivery cost',
  'orders.npUAH': 'UAH',
  'orders.npCalcPrice': 'Calculating cost',
  'orders.author': 'Author',
  'invoice.title': 'Invoice',
  'invoice.date': 'Date',
  'invoice.status': 'Status',
  'invoice.customer': 'Customer',
  'invoice.note': 'Note',
  'invoice.items': 'Items',
  'invoice.product': 'Product',
  'invoice.unit': 'Unit',
  'invoice.qty': 'Qty',
  'invoice.price': 'Price',
  'invoice.discountCol': 'Discount',
  'invoice.sum': 'Total',
  'invoice.discount': 'Discount',
  'invoice.total': 'Total',
  'invoice.paid': 'Paid',
  'invoice.remaining': 'Remaining',
  'invoice.seller': 'Seller',
  'invoice.bankAccount': 'Account',
  'invoice.sellerSign': 'Seller signature',
  'invoice.buyerSign': 'Buyer signature',
  'invoice.pcs': 'pcs',

  // ── Bill ──
  'bill.title': 'Bill',
  'bill.amountDue': 'Amount due',
  'bill.payTo': 'Payment details',
  'bill.service': 'service',
  'bill.itemName': 'Description',

  // ── Services: default materials ──
  'services.materials': 'Materials',
  'services.hasMaterials': 'Has default materials',
  'services.defaultMaterials': 'Default materials',
  'services.defaultMaterialsHint': 'These materials will be auto-added when selecting this service in an appointment',
  'services.addMaterial': 'Add material',
  'services.noProductsAvailable': 'No products available',

  // ── Navigation ──
  'nav.production': 'Production',

  // ── Production ──
  'production.title': 'Production',
  'production.subtitle': 'Specifications & manufacturing',
  'production.recipesCount': 'Specifications',
  'production.operationsCount': 'Operations',
  'production.tab_recipes': 'Specifications',
  'production.tab_produce': 'Produce',
  'production.tab_history': 'History',
  'production.newRecipe': 'New specification',
  'production.newProduction': 'New operation',
  'production.searchRecipes': 'Search specifications...',
  'production.searchHistory': 'Search history...',
  'production.noRecipes': 'No specifications yet',
  'production.noRecipesHint': 'Create a specification to manufacture products from raw materials',
  'production.createRecipeFirst': 'First create a specification in the "Specifications" tab',
  'production.noHistory': 'Production history is empty',
  'production.output': 'Output',
  'production.inputs': 'Inputs',
  'production.produce': 'Produce',
  'production.edit': 'Edit',
  'production.delete': 'Delete',
  'production.stockOk': 'In stock',
  'production.stockLow': 'Insufficient',
  'production.inputCost': 'Input cost',
  'production.unitCost': 'Unit cost',
  'production.uah': 'UAH',
  'production.warehouse': 'Warehouse',
  'production.recipeName': 'Specification name',
  'production.recipeNamePlaceholder': 'E.g. "Hand cream 100ml"',
  'production.selectWarehouse': 'Select warehouse',
  'production.noInputsYet': 'Add raw materials to the specification',
  'production.outputSection': 'Output product',
  'production.outputProduct': 'Output product',
  'production.selectProduct': 'Select product',
  'production.outputQty': 'Quantity',
  'production.inputsSection': 'Raw materials (inputs)',
  'production.addInput': 'Add input',
  'production.searchProduct': 'Search product...',
  'production.qty': 'Qty',
  'production.cancel': 'Cancel',
  'production.save': 'Save',
  'production.create': 'Create',
  'production.editRecipe': 'Edit specification',
  'production.recipeCreated': 'Specification created',
  'production.recipeUpdated': 'Specification updated',
  'production.recipeDeleted': 'Specification deleted',
  'production.cannotDeleteRecipe': 'Cannot delete specification — it has been used in production',
  'production.executeProduction': 'Execute production',
  'production.selectRecipeLabel': 'Specification',
  'production.selectRecipe': 'Select specification',
  'production.multiplier': 'Multiplier (batch count)',
  'production.preview': 'Preview',
  'production.willConsume': 'Will consume',
  'production.willProduce': 'Will produce',
  'production.need': 'need',
  'production.available': 'available',
  'production.note': 'Note',
  'production.notePlaceholder': 'Comment on operation',
  'production.executeProduce': 'Produce',
  'production.produced': 'Produced: {qty} × {name}',
  'production.errNameRequired': 'Specification name is required',
  'production.errOutputRequired': 'Select output product',
  'production.errInputsRequired': 'Add at least one input material',
  'production.errOutputInInputs': 'Output product cannot be among inputs',
  'production.errSelectRecipe': 'Select a specification',
  'production.errSelectWarehouse': 'Select a warehouse',
  'production.errMultiplier': 'Multiplier must be >= 1',
  'production.cancelTitle': 'Cancel production',
  'production.cancelMessage': 'Cancel production "{name}" ×{qty}?',
  'production.cancelDescription': 'Produced goods will be deducted from stock, raw materials — returned',
  'production.cancelWarning': 'This action cannot be undone',
  'production.confirmCancel': 'Confirm cancellation',
  'production.cancelledLabel': 'Cancelled',
  'production.cancelBtn': 'Cancel',
  'production.alreadyCancelled': 'This production has already been cancelled',
  'production.cancelNotEnoughStock': 'Cannot cancel — only {available} of {needed} units remain in stock. Product has already been shipped.',
  'production.cancelNote': 'Production cancellation',
  'production.cancelledSuccess': 'Production cancelled',
  'production.cancelLookupError': 'Could not read the stock movements — nothing was cancelled',

  // ── Inventory movements: production types ──
  'invMov.typeProductionOut': 'Production (consumed)',
  'invMov.typeProductionIn': 'Production (output)',
  'invMov.filterProduction': 'Production',

  // ── Navigation: audit log ──
  'nav.auditLog': 'Audit log',

  // ── Audit Log ──
  'auditLog.title': 'Audit Log',
  'auditLog.dateTime': 'Date & Time',
  'auditLog.user': 'User',
  'auditLog.action': 'Action',
  'auditLog.collection': 'Section',
  'auditLog.documentId': 'Document ID',
  'auditLog.document': 'Document',
  'auditLog.details': 'Details',
  'auditLog.actionCreate': 'Create',
  'auditLog.actionUpdate': 'Update',
  'auditLog.actionDelete': 'Delete',
  'auditLog.filterCollection': 'Section',
  'auditLog.filterAction': 'Action',
  'auditLog.filterFrom': 'From',
  'auditLog.filterTo': 'To',
  'auditLog.allCollections': 'All sections',
  'auditLog.allActions': 'All actions',
  'auditLog.noEntries': 'No entries found',
  'auditLog.loadMore': 'Load more',
  'auditLog.changes': 'Changes',
  'auditLog.field': 'Field',
  'auditLog.oldValue': 'Before',
  'auditLog.newValue': 'After',
  'auditLog.deletedData': 'Deleted data',
  'auditLog.newRecord': 'New record created',
  'auditLog.fieldsChanged': 'fields changed',
  'auditLog.colCustomers': 'Customers',
  'auditLog.colStaff': 'Staff',
  'auditLog.colAppointments': 'Appointments',
  'auditLog.colTransactions': 'Transactions',
  'auditLog.colOrders': 'Orders',
  'auditLog.colProducts': 'Products',
  'auditLog.colStock': 'Stock',
  'auditLog.colStockMovements': 'Stock movements',
  'auditLog.colServices': 'Services',
  'auditLog.colCategories': 'Categories',
  'auditLog.colLocations': 'Locations',
  'auditLog.colRoles': 'Roles',
  'auditLog.colUsers': 'Users',
  'auditLog.colSalaryHistory': 'Salary history',
  'auditLog.colSalarySchemes': 'Salary schemes',
  'auditLog.colFixedExpenses': 'Fixed expenses',
  'auditLog.colWarehouses': 'Warehouses',
  'auditLog.colScheduleTemplates': 'Schedule templates',
  'auditLog.colCashShifts': 'Cash shifts',
  'auditLog.colProductions': 'Production',
  'auditLog.colTechCards': 'Tech cards',
  'auditLog.colCustomerComments': 'Customer comments',

  // ── Loyalty (4 modules) ──
  'nav.loyalty': 'Loyalty Programs',
  'loyalty.title': 'Loyalty Programs',
  'loyalty.subtitle': 'Points, tiers, promo codes & subscriptions',
  'custModal.tabLoyalty': 'Loyalty',

  // Tabs
  'loyalty.tabPoints': 'Points',
  'loyalty.tabTiers': 'Tiers',
  'loyalty.tabCoupons': 'Promo Codes',
  'loyalty.tabSubscriptions': 'Subscriptions',
  'loyalty.tabSettings': 'Settings',
  'loyalty.tabBalances': 'Balances',
  'loyalty.tabHistory': 'History',
  'loyalty.tabTierOverview': 'Customer Overview',
  'loyalty.tabPlans': 'Plans',
  'loyalty.tabPlansSettings': 'Plan settings',
  'loyalty.tabActiveSubs': 'Active Subscriptions',

  // Common
  'loyalty.statMembers': 'members',
  'loyalty.statPoints': 'active points',
  'loyalty.saveSettings': 'Save settings',
  'loyalty.saved': 'Settings saved',
  'loyalty.searchCustomer': 'Search customer...',
  'loyalty.days': 'days',
  'loyalty.pts': 'pts',
  'loyalty.cancel': 'Cancel',
  'loyalty.colCustomer': 'Customer',
  'loyalty.colTier': 'Tier',
  'loyalty.colBalance': 'Balance',
  'loyalty.colTotalEarned': 'Earned',
  'loyalty.colTotalRedeemed': 'Redeemed',
  'loyalty.colTotalSpent': 'Total Spent',
  'loyalty.colDate': 'Date',
  'loyalty.colType': 'Type',
  'loyalty.colPoints': 'Points',
  'loyalty.colNote': 'Note',
  'loyalty.colStatus': 'Status',

  // Points module
  'loyalty.enablePoints': 'Enable points program',
  'loyalty.pointsDisabled': 'Points program is disabled',
  'loyalty.sectionEarning': 'Earning & Redemption',
  'loyalty.cashbackPercent': 'Points cashback',
  'loyalty.cashbackPercentHint': 'Percentage of purchase amount returned as points. 1 point = 1 ₴',
  'loyalty.maxRedeemPercent': 'Max % payable with points',
  'loyalty.maxRedeemPercentHint': 'Maximum share of order amount that can be paid with points',
  'loyalty.sectionAutoBonuses': 'Auto Bonuses',
  'loyalty.birthdayBonus': 'Birthday bonus',
  'loyalty.referralBonus': 'Referral bonus',
  'loyalty.inactivityDays': 'Inactivity days',
  'loyalty.inactivityBonus': 'Return bonus',
  'loyalty.noBalances': 'No members yet',
  'loyalty.noBalancesHint': 'Points will be earned automatically on payments',
  'loyalty.noHistory': 'No history yet',
  'loyalty.txEarn': 'Earned',
  'loyalty.txRedeem': 'Redeemed',
  'loyalty.txBirthday': 'Birthday',
  'loyalty.txReferral': 'Referral',
  'loyalty.txInactivity': 'Return',
  'loyalty.txManual': 'Manual',
  'loyalty.sectionPoints': 'Points',
  'loyalty.pointsBalance': 'points',
  'loyalty.earned': 'earned',
  'loyalty.redeemed': 'redeemed',
  'loyalty.manualPlaceholder': '±points',
  'loyalty.manualApply': 'Apply',
  'loyalty.manualAdd': 'Manual credit',
  'loyalty.insufficientPoints': 'Not enough points: the balance is {n}',
  'loyalty.planHasSubscriptions': 'Subscriptions have already been sold on this plan — it cannot be deleted.',
  'loyalty.planDeleteError': 'Could not delete the plan',
  'loyalty.redeemFailed': 'Could not redeem points',
  'loyalty.manualDeduct': 'Manual debit',
  'loyalty.history': 'Points History',
  'loyalty.noTransactions': 'No point transactions yet',

  // Tiers module
  'loyalty.enableTiers': 'Enable tiers program',
  'loyalty.tiersDisabled': 'Tiers program is disabled',
  'loyalty.tierPeriod': 'Accounting period',
  'loyalty.periodAllTime': 'All time',
  'loyalty.periodMonths': 'Last {n} months',
  'loyalty.tierPeriodHint': 'Period for calculating spending to determine tier',
  'loyalty.sectionTiers': 'Customer Tiers',
  'loyalty.tiersHint': 'Discount is determined automatically by total customer spending',
  'loyalty.tierName': 'Name',
  'loyalty.tierMinSpent': 'Min spent',
  'loyalty.tierDiscount': 'Discount',
  'loyalty.tierLoadingBtn': 'Calculating discount',
  'loyalty.tierLoadingHint': 'Calculating tier discount…',
  'loyalty.addTier': 'Add tier',
  'loyalty.noTierCustomers': 'No customers with spending yet',
  'loyalty.sectionTierStatus': 'Customer Tier',
  'loyalty.tierDiscountLabel': 'Tier discount',
  'loyalty.nextTier': 'Next tier',

  // Coupons module
  'loyalty.enableCoupons': 'Enable promo codes',
  'loyalty.couponsDisabled': 'Promo codes are disabled',
  'loyalty.searchCoupon': 'Search promo code...',
  'loyalty.addCoupon': 'Create promo code',
  'loyalty.newCoupon': 'New promo code',
  'loyalty.editCoupon': 'Edit promo code',
  'loyalty.saveCoupon': 'Save promo code',
  'loyalty.couponCode': 'Code',
  'loyalty.couponType': 'Discount type',
  'loyalty.couponPercent': 'Percentage',
  'loyalty.couponFixed': 'Fixed amount',
  'loyalty.couponValue': 'Discount value',
  'loyalty.couponMinOrder': 'Min order amount',
  'loyalty.couponMaxUses': 'Max uses',
  'loyalty.couponMaxUsesHint': '0 = unlimited',
  'loyalty.couponExpiry': 'Valid until',
  'loyalty.couponUsed': 'Used',
  'loyalty.generateCode': 'Generate',
  'loyalty.noCoupons': 'No promo codes yet',
  'loyalty.statusActive': 'Active',
  'loyalty.statusInactive': 'Inactive',
  'loyalty.statusExpired': 'Expired',
  'loyalty.statusMaxed': 'Exhausted',

  // Subscriptions module
  'loyalty.enableSubscriptions': 'Enable subscriptions',
  'loyalty.subscriptionsDisabled': 'Subscriptions are disabled',
  'loyalty.disableConfirmTitle': 'Disable program?',
  'loyalty.disableConfirmMessage': 'Are you sure you want to disable this loyalty program? It will stop working for clients.',
  'loyalty.disableConfirm': 'Disable',
  'loyalty.addPlan': 'Create plan',
  'loyalty.newPlan': 'New plan',
  'loyalty.editPlan': 'Edit plan',
  'loyalty.savePlan': 'Save plan',
  'loyalty.planName': 'Plan name',
  'loyalty.planType': 'Type',
  'loyalty.planTypeVisits': 'By visits',
  'loyalty.planTypeTime': 'By time',
  'loyalty.planTotalVisits': 'Total visits',
  'loyalty.planValidDays': 'Validity period',
  'loyalty.planPrice': 'Price',
  'loyalty.planServices': 'Services',
  'loyalty.planServicesHint': 'Select services or leave empty for all',
  'loyalty.allServices': 'All services',
  'loyalty.noPlans': 'No plans yet',
  'loyalty.visits': 'visits',
  'loyalty.noActiveSubs': 'No active subscriptions yet',
  'loyalty.subVisits': 'Visits',
  'loyalty.subExpires': 'Expires',
  'loyalty.consumedVisitsTitle': 'Consumed visits',
  'loyalty.noConsumedVisits': 'No visits used yet',
  'loyalty.subStatus_active': 'Active',
  'loyalty.subStatus_expired': 'Expired',
  'loyalty.subStatus_used_up': 'Used up',
  'loyalty.sectionSubscriptions': 'Subscriptions',
  'loyalty.sellSubscription': 'Sell subscription',
  'loyalty.sellSubTitle': 'Sell subscription',
  'loyalty.selectCustomer': 'Select customer',
  'loyalty.selectPlan': 'Select plan',
  'loyalty.confirmSell': 'Confirm',
  'loyalty.toPayment': 'Proceed to payment',
  'loyalty.paymentTitle': 'Subscription payment',
  'loyalty.subSold': 'Subscription sold successfully',
  'loyalty.refund': 'Refund',
  'loyalty.refundConfirm': 'Refund subscription "{name}"? It will be deactivated.',
  'loyalty.subRefunded': 'Refunded, subscription deactivated',
  'loyalty.terminalError': 'Terminal payment error',
  'loyalty.fiscalError': 'Failed to create fiscal receipt. Payment cancelled',
  'loyalty.fiscalReturnError': 'Failed to create fiscal return receipt',
  'loyalty.subStatus_refunded': 'Refunded',
  'loyalty.subPurchased': 'Purchased',
  'loyalty.subPrice': 'Price',
  'loyalty.noActiveModules': 'No active loyalty programs',

  // ── Loyalty integration (checkout) ──
  'loyalty.usePoints': 'Use points',
  'loyalty.balance': 'Balance',
  'loyalty.max': 'Max.',
  'loyalty.apply': 'Apply',
  'loyalty.enterCoupon': 'Enter promo code',
  'loyalty.couponNotFound': 'Promo code not found',
  'loyalty.couponInvalid': 'Promo code is invalid',
  'loyalty.couponErr_not_found': 'Promo code not found',
  'loyalty.couponErr_inactive': 'Promo code is inactive',
  'loyalty.couponErr_expired': 'Promo code has expired',
  'loyalty.couponErr_maxed': 'Promo code usage limit reached',
  'loyalty.couponErr_min_order': 'Order amount below promo code minimum',
  'loyalty.payBySubscription': 'Pay with subscription',
  'loyalty.subscription': 'Subscription',
  'loyalty.pointsRedeemed': 'Points redeemed at payment',
  'presence.editing': 'This record is currently being edited by',

  // ── Rozetka integration ──
  'rozetka.title': 'Rozetka Marketplace',
  'rozetka.subtitle': 'Rozetka marketplace integration for order synchronization',
  'rozetka.login': 'Login (seller email)',
  'rozetka.loginRequired': 'Enter login',
  'rozetka.password': 'Password',
  'rozetka.save': 'Save',
  'rozetka.saved': 'Settings saved',
  'rozetka.error': 'Error: ',
  'rozetka.testConnection': 'Test connection',
  'rozetka.testSuccess': 'Connection successful',
  'rozetka.testError': 'Connection failed',
  'rozetka.ordersCount': 'Orders',
  'rozetka.help': 'A Rozetka seller account is required. Use the same login and password as for seller.rozetka.com.ua',

  // ── Prom.ua integration ──
  'prom.title': 'Prom.ua',
  'prom.subtitle': 'Prom.ua marketplace integration for order synchronization',
  'prom.apiToken': 'API token',
  'prom.tokenRequired': 'Enter API token',
  'prom.save': 'Save',
  'prom.saved': 'Settings saved',
  'prom.error': 'Error: ',
  'prom.testConnection': 'Test connection',
  'prom.testSuccess': 'Connection successful',
  'prom.testError': 'Connection failed',
  'prom.help': 'To get an API token: Seller Cabinet → Settings → API Token Management. Create a token with orders and products permissions.',

  // ── POS (quick sale) ──
  'pos.title': 'Shop',
  'pos.selectWarehouse': 'Select warehouse',
  'pos.noWarehouseHint': 'Select a warehouse to start selling',
  'pos.tariffPlan': 'Tariff plan',
  'pos.standardPrice': 'Standard price',
  'pos.search': 'Search product...',
  'pos.allCategories': 'All',
  'pos.outOfStock': 'Out of stock',
  'pos.noProducts': 'No products found',
  'pos.cart': 'Cart',
  'pos.emptyCart': 'Cart is empty',
  'pos.subtotal': 'Subtotal',
  'pos.discount': 'Discount',
  'pos.loyaltyPoints': 'Loyalty points',
  'pos.available': 'available',
  'pos.total': 'Total',
  'pos.coupon': 'Coupon',
  'pos.couponPlaceholder': 'Enter coupon code...',
  'pos.applyCoupon': 'Apply',
  'pos.invalidCoupon': 'Coupon is invalid or not found',
  'pos.cash': 'Cash',
  'pos.card': 'Card',
  'pos.transfer': 'Transfer',
  'pos.cashGiven': 'Cash given',
  'pos.change': 'Change',
  'pos.confirm': 'Confirm',
  'pos.saleComplete': 'Sale complete!',
  'pos.fiscalError': 'Failed to create fiscal receipt. Payment cancelled',
  'pos.terminalError': 'Terminal payment error',
  'pos.fiscalReturnError': 'Failed to create fiscal return receipt',
  'pos.refundNotRecorded': 'The refund went through, but its record was not saved. Do not repeat it — tell your administrator.',
  'orders.returnAfterCancel': 'The order is cancelled — the goods are already back in stock',
  'pos.returnTitle': 'Product return',
  'pos.returnHint': 'Specify quantities to return',
  'pos.returnAmount': 'Return amount',
  'pos.confirmReturn': 'Confirm return',
  'pos.tabSale': 'Sale',
  'pos.tabHistory': 'History',
  'pos.historyEmpty': 'No sales yet',
  'pos.historyDate': 'Date',
  'pos.historyItems': 'Items',
  'pos.historyTotal': 'Total',
  'pos.historyMethod': 'Method',
  'pos.historyAuthor': 'Author',
  'pos.historyCancel': 'Cancel',
  'pos.historyCancelConfirm': 'Cancel this sale? Items will be returned to stock.',
  'pos.historyCancelled': 'Sale cancelled',
  'pos.historyCustomer': 'Customer',
  'pos.historyReturn': 'Return',
  'pos.historyReturned': 'Return',
  'pos.partialReturn': 'Partial return',
  'pos.warehouse': 'Warehouse',
  'pos.customer': 'Customer',
  'pos.selectCustomer': 'Search customer...',

  // ── Business Monitor ──
  'bizMonitor.title': 'Business Monitor',
  'bizMonitor.subtitle': 'Strategic overview for the owner',
  'bizMonitor.revenue': 'Revenue',
  'bizMonitor.profit': 'Profit',
  'bizMonitor.profitability': 'Profitability',
  'bizMonitor.activeClients': 'Active Clients',
  'bizMonitor.retention': 'Retention',
  'bizMonitor.services': 'Services',
  'bizMonitor.goods': 'Products',
  'bizMonitor.new': 'New',
  'bizMonitor.returning': 'Returning',
  'bizMonitor.prevMonth': 'Prev month',
  'bizMonitor.revenueTrend': 'Revenue Trend',
  'bizMonitor.clientHealth': 'Client Health',
  'bizMonitor.viewDetails': 'View details',
  'bizMonitor.newClients': 'New',
  'bizMonitor.returningClients': 'Returning',
  'bizMonitor.sleeping': 'Sleeping (30d+)',
  'bizMonitor.avgCheckServices': 'Avg check services',
  'bizMonitor.avgCheckProducts': 'Avg check products',
  'bizMonitor.channels': 'Sales channels',
  'bizMonitor.channelAppts': 'Appointments',
  'bizMonitor.channelOrders': 'Orders',
  'bizMonitor.channelPos': 'POS',
  'bizMonitor.topStaff': 'Top Staff',
  'bizMonitor.topServices': 'Top Services',
  'bizMonitor.topProducts': 'Top Products',
  'bizMonitor.appointments': 'appointments',
  'bizMonitor.times': 'times',
  'bizMonitor.pcs': 'pcs',
  'bizMonitor.margin': 'Margin',
  'bizMonitor.stockAnalytics': 'Inventory',
  'bizMonitor.stockValue': 'Stock value',
  'bizMonitor.positions': 'items',
  'bizMonitor.lowStockCount': 'Low stock',
  'bizMonitor.noMovementCount': 'No movement 30d+',
  'bizMonitor.alerts': 'Needs attention',
  'bizMonitor.alertFinance': 'Finances',
  'bizMonitor.alertClients': 'Clients',
  'bizMonitor.alertStock': 'Products/Inventory',
  'bizMonitor.alertStaff': 'Staff',
  'bizMonitor.alertRevenueDrop': 'Revenue dropped by {pct}% compared to last month',
  'bizMonitor.alertLowProfit': 'Profitability {pct}% — below 15% threshold',
  'bizMonitor.alertNoSalary': 'Salaries for {month} not calculated',
  'bizMonitor.alertSleeping': '{count} clients haven\'t returned in 30+ days',
  'bizMonitor.alertRetentionDrop': 'Retention dropped from {from}% to {to}%',
  'bizMonitor.alertNoShow': 'No-show rate {pct}% — above norm (10%)',
  'bizMonitor.alertLowStock': '{count} products below minimum stock level',
  'bizMonitor.alertNoMovement': '{count} products with no movement for 30+ days ({value}₴)',
  'bizMonitor.alertMarginDrop': 'Product margin dropped from {from}% to {to}%',
  'bizMonitor.alertStaffDrop': '{name} — revenue dropped by {pct}%',
  'bizMonitor.noData': 'No data',
  'sidebar.businessMonitor': 'Business Monitor',

  // ── Communication: added 2026-09-25 (module review) ──────────
  'custModal.messageSent': 'Sent',
  'instagram.resubscribed': 'Webhook subscription refreshed. Click “Test connection” to see the new state.',
  'instagram.resubscribeFailed': 'Could not refresh the subscription:',
  'instagram.errorPrefix': 'Error:',
  'sms.testText': 'Systemic CRM: test message.',
  'sms.testSent': 'Sent — check the phone',
  'sms.testNotSent': 'Not sent',
  'sms.senderRule1': 'At most 11 Latin characters, no spaces — that is the GSM standard limit. The name must be',
  'sms.senderRuleStrong': 'registered in the provider’s account',
  'sms.senderRule2': 'and match character for character, including case.',
  'sms.lastFailed': 'Last send failed',
  'sms.lastOk': 'Last successful send',
  'sms.testLabel': 'Test with a real SMS',
  'telegram.statusChecking': 'Checking bot status…',
  'telegram.statusRecheck': 'Check',
  'telegram.statusLastError': 'Last error:',
  'telegram.statusBot': 'Bot',
  'telegram.statusWebhook': 'Webhook',
  'telegram.statusWebhookNone': 'not set',
  'telegram.statusWebhookExpected': 'expected',
  'telegram.statusQueue': 'Queued',
  'telegram.statusSubscribers': 'Subscribers',
  'telegram.statusSubscribersSub': 'clients who pressed “Start”',
  'telegram.verdictOk': 'Bot is connected and working',
  'telegram.verdictNoToken': 'Bot is not set up',
  'telegram.verdictNoTokenHint': 'Paste the token from @BotFather and click “Save and connect”.',
  'telegram.verdictBadToken': 'Token is invalid',
  'telegram.verdictBadTokenHint': 'The bot was deleted or the token was reissued in @BotFather. Paste the new one.',
  'telegram.verdictNoWebhook': 'Webhook is not set',
  'telegram.verdictNoWebhookHint': 'Telegram does not know where to send updates. Click “Save and connect”.',
  'telegram.verdictHostMismatch': 'Webhook points to another address',
  'telegram.verdictHostMismatchHint': 'This usually happens when the bot was connected from a test link. Click “Save and connect” at this address.',
  'telegram.verdictWebhookError': 'Telegram cannot reach us',
  'telegram.verdictPending': 'Updates are stuck in the queue',
  'telegram.verdictPendingHint': 'Telegram has accumulated updates it could not deliver.',
  'telegram.verdictNoSubscribers': 'Bot works, but has no subscribers',
  'telegram.verdictNoSubscribersHint': 'No client has pressed “Start” in the bot yet. The personal link is in the client card.',
  'telegram.verdictUnreachable': 'Could not check the status',
  'telegram.statusForward': 'Forwarding',
  'telegram.statusForwardOk': 'working',
  'telegram.statusForwardError': 'error',
  'telegram.statusForwardPending': 'no updates yet',
  'telegram.fwdTitle': 'External bot: menus and flows',
  'telegram.fwdIntro': 'If this bot has a separate server for menus (buttons, flows), Systemic stays the webhook owner and forwards a copy of every update to it. Conversations and operator replies stay here, as before.',
  'telegram.fwdUrl': 'Forwarding address (https)',
  'telegram.fwdUrlHint': 'Leave empty to disable forwarding.',
  'telegram.fwdSecret': 'Forwarding secret',
  'telegram.fwdSecretHint': 'Any string you choose. Systemic sends it in the X-Systemic-Secret header and a body signature in X-Systemic-Signature, so the external server can verify the request came from us.',
  'telegram.fwdSecretStored': 'The secret is stored on the server and never sent back to the browser. Enter a new one to replace it.',
  'telegram.fwdSave': 'Save forwarding',
  'telegram.fwdSaved': 'Forwarding saved',
  'telegram.fwdInvalidUrl': 'The address must start with https://',
  'telegram.fwdHowTitle': 'How it works and what to keep in mind',
  'telegram.fwdHow1': 'The bot’s webhook stays with Systemic. The external server must not re-point it: the status card would show “Webhook points to another address”, and “Save and connect” would take the webhook back.',
  'telegram.fwdHow2': 'Systemic processes each update itself (conversations, client linking, phone number) and in parallel forwards a copy to the address above — including button presses, which Systemic itself ignores.',
  'telegram.fwdHow3': 'The external server shows menus through the bot token. That is interface, not conversation: it does not land in Communications. Operators reply to clients from Systemic.',
  'telegram.fwdHow4': 'Build menus with inline buttons (under the message). A bottom keyboard sends presses as plain text, and the operator’s thread fills with “Services”, “Back”.',
  'telegram.fwdHow5': 'Systemic already answers /start: it greets and asks for the phone number to find the client. Show the menu after that or on a separate command, otherwise the client gets two messages in a row.',
  'telegram.fwdHow6': 'The server must answer 200 within 4 seconds. There are no retries; the last forwarding state is shown in the status card above.',
  'messengerSet.tagline': 'Messages from your Facebook Page — in the CRM',
  'messengerSet.tabOpened': 'Facebook opened in a new tab. Sign in and come back here.',
  'messengerSet.connectFailed': 'Connection error:',
  'messengerSet.confirmDisconnect': 'Disconnect the Messenger integration?',
  'messengerSet.disconnected': 'Messenger disconnected',
  'messengerSet.pageActivated': 'Page “{name}” activated',
  'messengerSet.subscribeFailed': 'Page activated, but the webhook subscription failed: {error}. Click “Refresh webhook subscription”.',
  'messengerSet.activateFailed': 'Could not activate the page',
  'messengerSet.errorPrefix': 'Error:',
  'messengerSet.pagesRefreshed': 'Page list refreshed',
  'messengerSet.resubscribed': 'Webhook subscription refreshed. Click “Test connection”.',
  'messengerSet.resubscribeFailed': 'Could not refresh the subscription:',
  'messengerSet.needsReconnect': 'Re-authorization required',
  'messengerSet.reconnectHint': 'Facebook revoked the token. Click “Connect” to continue.',
  'messengerSet.howTitle': 'How it works',
  'messengerSet.how1': 'Click “Connect Messenger” — Facebook opens the authorization in a new tab.',
  'messengerSet.how2': 'Allow the app to manage messages of your Pages.',
  'messengerSet.how3': 'Come back here — you will see your Facebook Pages. Pick one for the CRM.',
  'messengerSet.how4': 'Done. Messages from that Page land in Communications automatically.',
  'messengerSet.givesTitle': 'What you get',
  'messengerSet.capInboxTitle': 'Facebook Page messages — in the CRM',
  'messengerSet.capInboxText': 'Every message to your Page lands in Communications in real time — next to Telegram, SMS and email.',
  'messengerSet.capReplyTitle': 'Reply from the CRM straight into Messenger',
  'messengerSet.capReplyText': 'Open the thread in Communications, pick the “Messenger” channel — the reply goes to the client. Meta allows replies within 24 hours of their message.',
  'messengerSet.limitsLabel': 'Limitations:',
  'messengerSet.limitsText': 'Works only with Facebook business Pages, not with personal profiles.',
  'messengerSet.statusOff': 'Not connected',
  'messengerSet.statusPending': 'Waiting for page selection',
  'messengerSet.statusOn': 'Connected',
  'messengerSet.connectIntro': 'Connect your Facebook account and pick the Page whose messages should arrive in the CRM.',
  'messengerSet.connectBtn': 'Connect Messenger',
  'messengerSet.noPages': 'No Facebook Pages found on this account. Create a Page at facebook.com → Pages, then refresh the list.',
  'messengerSet.refreshPages': 'Refresh page list',
  'messengerSet.disconnectBtn': 'Disconnect',
  'messengerSet.pickIntro': 'Pick the Facebook Page the CRM will receive messages from:',
  'messengerSet.pageActive': 'Active',
  'messengerSet.pageUse': 'Use',
  'messengerSet.refreshList': 'Refresh list',
  'messengerSet.fbAccount': 'Facebook account:',
  'messengerSet.activePage': 'Active page:',
  'messengerSet.connectedAt': 'Connected:',
  'messengerSet.userTokenUntil': 'User token valid until:',
  'messengerSet.unknown': '(unknown)',
  'messengerSet.testBtn': 'Test connection',
  'messengerSet.resubscribeBtn': 'Refresh webhook subscription',
  'messengerSet.switchPage': 'Switch page',
  'messengerSet.patOk': '✓ Page token is valid:',
  'messengerSet.patFailed': '✗ Page token failed the check:',
  'messengerSet.subsTitle': 'Webhook subscriptions:',
  'messengerSet.noApps': 'No app is subscribed to this Page. Click “Refresh webhook subscription”.',
  'messengerSet.subscribedFields': 'Subscribed fields:',
  'messengerSet.noMessagesField': '⚠ The “messages” field is missing — Meta will not deliver messages. Click “Refresh webhook subscription”.',
  'messengerSet.subsFailed': '✗ Subscription check failed:',

  // ── Keys that existed only in uk (fell back to Ukrainian in the English UI) ──
  'nav.messenger': 'Messenger',
  'booking.cardStyle': 'Card style',
  'booking.cardStyleDefault': 'Default',
  'booking.cardStyleFlat': 'Flat',
  'booking.cardStyleShadow': 'With shadow',
  'booking.cardStyleMinimal': 'Minimal',
  'booking.cardStyleBorderless': 'Borderless',
  'booking.footerText': 'Footer text',
  'booking.footerTextHint': 'For example: © 2026 Your business name',
  'booking.servicesBannerImage': 'Banner for the “Services” section',
  'booking.shopBannerImage': 'Banner for the “Products” section',
  'booking.shopBannerHint': 'Image for the top of the product shop',
  'myPlan.renewPlan': 'Renew',
  'reports.returns': 'Returns',
  'reports.returnToSupplier': 'Return',
  'reports.invoice': 'Invoice',
  'meest.branchSearchPlaceholder': 'City, branch name or number',
  'locations.saveFailed': 'Failed to save the location. Please try again.',
  'locations.deleteFailed': 'Failed to delete the location. Please try again.',
  'roles.groupTasks': 'Tasks',
  'roles.fullAccess': 'Full access',
  'roles.adminFullAccessNote': 'The administrator always has full access — it is the account owner, not a set of permissions. To restrict someone, create a separate role: the toggles work there.',
  'roles.permTasksView': 'Own tasks',
  'roles.permTasksViewAll': 'All company tasks',
  'roles.permTasksCreate': 'Create tasks',
  'roles.permTasksAssign': 'Assign performers',
  'roles.permTasksEditAll': 'Edit other people’s tasks',
  'roles.permTasksManage': 'Templates and automations',
  'roles.permTasksReports': 'Task reports',
  'roles.permProjectsManage': 'Manage projects',
  'nav.projects': 'Projects',
  'orders.shippingMeest': 'Meest Express',
  'orders.shipping_meest': 'Meest Express',
  'orders.meestCity': 'City (Meest)',
  'orders.meestCityPlaceholder': 'Enter city name',
  'orders.meestBranch': 'Branch (Meest)',
  'orders.meestBranchPlaceholder': 'Search branch',
  'orders.meestBranchSearchPlaceholder': 'City, branch name or number',
  'orders.meestTracking': 'Meest shipment number',
  'orders.meestTrackingPlaceholder': 'Filled in automatically',
  'orders.meestDeliveryTo': 'Meest delivery',
  'orders.meestCreateParcel': 'Create Meest shipment',
  'orders.meestParcelCreated': 'Meest shipment created',
  'orders.meestParcelError': 'Failed to create the Meest shipment',
  'orders.meestSettingsRequired': 'Set up Meest Express in Integrations',
  'orders.meestAddressRequired': 'Pick the Meest city and branch',
};

export default en;
